{
  "_meta": {
    "baseline_year": 2026,
    "country_count": 191,
    "derived_rate_precision": "full",
    "extracted_date": "2026-10-16",
    "extracted_from": "https://data.imf.org/-/media/iData/External-Storage/Documents/0FA3DC49A04D446E9D69DBEB29979E1C/en/WEOOct2026all.xlsx",
    "generated_by": "scripts/extract-weo.py",
    "historical_window": [
      2022,
      2023,
      2024,
      2025
    ],
    "horizon_years": 6,
    "indicators": {
      "fcuShare": "Placeholder 0; runtime adapter supplies DSA observation or tagged missing-coverage fallback.",
      "realFxAppreciation": "Explicit 0 assumption; not supplied by WEO.",
      "realInterestRate": "Algebraic reconciliation residual at full precision; inclusive [-20,+50] guard before serialization; scalar is the first-year value."
    },
    "indicators_used": {
      "debt_to_gdp": "GGXWDG_NGDP",
      "primary_balance": "GGXONLB_NGDP",
      "real_gdp_growth": "NGDP_RPCH"
    },
    "notes": [
      "The 2022–2025 and 2026–2031 chart sections are modeling windows; latest actual metadata varies by country and indicator.",
      "Derived real rate reconciles the debt identity and may absorb stock-flow, valuation and inflation effects; it is not observed borrowing cost.",
      "Missing source cells stay null. Any missing or guarded yearly input excludes a country from selection."
    ],
    "projection_years": [
      2026,
      2027,
      2028,
      2029,
      2030,
      2031
    ],
    "retrieved_at": "2026-10-16T16:38:04.520500+00:00",
    "selectable_country_count": 169,
    "source_country_count": 197,
    "source_publication_date": "2026-10-13T02:00:00Z",
    "source_sha256": "2aa4f70a05931197b41ed7e0202dc56eee8d816858ac14521e4f8f5dbc38696c",
    "source_update_date": "2026-10-13T02:00:00Z",
    "source_vintage": "IMF WEO October 2026"
  },
  "countries": [
    {
      "baselineProjection": [
        {
          "debtPct": 59.618,
          "year": 2026
        },
        {
          "debtPct": 56.081,
          "year": 2027
        },
        {
          "debtPct": 53.305,
          "year": 2028
        },
        {
          "debtPct": 50.915,
          "year": 2029
        },
        {
          "debtPct": 48.733,
          "year": 2030
        },
        {
          "debtPct": 46.704,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 5.787,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.662,
        "realInterestRate": 4.686375511464536
      },
      "historical": [
        {
          "debtPct": 95.984,
          "year": 2022
        },
        {
          "debtPct": 82.95,
          "year": 2023
        },
        {
          "debtPct": 72.513,
          "year": 2024
        },
        {
          "debtPct": 64.765,
          "year": 2025
        }
      ],
      "iso": "abw",
      "name": "Aruba, Kingdom of the Netherlands",
      "startingDebtPct": 64.765,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          5.787,
          4.837,
          4.606,
          4.479,
          4.323,
          3.899
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.662,
          2.651,
          1.976,
          1.376,
          1.183,
          1.223
        ],
        "realInterestRate": [
          4.686375511464536,
          4.889355865678158,
          5.303616839927949,
          5.348881793452764,
          5.437793341844244,
          5.107164939568687
        ]
      }
    },
    {
      "baselineProjection": [],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": null,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 10.643,
          "year": 2022
        },
        {
          "debtPct": 8.255,
          "year": 2023
        },
        {
          "debtPct": 8.912,
          "year": 2024
        },
        {
          "debtPct": 7.629,
          "year": 2025
        }
      ],
      "iso": "afg",
      "name": "Afghanistan, Islamic Republic of",
      "startingDebtPct": 7.629,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 51.493,
          "year": 2026
        },
        {
          "debtPct": 53.348,
          "year": 2027
        },
        {
          "debtPct": 53.023,
          "year": 2028
        },
        {
          "debtPct": 53.539,
          "year": 2029
        },
        {
          "debtPct": 54.081,
          "year": 2030
        },
        {
          "debtPct": 55.12,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.97,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.442,
        "realInterestRate": -0.19249151676785647
      },
      "historical": [
        {
          "debtPct": 57.427,
          "year": 2022
        },
        {
          "debtPct": 75.739,
          "year": 2023
        },
        {
          "debtPct": 54.992,
          "year": 2024
        },
        {
          "debtPct": 52.869,
          "year": 2025
        }
      ],
      "iso": "ago",
      "name": "Angola",
      "startingDebtPct": 52.869,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.97,
          -0.71,
          -0.624,
          -0.445,
          -0.021,
          -0.048
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.442,
          3.27,
          3.225,
          3.23,
          3.271,
          3.259
        ],
        "realInterestRate": [
          -0.19249151676785647,
          5.566315033111291,
          1.3887451263402628,
          3.368229259000799,
          4.275953230355434,
          5.1511556369149725
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 49.736,
          "year": 2026
        },
        {
          "debtPct": 48.557,
          "year": 2027
        },
        {
          "debtPct": 47.818,
          "year": 2028
        },
        {
          "debtPct": 47.144,
          "year": 2029
        },
        {
          "debtPct": 46.458,
          "year": 2030
        },
        {
          "debtPct": 45.9,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.25,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.532,
        "realInterestRate": -3.730666666666671
      },
      "historical": [
        {
          "debtPct": 64.673,
          "year": 2022
        },
        {
          "debtPct": 57.952,
          "year": 2023
        },
        {
          "debtPct": 54.517,
          "year": 2024
        },
        {
          "debtPct": 53.757,
          "year": 2025
        }
      ],
      "iso": "alb",
      "name": "Albania",
      "startingDebtPct": 53.757,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.25,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.532,
          3.218,
          3.212,
          3.193,
          3.211,
          3.248
        ],
        "realInterestRate": [
          -3.730666666666671,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 27.832,
          "year": 2026
        },
        {
          "debtPct": 26.57,
          "year": 2027
        },
        {
          "debtPct": 25.887,
          "year": 2028
        },
        {
          "debtPct": 25.272,
          "year": 2029
        },
        {
          "debtPct": 24.692,
          "year": 2030
        },
        {
          "debtPct": 24.112,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 2.66,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.9,
        "realInterestRate": 2.6032691609153558
      },
      "historical": [
        {
          "debtPct": 38.916,
          "year": 2022
        },
        {
          "debtPct": 35.44,
          "year": 2023
        },
        {
          "debtPct": 32.89,
          "year": 2024
        },
        {
          "debtPct": 30.283,
          "year": 2025
        }
      ],
      "iso": "and",
      "name": "Andorra, Principality of",
      "startingDebtPct": 30.283,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          2.66,
          2.704,
          2.683,
          2.662,
          2.664,
          2.704
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.9,
          1.7,
          1.7,
          1.6,
          1.5,
          1.5
        ],
        "realInterestRate": [
          2.6032691609153558,
          6.969164989939625,
          9.355250282273243,
          9.633962993008073,
          9.869974675530235,
          10.231005993844144
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 32.756,
          "year": 2026
        },
        {
          "debtPct": 30.797,
          "year": 2027
        },
        {
          "debtPct": 29.018,
          "year": 2028
        },
        {
          "debtPct": 27.369,
          "year": 2029
        },
        {
          "debtPct": 26.952,
          "year": 2030
        },
        {
          "debtPct": 26.087,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 2.308,
        "realFxAppreciation": 0,
        "realGdpGrowth": -3.904,
        "realInterestRate": -0.495817145557087
      },
      "historical": [
        {
          "debtPct": 31.513,
          "year": 2022
        },
        {
          "debtPct": 31.909,
          "year": 2023
        },
        {
          "debtPct": 33.222,
          "year": 2024
        },
        {
          "debtPct": 33.863,
          "year": 2025
        }
      ],
      "iso": "are",
      "name": "United Arab Emirates",
      "startingDebtPct": 33.863,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          2.308,
          5.257,
          4.895,
          4.542,
          4.264,
          4.144
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -3.904,
          7.656,
          6.982,
          5.936,
          3.679,
          3.529
        ],
        "realInterestRate": [
          -0.495817145557087,
          18.495219929173288,
          17.80629821086468,
          16.497473843821076,
          18.25217085023201,
          16.12441373552982
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 69.349,
          "year": 2026
        },
        {
          "debtPct": 70.424,
          "year": 2027
        },
        {
          "debtPct": 65.633,
          "year": 2028
        },
        {
          "debtPct": 60.317,
          "year": 2029
        },
        {
          "debtPct": 56.675,
          "year": 2030
        },
        {
          "debtPct": 53.92,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.656,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.06,
        "realInterestRate": -9.487781025179853
      },
      "historical": [
        {
          "debtPct": 84.303,
          "year": 2022
        },
        {
          "debtPct": 153.375,
          "year": 2023
        },
        {
          "debtPct": 84.585,
          "year": 2024
        },
        {
          "debtPct": 80.064,
          "year": 2025
        }
      ],
      "iso": "arg",
      "name": "Argentina",
      "startingDebtPct": 80.064,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.656,
          2.097,
          2.184,
          2.818,
          3.472,
          3.413
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.06,
          3.462,
          4.162,
          3.849,
          3.329,
          3.01
        ],
        "realInterestRate": [
          -9.487781025179853,
          8.194317178329902,
          0.306065460638405,
          -0.10350562978990174,
          3.0377731485319304,
          4.205952007057778
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 48.057,
          "year": 2026
        },
        {
          "debtPct": 48.442,
          "year": 2027
        },
        {
          "debtPct": 48.639,
          "year": 2028
        },
        {
          "debtPct": 47.46,
          "year": 2029
        },
        {
          "debtPct": 46.102,
          "year": 2030
        },
        {
          "debtPct": 44.712,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.925,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.5,
        "realInterestRate": 5.924759815094904
      },
      "historical": [
        {
          "debtPct": 47.097,
          "year": 2022
        },
        {
          "debtPct": 48.493,
          "year": 2023
        },
        {
          "debtPct": 47.988,
          "year": 2024
        },
        {
          "debtPct": 46.943,
          "year": 2025
        }
      ],
      "iso": "arm",
      "name": "Armenia, Republic of",
      "startingDebtPct": 46.943,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.925,
          -0.182,
          0.256,
          1.19,
          1.145,
          1.094
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.5,
          5.45,
          5.26,
          4.955,
          4.95,
          4.955
        ],
        "realInterestRate": [
          5.924759815094904,
          5.8954366689556,
          6.244327236695435,
          4.97873619934619,
          4.478985461441232,
          4.281131621187817
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 66.768,
          "year": 2026
        },
        {
          "debtPct": 65.838,
          "year": 2027
        },
        {
          "debtPct": 64.682,
          "year": 2028
        },
        {
          "debtPct": 63.142,
          "year": 2029
        },
        {
          "debtPct": 61.425,
          "year": 2030
        },
        {
          "debtPct": 59.358,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.004,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.387,
        "realInterestRate": -1.17958694351874
      },
      "historical": [
        {
          "debtPct": 82.446,
          "year": 2022
        },
        {
          "debtPct": 74.534,
          "year": 2023
        },
        {
          "debtPct": 71.578,
          "year": 2024
        },
        {
          "debtPct": 70.218,
          "year": 2025
        }
      ],
      "iso": "atg",
      "name": "Antigua and Barbuda",
      "startingDebtPct": 70.218,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.004,
          0.706,
          0.868,
          1,
          1,
          1
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.387,
          2.464,
          2.497,
          2.503,
          2.508,
          2.514
        ],
        "realInterestRate": [
          -1.17958694351874,
          2.12024346992572,
          2.0486398432516095,
          1.647250023190372,
          1.3439849862215247,
          0.7332521286121274
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 52.626,
          "year": 2026
        },
        {
          "debtPct": 53.212,
          "year": 2027
        },
        {
          "debtPct": 53.688,
          "year": 2028
        },
        {
          "debtPct": 54.099,
          "year": 2029
        },
        {
          "debtPct": 54.27,
          "year": 2030
        },
        {
          "debtPct": 54.289,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.17,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.935,
        "realInterestRate": -0.9182923963089284
      },
      "historical": [
        {
          "debtPct": 50.043,
          "year": 2022
        },
        {
          "debtPct": 49.418,
          "year": 2023
        },
        {
          "debtPct": 50.943,
          "year": 2024
        },
        {
          "debtPct": 51.909,
          "year": 2025
        }
      ],
      "iso": "aus",
      "name": "Australia",
      "startingDebtPct": 51.909,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.17,
          -1.856,
          -1.62,
          -1.413,
          -1.224,
          -1.123
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.935,
          1.587,
          1.84,
          1.955,
          2.089,
          2.184
        ],
        "realInterestRate": [
          -0.9182923963089284,
          -0.8645541747425156,
          -0.34944899646696115,
          0.052174228877954754,
          0.10190750291134698,
          0.10529839690438525
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 82.351,
          "year": 2026
        },
        {
          "debtPct": 82.264,
          "year": 2027
        },
        {
          "debtPct": 82.435,
          "year": 2028
        },
        {
          "debtPct": 82.907,
          "year": 2029
        },
        {
          "debtPct": 83.513,
          "year": 2030
        },
        {
          "debtPct": 84.271,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.713,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.641,
        "realInterestRate": -1.5278165175938496
      },
      "historical": [
        {
          "debtPct": 78.139,
          "year": 2022
        },
        {
          "debtPct": 77.771,
          "year": 2023
        },
        {
          "debtPct": 79.956,
          "year": 2024
        },
        {
          "debtPct": 81.392,
          "year": 2025
        }
      ],
      "iso": "aut",
      "name": "Austria",
      "startingDebtPct": 81.392,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.713,
          -2.254,
          -1.936,
          -1.731,
          -1.723,
          -1.669
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.641,
          0.855,
          1.18,
          0.991,
          0.805,
          0.785
        ],
        "realInterestRate": [
          -1.5278165175938496,
          -2.0120150332115005,
          -0.9908487309150948,
          -0.5513990901922616,
          -0.55313845634265,
          -0.31441128926036344
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 16.513,
          "year": 2026
        },
        {
          "debtPct": 16.357,
          "year": 2027
        },
        {
          "debtPct": 16.476,
          "year": 2028
        },
        {
          "debtPct": 16.488,
          "year": 2029
        },
        {
          "debtPct": 16.6,
          "year": 2030
        },
        {
          "debtPct": 16.687,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 4.349,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.715,
        "realInterestRate": 5.408490884705186
      },
      "historical": [
        {
          "debtPct": 17.324,
          "year": 2022
        },
        {
          "debtPct": 21.807,
          "year": 2023
        },
        {
          "debtPct": 21.64,
          "year": 2024
        },
        {
          "debtPct": 20.131,
          "year": 2025
        }
      ],
      "iso": "aze",
      "name": "Azerbaijan, Republic of",
      "startingDebtPct": 20.131,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          4.349,
          3.689,
          2.782,
          2.563,
          2.132,
          2.287
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.715,
          2.25,
          2.454,
          2.456,
          2.486,
          2.515
        ],
        "realInterestRate": [
          5.408490884705186,
          24.12665778477563,
          20.62475588433086,
          18.46863656227238,
          16.43424017467252,
          17.175880120481924
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 40.425,
          "year": 2026
        },
        {
          "debtPct": 41.096,
          "year": 2027
        },
        {
          "debtPct": 39.087,
          "year": 2028
        },
        {
          "debtPct": 37.599,
          "year": 2029
        },
        {
          "debtPct": 37.853,
          "year": 2030
        },
        {
          "debtPct": 37.518,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.348,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.648,
        "realInterestRate": -6.051111788230812
      },
      "historical": [
        {
          "debtPct": 68.479,
          "year": 2022
        },
        {
          "debtPct": 60.382,
          "year": 2023
        },
        {
          "debtPct": 53.828,
          "year": 2024
        },
        {
          "debtPct": 42.008,
          "year": 2025
        }
      ],
      "iso": "bdi",
      "name": "Burundi",
      "startingDebtPct": 42.008,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.348,
          -1.91,
          -2.463,
          -1.961,
          -2.904,
          -1.852
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.648,
          4.687,
          3.858,
          4.577,
          3.986,
          4.47
        ],
        "realInterestRate": [
          -6.051111788230812,
          1.4784114285714356,
          -7.443658944909471,
          -4.650775807813345,
          -3.342995452006703,
          -1.5658727181465215
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 109.81,
          "year": 2026
        },
        {
          "debtPct": 111.632,
          "year": 2027
        },
        {
          "debtPct": 114.112,
          "year": 2028
        },
        {
          "debtPct": 116.447,
          "year": 2029
        },
        {
          "debtPct": 119.286,
          "year": 2030
        },
        {
          "debtPct": 122.113,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.219,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.65,
        "realInterestRate": -0.5314059356369971
      },
      "historical": [
        {
          "debtPct": 103.325,
          "year": 2022
        },
        {
          "debtPct": 102.544,
          "year": 2023
        },
        {
          "debtPct": 103.917,
          "year": 2024
        },
        {
          "debtPct": 107.857,
          "year": 2025
        }
      ],
      "iso": "bel",
      "name": "Belgium",
      "startingDebtPct": 107.857,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.219,
          -3.128,
          -3.044,
          -2.756,
          -2.825,
          -2.725
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.65,
          1.125,
          1.232,
          1.305,
          1.318,
          1.273
        ],
        "realInterestRate": [
          -0.5314059356369971,
          -0.07770694836535252,
          0.7205440733839774,
          0.9312496056506081,
          1.3301810952622173,
          1.3595973039585374
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 58.138,
          "year": 2026
        },
        {
          "debtPct": 56.451,
          "year": 2027
        },
        {
          "debtPct": 54.729,
          "year": 2028
        },
        {
          "debtPct": 53.131,
          "year": 2029
        },
        {
          "debtPct": 51.656,
          "year": 2030
        },
        {
          "debtPct": 50.311,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.818,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6.997,
        "realInterestRate": 1.616657785572162
      },
      "historical": [
        {
          "debtPct": 59.735,
          "year": 2022
        },
        {
          "debtPct": 61.324,
          "year": 2023
        },
        {
          "debtPct": 60.527,
          "year": 2024
        },
        {
          "debtPct": 59.302,
          "year": 2025
        }
      ],
      "iso": "ben",
      "name": "Benin",
      "startingDebtPct": 59.302,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.818,
          -1.676,
          -1.574,
          -1.55,
          -1.532,
          -1.524
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6.997,
          6.801,
          6.771,
          6.744,
          6.721,
          6.7
        ],
        "realInterestRate": [
          1.616657785572162,
          0.6230825793800854,
          0.5369702042479219,
          0.604108680955262,
          0.6810224539345988,
          0.7738287904599739
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 50.975,
          "year": 2026
        },
        {
          "debtPct": 50.937,
          "year": 2027
        },
        {
          "debtPct": 50.983,
          "year": 2028
        },
        {
          "debtPct": 50.4,
          "year": 2029
        },
        {
          "debtPct": 49.961,
          "year": 2030
        },
        {
          "debtPct": 49.709,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.655,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.443,
        "realInterestRate": -3.123283683141509
      },
      "historical": [
        {
          "debtPct": 59.165,
          "year": 2022
        },
        {
          "debtPct": 56.818,
          "year": 2023
        },
        {
          "debtPct": 57.247,
          "year": 2024
        },
        {
          "debtPct": 53.172,
          "year": 2025
        }
      ],
      "iso": "bfa",
      "name": "Burkina Faso",
      "startingDebtPct": 53.172,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.655,
          -1.304,
          -0.937,
          -0.877,
          -0.908,
          -1.015
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.443,
          4.803,
          4.789,
          4.813,
          4.837,
          4.861
        ],
        "realInterestRate": [
          -3.123283683141509,
          2.0438901226091044,
          2.9560102479533557,
          1.8114704705489926,
          2.0351063690476234,
          2.201748043473928
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 40.475,
          "year": 2026
        },
        {
          "debtPct": 40.429,
          "year": 2027
        },
        {
          "debtPct": 42.828,
          "year": 2028
        },
        {
          "debtPct": 45.467,
          "year": 2029
        },
        {
          "debtPct": 47.634,
          "year": 2030
        },
        {
          "debtPct": 49.424,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.488,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.564,
        "realInterestRate": -1.4770854328741811
      },
      "historical": [
        {
          "debtPct": 37.863,
          "year": 2022
        },
        {
          "debtPct": 39.726,
          "year": 2023
        },
        {
          "debtPct": 40.972,
          "year": 2024
        },
        {
          "debtPct": 42.033,
          "year": 2025
        }
      ],
      "iso": "bgd",
      "name": "Bangladesh",
      "startingDebtPct": 42.033,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.488,
          -2.493,
          -2.769,
          -2.768,
          -2.666,
          -2.514
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.564,
          3.174,
          2.213,
          2.817,
          2.949,
          2.973
        ],
        "realInterestRate": [
          -1.4770854328741811,
          -3.298113304508954,
          1.2775623191273677,
          2.507310240963845,
          1.8191354608837251,
          1.4078899525548971
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 32.944,
          "year": 2026
        },
        {
          "debtPct": 34.593,
          "year": 2027
        },
        {
          "debtPct": 36.204,
          "year": 2028
        },
        {
          "debtPct": 38.229,
          "year": 2029
        },
        {
          "debtPct": 39.787,
          "year": 2030
        },
        {
          "debtPct": 40.892,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -4.816,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.553,
        "realInterestRate": -3.3728340870264106
      },
      "historical": [
        {
          "debtPct": 22.485,
          "year": 2022
        },
        {
          "debtPct": 22.931,
          "year": 2023
        },
        {
          "debtPct": 23.84,
          "year": 2024
        },
        {
          "debtPct": 29.853,
          "year": 2025
        }
      ],
      "iso": "bgr",
      "name": "Bulgaria",
      "startingDebtPct": 29.853,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -4.816,
          -3.456,
          -2.912,
          -2.761,
          -2.38,
          -1.961
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.553,
          2.661,
          2.553,
          2.49,
          2.467,
          2.441
        ],
        "realInterestRate": [
          -3.3728340870264106,
          -2.970023160514801,
          -1.303891654380951,
          0.4064556402607167,
          0.26375445342539106,
          0.2370264407972611
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 162.845,
          "year": 2026
        },
        {
          "debtPct": 150.327,
          "year": 2027
        },
        {
          "debtPct": 151.971,
          "year": 2028
        },
        {
          "debtPct": 155.146,
          "year": 2029
        },
        {
          "debtPct": 158.66,
          "year": 2030
        },
        {
          "debtPct": 161.635,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.577,
        "realFxAppreciation": 0,
        "realGdpGrowth": -11.262,
        "realInterestRate": -2.032913381023682
      },
      "historical": [
        {
          "debtPct": 111.648,
          "year": 2022
        },
        {
          "debtPct": 123.02,
          "year": 2023
        },
        {
          "debtPct": 133.67,
          "year": 2024
        },
        {
          "debtPct": 144.264,
          "year": 2025
        }
      ],
      "iso": "bhr",
      "name": "Bahrain, Kingdom of",
      "startingDebtPct": 144.264,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.577,
          -1.482,
          -0.909,
          -0.802,
          -1.111,
          -1.416
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -11.262,
          13.941,
          5.153,
          2.9,
          2.949,
          3.12
        ],
        "realInterestRate": [
          -2.032913381023682,
          4.145341551782367,
          5.667128899000207,
          4.506765106500565,
          4.5435396400809624,
          4.133261565611979
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 70.201,
          "year": 2026
        },
        {
          "debtPct": 65.388,
          "year": 2027
        },
        {
          "debtPct": 62.897,
          "year": 2028
        },
        {
          "debtPct": 60.535,
          "year": 2029
        },
        {
          "debtPct": 58.251,
          "year": 2030
        },
        {
          "debtPct": 55.848,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.599,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.5,
        "realInterestRate": 5.44032784143178
      },
      "historical": [
        {
          "debtPct": 84.54,
          "year": 2022
        },
        {
          "debtPct": 77.951,
          "year": 2023
        },
        {
          "debtPct": 73.045,
          "year": 2024
        },
        {
          "debtPct": 71.742,
          "year": 2025
        }
      ],
      "iso": "bhs",
      "name": "Bahamas, The",
      "startingDebtPct": 71.742,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.599,
          3.896,
          4.331,
          4.318,
          4.252,
          4.277
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.5,
          1.9,
          1.8,
          1.55,
          1.5,
          1.5
        ],
        "realInterestRate": [
          5.44032784143178,
          0.5689320664947983,
          4.664623478314045,
          4.708048873555182,
          4.799776988519033,
          4.7653688348697765
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 31.441,
          "year": 2026
        },
        {
          "debtPct": 33.662,
          "year": 2027
        },
        {
          "debtPct": 36.168,
          "year": 2028
        },
        {
          "debtPct": 38.859,
          "year": 2029
        },
        {
          "debtPct": 40.951,
          "year": 2030
        },
        {
          "debtPct": 43.585,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.168,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.3,
        "realInterestRate": 0.5572402044292879
      },
      "historical": [
        {
          "debtPct": 31.298,
          "year": 2022
        },
        {
          "debtPct": 29.078,
          "year": 2023
        },
        {
          "debtPct": 28.889,
          "year": 2024
        },
        {
          "debtPct": 28.763,
          "year": 2025
        }
      ],
      "iso": "bih",
      "name": "Bosnia and Herzegovina",
      "startingDebtPct": 28.763,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.168,
          -3.233,
          -3.244,
          -3.186,
          -3.045,
          -2.898
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.3,
          2.6,
          3,
          3,
          3,
          3
        ],
        "realInterestRate": [
          0.5572402044292879,
          -0.7024140453547822,
          0.7418454043134792,
          1.5903284671533013,
          0.47396999408115814,
          2.3359869111865272
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 31.124,
          "year": 2026
        },
        {
          "debtPct": 30.192,
          "year": 2027
        },
        {
          "debtPct": 29.447,
          "year": 2028
        },
        {
          "debtPct": 28.429,
          "year": 2029
        },
        {
          "debtPct": 27.654,
          "year": 2030
        },
        {
          "debtPct": 26.945,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.567,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.9,
        "realInterestRate": 6.571530488194988
      },
      "historical": [
        {
          "debtPct": 40.844,
          "year": 2022
        },
        {
          "debtPct": 40.724,
          "year": 2023
        },
        {
          "debtPct": 38.699,
          "year": 2024
        },
        {
          "debtPct": 31.258,
          "year": 2025
        }
      ],
      "iso": "blr",
      "name": "Belarus, Republic of",
      "startingDebtPct": 31.258,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.567,
          2.247,
          2.102,
          1.92,
          1.826,
          1.72
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.9,
          1.209,
          1.082,
          0.872,
          0.774,
          0.755
        ],
        "realInterestRate": [
          6.571530488194988,
          5.4851160197918025,
          5.625199324324326,
          3.9618408666417526,
          4.4995434239684995,
          4.438492623128654
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 64.633,
          "year": 2026
        },
        {
          "debtPct": 65.78,
          "year": 2027
        },
        {
          "debtPct": 66.485,
          "year": 2028
        },
        {
          "debtPct": 66.277,
          "year": 2029
        },
        {
          "debtPct": 65.816,
          "year": 2030
        },
        {
          "debtPct": 65.35,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.356,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.909,
        "realInterestRate": -2.124663165287033
      },
      "historical": [
        {
          "debtPct": 66.199,
          "year": 2022
        },
        {
          "debtPct": 66.62,
          "year": 2023
        },
        {
          "debtPct": 64.262,
          "year": 2024
        },
        {
          "debtPct": 66.926,
          "year": 2025
        }
      ],
      "iso": "blz",
      "name": "Belize",
      "startingDebtPct": 66.926,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.356,
          -0.439,
          0.414,
          1.327,
          1.548,
          1.548
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.909,
          1.991,
          2,
          2,
          2,
          2
        ],
        "realInterestRate": [
          -2.124663165287033,
          3.1082253802237503,
          3.7351474612344227,
          3.7167481386779055,
          3.6728880305384903,
          3.6768566913820244
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 100.177,
          "year": 2026
        },
        {
          "debtPct": 95.122,
          "year": 2027
        },
        {
          "debtPct": 93.003,
          "year": 2028
        },
        {
          "debtPct": 88.94,
          "year": 2029
        },
        {
          "debtPct": 85.264,
          "year": 2030
        },
        {
          "debtPct": 82.254,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -6.491,
        "realFxAppreciation": 0,
        "realGdpGrowth": -3,
        "realInterestRate": 9.071882088889428
      },
      "historical": [
        {
          "debtPct": 69.174,
          "year": 2022
        },
        {
          "debtPct": 78.281,
          "year": 2023
        },
        {
          "debtPct": 83.219,
          "year": 2024
        },
        {
          "debtPct": 83.317,
          "year": 2025
        }
      ],
      "iso": "bol",
      "name": "Bolivia",
      "startingDebtPct": 83.317,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -6.491,
          -3.02,
          -0.276,
          0.598,
          1.309,
          1.431
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -3,
          -1.511,
          0.489,
          2.512,
          2.897,
          2.709
        ],
        "realInterestRate": [
          9.071882088889428,
          -9.449934835341455,
          -2.041131357624937,
          -1.3072755072417008,
          0.1585561164830107,
          0.8069368666729249
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 97.01,
          "year": 2026
        },
        {
          "debtPct": 99.291,
          "year": 2027
        },
        {
          "debtPct": 101.308,
          "year": 2028
        },
        {
          "debtPct": 103.192,
          "year": 2029
        },
        {
          "debtPct": 104.513,
          "year": 2030
        },
        {
          "debtPct": 105.262,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.339,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.182,
        "realInterestRate": 5.841015354284318
      },
      "historical": [
        {
          "debtPct": 83.939,
          "year": 2022
        },
        {
          "debtPct": 84.001,
          "year": 2023
        },
        {
          "debtPct": 87.028,
          "year": 2024
        },
        {
          "debtPct": 93.329,
          "year": 2025
        }
      ],
      "iso": "bra",
      "name": "Brazil",
      "startingDebtPct": 93.329,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.339,
          -0.141,
          0.369,
          0.678,
          1.012,
          1.059
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.182,
          1.863,
          2.425,
          2.463,
          2.503,
          2.503
        ],
        "realInterestRate": [
          5.841015354284318,
          4.110055148953684,
          4.886311196382365,
          5.054209045682456,
          4.820422852546735,
          4.2762284404811
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 93.766,
          "year": 2026
        },
        {
          "debtPct": 88.36,
          "year": 2027
        },
        {
          "debtPct": 84.26,
          "year": 2028
        },
        {
          "debtPct": 80.338,
          "year": 2029
        },
        {
          "debtPct": 76.556,
          "year": 2030
        },
        {
          "debtPct": 72.8,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.528,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.8,
        "realInterestRate": 2.9694580461383513
      },
      "historical": [
        {
          "debtPct": 103.968,
          "year": 2022
        },
        {
          "debtPct": 104.122,
          "year": 2023
        },
        {
          "debtPct": 98.903,
          "year": 2024
        },
        {
          "debtPct": 96.189,
          "year": 2025
        }
      ],
      "iso": "brb",
      "name": "Barbados",
      "startingDebtPct": 96.189,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.528,
          3.49,
          4.089,
          4.094,
          4.098,
          4.091
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.8,
          2.2,
          2.1,
          2,
          2,
          2
        ],
        "realInterestRate": [
          2.9694580461383513,
          0.1116609431990101,
          2.087289497510181,
          2.2082126750534004,
          2.401204909258392,
          2.446339934165831
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -806.63% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 1.325,
          "year": 2026
        },
        {
          "debtPct": 1.375,
          "year": 2027
        },
        {
          "debtPct": 1.417,
          "year": 2028
        },
        {
          "debtPct": 1.417,
          "year": 2029
        },
        {
          "debtPct": 1.345,
          "year": 2030
        },
        {
          "debtPct": 1.306,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -12.714,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.94,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 1.326,
          "year": 2022
        },
        {
          "debtPct": 1.672,
          "year": 2023
        },
        {
          "debtPct": 1.568,
          "year": 2024
        },
        {
          "debtPct": 1.643,
          "year": 2025
        }
      ],
      "iso": "brn",
      "name": "Brunei Darussalam",
      "startingDebtPct": 1.643,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -12.714,
          -13.705,
          -15.398,
          -15.803,
          -14.743,
          -14.09
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.94,
          1.32,
          2.724,
          2.229,
          6.59,
          4.105
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 116.152,
          "year": 2026
        },
        {
          "debtPct": 116.717,
          "year": 2027
        },
        {
          "debtPct": 115.687,
          "year": 2028
        },
        {
          "debtPct": 127.89,
          "year": 2029
        },
        {
          "debtPct": 122.066,
          "year": 2030
        },
        {
          "debtPct": 115.548,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.416,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6.976,
        "realInterestRate": 22.62901461569211
      },
      "historical": [
        {
          "debtPct": 119.859,
          "year": 2022
        },
        {
          "debtPct": 117.18,
          "year": 2023
        },
        {
          "debtPct": 108.717,
          "year": 2024
        },
        {
          "debtPct": 102.561,
          "year": 2025
        }
      ],
      "iso": "btn",
      "name": "Bhutan",
      "startingDebtPct": 102.561,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.416,
          -1.813,
          -1.694,
          -0.948,
          0.447,
          0.2
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6.976,
          6.9,
          6.091,
          7.243,
          6.487,
          5.52
        ],
        "realInterestRate": [
          22.62901461569211,
          5.751408499207922,
          3.6149949279025373,
          17.676496978917267,
          2.0098665337399346,
          0.058402503563637076
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 40.263,
          "year": 2026
        },
        {
          "debtPct": 45.457,
          "year": 2027
        },
        {
          "debtPct": 49.945,
          "year": 2028
        },
        {
          "debtPct": 54.432,
          "year": 2029
        },
        {
          "debtPct": 59.084,
          "year": 2030
        },
        {
          "debtPct": 64.382,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -4.81,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.359,
        "realInterestRate": 8.934154604875744
      },
      "historical": [
        {
          "debtPct": 20.003,
          "year": 2022
        },
        {
          "debtPct": 22.494,
          "year": 2023
        },
        {
          "debtPct": 30.457,
          "year": 2024
        },
        {
          "debtPct": 33.964,
          "year": 2025
        }
      ],
      "iso": "bwa",
      "name": "Botswana",
      "startingDebtPct": 33.964,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -4.81,
          -4.662,
          -4.508,
          -4.721,
          -4.734,
          -4.781
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.359,
          2.228,
          2.963,
          3.928,
          3.945,
          3.956
        ],
        "realInterestRate": [
          8.934154604875744,
          3.5787512107890773,
          2.9176987262687692,
          3.4410813494844206,
          3.7884103101117006,
          4.865641391916609
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 43.482,
          "year": 2026
        },
        {
          "debtPct": 44.469,
          "year": 2027
        },
        {
          "debtPct": 45.324,
          "year": 2028
        },
        {
          "debtPct": 46.137,
          "year": 2029
        },
        {
          "debtPct": 47.066,
          "year": 2030
        },
        {
          "debtPct": 48.168,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.515,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.713,
        "realInterestRate": -1.1361432498472657
      },
      "historical": [
        {
          "debtPct": 34.21,
          "year": 2022
        },
        {
          "debtPct": 38.962,
          "year": 2023
        },
        {
          "debtPct": 41.62,
          "year": 2024
        },
        {
          "debtPct": 42.562,
          "year": 2025
        }
      ],
      "iso": "caf",
      "name": "Central African Republic",
      "startingDebtPct": 42.562,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.515,
          -2.288,
          -2.103,
          -1.938,
          -1.955,
          -2.012
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.713,
          3.304,
          3.486,
          3.496,
          3.499,
          3.497
        ],
        "realInterestRate": [
          -1.1361432498472657,
          0.21310022538061357,
          0.5817177359508818,
          0.9270961080222406,
          1.1973771376552644,
          1.4959319253813774
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 115.571,
          "year": 2026
        },
        {
          "debtPct": 113.389,
          "year": 2027
        },
        {
          "debtPct": 111.847,
          "year": 2028
        },
        {
          "debtPct": 110.41,
          "year": 2029
        },
        {
          "debtPct": 108.77,
          "year": 2030
        },
        {
          "debtPct": 106.984,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.555,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.12,
        "realInterestRate": 0.6152146007765369
      },
      "historical": [
        {
          "debtPct": 103.541,
          "year": 2022
        },
        {
          "debtPct": 105.071,
          "year": 2023
        },
        {
          "debtPct": 110.019,
          "year": 2024
        },
        {
          "debtPct": 113.583,
          "year": 2025
        }
      ],
      "iso": "can",
      "name": "Canada",
      "startingDebtPct": 113.583,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.555,
          -2.32,
          -2.076,
          -1.886,
          -1.658,
          -1.394
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.12,
          1.734,
          1.731,
          1.698,
          1.655,
          1.79
        ],
        "realInterestRate": [
          0.6152146007765369,
          -2.2289878429709975,
          -1.5150182028239034,
          -1.3234708843330556,
          -1.381483923557647,
          -1.1859327020318111
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 38.255,
          "year": 2026
        },
        {
          "debtPct": 37.769,
          "year": 2027
        },
        {
          "debtPct": 37.14,
          "year": 2028
        },
        {
          "debtPct": 36.961,
          "year": 2029
        },
        {
          "debtPct": 36.196,
          "year": 2030
        },
        {
          "debtPct": 35.874,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.214,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.855,
        "realInterestRate": -3.2736019022417295
      },
      "historical": [
        {
          "debtPct": 39.161,
          "year": 2022
        },
        {
          "debtPct": 40.152,
          "year": 2023
        },
        {
          "debtPct": 40.396,
          "year": 2024
        },
        {
          "debtPct": 40.058,
          "year": 2025
        }
      ],
      "iso": "che",
      "name": "Switzerland",
      "startingDebtPct": 40.058,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.214,
          -0.151,
          -0.097,
          -0.284,
          -0.25,
          -0.435
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.855,
          1.208,
          1.9,
          1.23,
          1.835,
          1.22
        ],
        "realInterestRate": [
          -3.2736019022417295,
          -0.47725672461117474,
          -0.05873335274962921,
          -0.031967959073775365,
          -0.961529449960763,
          -0.8969062879876311
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 42.827,
          "year": 2026
        },
        {
          "debtPct": 44.544,
          "year": 2027
        },
        {
          "debtPct": 45.952,
          "year": 2028
        },
        {
          "debtPct": 47.166,
          "year": 2029
        },
        {
          "debtPct": 48.134,
          "year": 2030
        },
        {
          "debtPct": 49.017,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.254,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.605,
        "realInterestRate": 0.6946182829352887
      },
      "historical": [
        {
          "debtPct": 37.923,
          "year": 2022
        },
        {
          "debtPct": 39.382,
          "year": 2023
        },
        {
          "debtPct": 41.777,
          "year": 2024
        },
        {
          "debtPct": 41.536,
          "year": 2025
        }
      ],
      "iso": "chl",
      "name": "Chile",
      "startingDebtPct": 41.536,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.254,
          -0.791,
          -0.654,
          -0.531,
          -0.438,
          -0.411
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.605,
          2.611,
          2.417,
          2.342,
          2.309,
          2.307
        ],
        "realInterestRate": [
          0.6946182829352887,
          4.8296421182898674,
          4.150621093749995,
          3.863143497562671,
          3.4586368146546365,
          3.310218182573643
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 104.369,
          "year": 2026
        },
        {
          "debtPct": 109.125,
          "year": 2027
        },
        {
          "debtPct": 113.223,
          "year": 2028
        },
        {
          "debtPct": 116.445,
          "year": 2029
        },
        {
          "debtPct": 119.451,
          "year": 2030
        },
        {
          "debtPct": 122.116,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -6.942,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.468,
        "realInterestRate": 3.215769716760142
      },
      "historical": [
        {
          "debtPct": 77.253,
          "year": 2022
        },
        {
          "debtPct": 84.084,
          "year": 2023
        },
        {
          "debtPct": 90.505,
          "year": 2024
        },
        {
          "debtPct": 98.609,
          "year": 2025
        }
      ],
      "iso": "chn",
      "name": "China, People's Republic of",
      "startingDebtPct": 98.609,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -6.942,
          -7.125,
          -6.893,
          -6.633,
          -6.493,
          -6.448
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.468,
          4.008,
          4,
          3.665,
          3.348,
          3.291
        ],
        "realInterestRate": [
          3.215769716760142,
          1.6471940901991777,
          1.3362657502863806,
          0.5419480140960831,
          0.25319579200480113,
          0.019785418288664758
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 57.762,
          "year": 2026
        },
        {
          "debtPct": 56.93,
          "year": 2027
        },
        {
          "debtPct": 55.344,
          "year": 2028
        },
        {
          "debtPct": 53.654,
          "year": 2029
        },
        {
          "debtPct": 52.173,
          "year": 2030
        },
        {
          "debtPct": 50.912,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.321,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6,
        "realInterestRate": 4.688633023027933
      },
      "historical": [
        {
          "debtPct": 56.035,
          "year": 2022
        },
        {
          "debtPct": 56.701,
          "year": 2023
        },
        {
          "debtPct": 59.46,
          "year": 2024
        },
        {
          "debtPct": 57.148,
          "year": 2025
        }
      ],
      "iso": "civ",
      "name": "Côte d'Ivoire",
      "startingDebtPct": 57.148,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.321,
          -1.086,
          -0.548,
          -0.613,
          -0.655,
          -0.651
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6,
          6.1,
          6.6,
          7,
          6.8,
          6.5
        ],
        "realInterestRate": [
          4.688633023027933,
          2.5769260067172173,
          2.6041384155981007,
          2.547466753396943,
          2.548223804376182,
          2.597061698579717
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 40.065,
          "year": 2026
        },
        {
          "debtPct": 39.076,
          "year": 2027
        },
        {
          "debtPct": 38.125,
          "year": 2028
        },
        {
          "debtPct": 36.752,
          "year": 2029
        },
        {
          "debtPct": 35.145,
          "year": 2030
        },
        {
          "debtPct": 34.268,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.724,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.199,
        "realInterestRate": 0.27791288561760386
      },
      "historical": [
        {
          "debtPct": 45.579,
          "year": 2022
        },
        {
          "debtPct": 43.56,
          "year": 2023
        },
        {
          "debtPct": 43.414,
          "year": 2024
        },
        {
          "debtPct": 40.487,
          "year": 2025
        }
      ],
      "iso": "cmr",
      "name": "Cameroon",
      "startingDebtPct": 40.487,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.724,
          -0.204,
          -0.033,
          0.009,
          0.055,
          -0.357
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.199,
          3.586,
          4.092,
          4.227,
          4.3,
          4.39
        ],
        "realInterestRate": [
          0.27791288561760386,
          0.5015597653812431,
          1.4707867744907288,
          0.4980654950819785,
          -0.10448410970832489,
          0.7246917057903035
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 23.68,
          "year": 2026
        },
        {
          "debtPct": 26.907,
          "year": 2027
        },
        {
          "debtPct": 28.352,
          "year": 2028
        },
        {
          "debtPct": 30.029,
          "year": 2029
        },
        {
          "debtPct": 31.494,
          "year": 2030
        },
        {
          "debtPct": 32.592,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.237,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.175,
        "realInterestRate": 10.41160897875255
      },
      "historical": [
        {
          "debtPct": 16.638,
          "year": 2022
        },
        {
          "debtPct": 17.186,
          "year": 2023
        },
        {
          "debtPct": 17.254,
          "year": 2024
        },
        {
          "debtPct": 20.426,
          "year": 2025
        }
      ],
      "iso": "cod",
      "name": "Congo, Democratic Republic of the",
      "startingDebtPct": 20.426,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.237,
          -1.807,
          -1.012,
          -1.038,
          -0.814,
          -0.507
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.175,
          5.69,
          5.507,
          5.502,
          5.467,
          5.459
        ],
        "realInterestRate": [
          10.41160897875255,
          12.027829391891887,
          7.204867878247301,
          7.879813840293459,
          7.753423690432593,
          7.437988664507511
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 80.549,
          "year": 2026
        },
        {
          "debtPct": 77.605,
          "year": 2027
        },
        {
          "debtPct": 74.556,
          "year": 2028
        },
        {
          "debtPct": 69.456,
          "year": 2029
        },
        {
          "debtPct": 63.511,
          "year": 2030
        },
        {
          "debtPct": 57.947,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 8.985,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.537,
        "realInterestRate": -7.688735954272974
      },
      "historical": [
        {
          "debtPct": 84.07,
          "year": 2022
        },
        {
          "debtPct": 98.263,
          "year": 2023
        },
        {
          "debtPct": 93.779,
          "year": 2024
        },
        {
          "debtPct": 100.422,
          "year": 2025
        }
      ],
      "iso": "cog",
      "name": "Congo, Republic of",
      "startingDebtPct": 100.422,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          8.985,
          8.759,
          7.981,
          7.338,
          7.72,
          6.792
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.537,
          3.564,
          3.741,
          3.947,
          3.987,
          3.975
        ],
        "realInterestRate": [
          -7.688735954272974,
          11.040500763510398,
          10.334010914245194,
          7.067250362143862,
          6.644465517737852,
          5.985380878902857
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 59.463,
          "year": 2026
        },
        {
          "debtPct": 62.855,
          "year": 2027
        },
        {
          "debtPct": 65.111,
          "year": 2028
        },
        {
          "debtPct": 65.92,
          "year": 2029
        },
        {
          "debtPct": 65.73,
          "year": 2030
        },
        {
          "debtPct": 65.298,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.383,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.22,
        "realInterestRate": -4.313248426780614
      },
      "historical": [
        {
          "debtPct": 61.3,
          "year": 2022
        },
        {
          "debtPct": 55.364,
          "year": 2023
        },
        {
          "debtPct": 61.008,
          "year": 2024
        },
        {
          "debtPct": 59.909,
          "year": 2025
        }
      ],
      "iso": "col",
      "name": "Colombia",
      "startingDebtPct": 59.909,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.383,
          -2.545,
          -1.201,
          0.068,
          0.56,
          0.588
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.22,
          2.28,
          2.4,
          2.6,
          2.78,
          2.92
        ],
        "realInterestRate": [
          -4.313248426780614,
          3.7368918487126423,
          4.118749502823982,
          3.98195082244166,
          3.356890169902904,
          3.16426471930622
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 34.737,
          "year": 2026
        },
        {
          "debtPct": 34.09,
          "year": 2027
        },
        {
          "debtPct": 32.773,
          "year": 2028
        },
        {
          "debtPct": 30.806,
          "year": 2029
        },
        {
          "debtPct": 29.438,
          "year": 2030
        },
        {
          "debtPct": 28.895,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.696,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.88,
        "realInterestRate": 8.053170747697248
      },
      "historical": [
        {
          "debtPct": 30.573,
          "year": 2022
        },
        {
          "debtPct": 32.392,
          "year": 2023
        },
        {
          "debtPct": 31.889,
          "year": 2024
        },
        {
          "debtPct": 30.507,
          "year": 2025
        }
      ],
      "iso": "com",
      "name": "Comoros, Union of the",
      "startingDebtPct": 30.507,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.696,
          -1.351,
          -0.754,
          -0.375,
          -0.365,
          -0.41
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.88,
          3.134,
          3.767,
          3.602,
          3.625,
          3.57
        ],
        "realInterestRate": [
          8.053170747697248,
          -2.798053199758188,
          -2.5369441771780354,
          -3.8015298568944034,
          -2.2044528663247465,
          0.2171156328554913
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 109.947,
          "year": 2026
        },
        {
          "debtPct": 103.605,
          "year": 2027
        },
        {
          "debtPct": 97.67,
          "year": 2028
        },
        {
          "debtPct": 92.321,
          "year": 2029
        },
        {
          "debtPct": 86.432,
          "year": 2030
        },
        {
          "debtPct": 80.809,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.116,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.996,
        "realInterestRate": 0.12714766711432457
      },
      "historical": [
        {
          "debtPct": 144.6,
          "year": 2022
        },
        {
          "debtPct": 134.33,
          "year": 2023
        },
        {
          "debtPct": 127.127,
          "year": 2024
        },
        {
          "debtPct": 115.415,
          "year": 2025
        }
      ],
      "iso": "cpv",
      "name": "Cabo Verde",
      "startingDebtPct": 115.415,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.116,
          0.861,
          0.891,
          0.86,
          0.828,
          0.946
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.996,
          5.033,
          5.112,
          5.063,
          5.076,
          5.059
        ],
        "realInterestRate": [
          0.12714766711432457,
          -0.20303075118011105,
          -0.005368157907426063,
          0.23421114979009783,
          -0.6842239577127707,
          -0.6259424171603301
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 61.839,
          "year": 2026
        },
        {
          "debtPct": 62.795,
          "year": 2027
        },
        {
          "debtPct": 63.259,
          "year": 2028
        },
        {
          "debtPct": 63.268,
          "year": 2029
        },
        {
          "debtPct": 63.009,
          "year": 2030
        },
        {
          "debtPct": 62.351,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.9,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.28,
        "realInterestRate": 7.258225518108974
      },
      "historical": [
        {
          "debtPct": 61.426,
          "year": 2022
        },
        {
          "debtPct": 60.411,
          "year": 2023
        },
        {
          "debtPct": 58.91,
          "year": 2024
        },
        {
          "debtPct": 60.412,
          "year": 2025
        }
      ],
      "iso": "cri",
      "name": "Costa Rica",
      "startingDebtPct": 60.412,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.9,
          0.816,
          0.924,
          1.085,
          1.239,
          1.428
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.28,
          3.478,
          3.541,
          3.53,
          3.47,
          3.47
        ],
        "realInterestRate": [
          7.258225518108974,
          6.443167871408018,
          5.82963616529979,
          5.320445944450558,
          5.07271543276222,
          4.734452697233715
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 51.424,
          "year": 2026
        },
        {
          "debtPct": 46.715,
          "year": 2027
        },
        {
          "debtPct": 42.379,
          "year": 2028
        },
        {
          "debtPct": 38.5,
          "year": 2029
        },
        {
          "debtPct": 35.604,
          "year": 2030
        },
        {
          "debtPct": 32.496,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.427,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.861,
        "realInterestRate": 2.5208277033779813
      },
      "historical": [
        {
          "debtPct": 80.327,
          "year": 2022
        },
        {
          "debtPct": 71.136,
          "year": 2023
        },
        {
          "debtPct": 62.836,
          "year": 2024
        },
        {
          "debtPct": 55.033,
          "year": 2025
        }
      ],
      "iso": "cyp",
      "name": "Cyprus",
      "startingDebtPct": 55.033,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.427,
          3.678,
          3.511,
          3.356,
          3.188,
          3.016
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.861,
          3.239,
          3.056,
          3.016,
          3.015,
          3.019
        ],
        "realInterestRate": [
          2.5208277033779813,
          1.1691608392968122,
          1.2360021406400357,
          1.7446776941409725,
          3.796308571428564,
          2.752801033591723
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 45.778,
          "year": 2026
        },
        {
          "debtPct": 47.394,
          "year": 2027
        },
        {
          "debtPct": 48.966,
          "year": 2028
        },
        {
          "debtPct": 50.858,
          "year": 2029
        },
        {
          "debtPct": 52.949,
          "year": 2030
        },
        {
          "debtPct": 55.276,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.019,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.843,
        "realInterestRate": 0.9044929810261282
      },
      "historical": [
        {
          "debtPct": 42.52,
          "year": 2022
        },
        {
          "debtPct": 42.223,
          "year": 2023
        },
        {
          "debtPct": 43.232,
          "year": 2024
        },
        {
          "debtPct": 44.166,
          "year": 2025
        }
      ],
      "iso": "cze",
      "name": "Czech Republic",
      "startingDebtPct": 44.166,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.019,
          -2.291,
          -2.505,
          -2.688,
          -2.892,
          -3.109
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.843,
          1.878,
          2.185,
          2.005,
          1.897,
          1.799
        ],
        "realInterestRate": [
          0.9044929810261282,
          0.37580134562453793,
          0.17338239017596901,
          0.3467885879998134,
          0.2921492980455298,
          0.2955378382972329
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 64.564,
          "year": 2026
        },
        {
          "debtPct": 66.946,
          "year": 2027
        },
        {
          "debtPct": 69.3,
          "year": 2028
        },
        {
          "debtPct": 71.462,
          "year": 2029
        },
        {
          "debtPct": 73.624,
          "year": 2030
        },
        {
          "debtPct": 75.59,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.368,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.32,
        "realInterestRate": -1.0441009926904887
      },
      "historical": [
        {
          "debtPct": 64.055,
          "year": 2022
        },
        {
          "debtPct": 61.824,
          "year": 2023
        },
        {
          "debtPct": 61.406,
          "year": 2024
        },
        {
          "debtPct": 62.658,
          "year": 2025
        }
      ],
      "iso": "deu",
      "name": "Germany",
      "startingDebtPct": 62.658,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.368,
          -3.566,
          -3.237,
          -2.851,
          -2.594,
          -2.394
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.32,
          1.088,
          1.051,
          0.891,
          0.655,
          0.608
        ],
        "realInterestRate": [
          -1.0441009926904887,
          -0.7657914627346551,
          -0.28183591252650686,
          -0.11208656565655506,
          0.046523327082925725,
          0.023133326089319617
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 28.726,
          "year": 2026
        },
        {
          "debtPct": 25.854,
          "year": 2027
        },
        {
          "debtPct": 23.314,
          "year": 2028
        },
        {
          "debtPct": 20.451,
          "year": 2029
        },
        {
          "debtPct": 17.86,
          "year": 2030
        },
        {
          "debtPct": 15.593,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.36,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.6,
        "realInterestRate": -7.769776274215678
      },
      "historical": [
        {
          "debtPct": 38.298,
          "year": 2022
        },
        {
          "debtPct": 35.607,
          "year": 2023
        },
        {
          "debtPct": 33.957,
          "year": 2024
        },
        {
          "debtPct": 31.333,
          "year": 2025
        }
      ],
      "iso": "dji",
      "name": "Djibouti",
      "startingDebtPct": 31.333,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.36,
          -0.839,
          0.465,
          0.484,
          0.607,
          0.731
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.6,
          5,
          5.2,
          5.4,
          5.5,
          5.5
        ],
        "realInterestRate": [
          -7.769776274215678,
          -8.564540834087586,
          -3.243180939119672,
          -5.35519430385174,
          -4.734805144002763,
          -3.573236282194836
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 99.657,
          "year": 2026
        },
        {
          "debtPct": 97.061,
          "year": 2027
        },
        {
          "debtPct": 93.44,
          "year": 2028
        },
        {
          "debtPct": 90.179,
          "year": 2029
        },
        {
          "debtPct": 86.445,
          "year": 2030
        },
        {
          "debtPct": 83.209,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.649,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.137,
        "realInterestRate": 4.634643106072733
      },
      "historical": [
        {
          "debtPct": 109.997,
          "year": 2022
        },
        {
          "debtPct": 101.258,
          "year": 2023
        },
        {
          "debtPct": 108.234,
          "year": 2024
        },
        {
          "debtPct": 99.856,
          "year": 2025
        }
      ],
      "iso": "dma",
      "name": "Dominica",
      "startingDebtPct": 99.856,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.649,
          1.277,
          1.591,
          1.864,
          2.055,
          2.244
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.137,
          2.839,
          2.733,
          2.425,
          2.132,
          2
        ],
        "realInterestRate": [
          4.634643106072733,
          1.4778849654314419,
          0.584371920750848,
          0.8936673266267237,
          0.23045276616506793,
          0.8294985250737685
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 26.442,
          "year": 2026
        },
        {
          "debtPct": 26.362,
          "year": 2027
        },
        {
          "debtPct": 26.193,
          "year": 2028
        },
        {
          "debtPct": 26.258,
          "year": 2029
        },
        {
          "debtPct": 26.38,
          "year": 2030
        },
        {
          "debtPct": 26.339,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.696,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.683,
        "realInterestRate": 2.6054499507712547
      },
      "historical": [
        {
          "debtPct": 33.315,
          "year": 2022
        },
        {
          "debtPct": 33.042,
          "year": 2023
        },
        {
          "debtPct": 29.943,
          "year": 2024
        },
        {
          "debtPct": 27.423,
          "year": 2025
        }
      ],
      "iso": "dnk",
      "name": "Denmark",
      "startingDebtPct": 27.423,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.696,
          -0.637,
          -0.468,
          -0.908,
          -1.013,
          -0.998
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.683,
          2.036,
          1.8,
          1.6,
          1.54,
          1.475
        ],
        "realInterestRate": [
          2.6054499507712547,
          -0.7308032675289566,
          -0.6598513011152329,
          -1.6699118084984699,
          -1.905507654809968,
          -2.5216840409401087
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 57.191,
          "year": 2026
        },
        {
          "debtPct": 55.294,
          "year": 2027
        },
        {
          "debtPct": 54.257,
          "year": 2028
        },
        {
          "debtPct": 53.36,
          "year": 2029
        },
        {
          "debtPct": 52.282,
          "year": 2030
        },
        {
          "debtPct": 50.392,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.073,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.613,
        "realInterestRate": 1.2691569046166418
      },
      "historical": [
        {
          "debtPct": 59.578,
          "year": 2022
        },
        {
          "debtPct": 60.511,
          "year": 2023
        },
        {
          "debtPct": 58.792,
          "year": 2024
        },
        {
          "debtPct": 59.004,
          "year": 2025
        }
      ],
      "iso": "dom",
      "name": "Dominican Republic",
      "startingDebtPct": 59.004,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.073,
          0.126,
          0.442,
          0.613,
          0.78,
          0.952
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.613,
          4.363,
          4.635,
          4.715,
          4.818,
          4.967
        ],
        "realInterestRate": [
          1.2691569046166418,
          1.131252469794175,
          3.5090582160812955,
          4.166885286691113,
          4.232622113943019,
          3.0837697104166173
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 51.802,
          "year": 2026
        },
        {
          "debtPct": 59.12,
          "year": 2027
        },
        {
          "debtPct": 66.092,
          "year": 2028
        },
        {
          "debtPct": 71.001,
          "year": 2029
        },
        {
          "debtPct": 75.289,
          "year": 2030
        },
        {
          "debtPct": 78.919,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -7.418,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.823,
        "realInterestRate": -11.520899521898587
      },
      "historical": [
        {
          "debtPct": 48.068,
          "year": 2022
        },
        {
          "debtPct": 47.655,
          "year": 2023
        },
        {
          "debtPct": 48.069,
          "year": 2024
        },
        {
          "debtPct": 52.081,
          "year": 2025
        }
      ],
      "iso": "dza",
      "name": "Algeria",
      "startingDebtPct": 52.081,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -7.418,
          -7.873,
          -8.02,
          -6.66,
          -6.253,
          -6.068
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.823,
          3.199,
          3.061,
          3.093,
          2.972,
          2.979
        ],
        "realInterestRate": [
          -11.520899521898587,
          2.0933391181807703,
          1.2340729364005654,
          0.3617187102826547,
          0.12218126505258997,
          -0.35565449135995797
        ]
      }
    },
    {
      "baselineProjection": [],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.7,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 57.203,
          "year": 2022
        },
        {
          "debtPct": 54.491,
          "year": 2023
        },
        {
          "debtPct": 54.134,
          "year": 2024
        },
        {
          "debtPct": 54.51,
          "year": 2025
        }
      ],
      "iso": "ecu",
      "name": "Ecuador",
      "startingDebtPct": 54.51,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.7,
          2.5,
          2.7,
          2.8,
          3,
          3
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 83.979,
          "year": 2026
        },
        {
          "debtPct": 82.922,
          "year": 2027
        },
        {
          "debtPct": 81.358,
          "year": 2028
        },
        {
          "debtPct": 77.988,
          "year": 2029
        },
        {
          "debtPct": 74.979,
          "year": 2030
        },
        {
          "debtPct": 71.474,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.072,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.133,
        "realInterestRate": 5.396943362546502
      },
      "historical": [
        {
          "debtPct": 88.534,
          "year": 2022
        },
        {
          "debtPct": 95.93,
          "year": 2023
        },
        {
          "debtPct": 90.926,
          "year": 2024
        },
        {
          "debtPct": 86.833,
          "year": 2025
        }
      ],
      "iso": "egy",
      "name": "Egypt, Arab Republic of",
      "startingDebtPct": 86.833,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.072,
          3.702,
          3.569,
          3.548,
          3.538,
          3.528
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.133,
          4.729,
          4.966,
          5.54,
          4.844,
          4.796
        ],
        "realInterestRate": [
          5.396943362546502,
          8.027541361530854,
          7.504009575263515,
          5.770906856117386,
          5.5551667948915195,
          4.828146441003489
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 97.628,
          "year": 2026
        },
        {
          "debtPct": 95.197,
          "year": 2027
        },
        {
          "debtPct": 93.233,
          "year": 2028
        },
        {
          "debtPct": 91.981,
          "year": 2029
        },
        {
          "debtPct": 90.68,
          "year": 2030
        },
        {
          "debtPct": 89.392,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.23,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.513,
        "realInterestRate": -0.6639820321749368
      },
      "historical": [
        {
          "debtPct": 109.226,
          "year": 2022
        },
        {
          "debtPct": 105.178,
          "year": 2023
        },
        {
          "debtPct": 101.377,
          "year": 2024
        },
        {
          "debtPct": 100.513,
          "year": 2025
        }
      ],
      "iso": "esp",
      "name": "Spain",
      "startingDebtPct": 100.513,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.23,
          -0.056,
          0.108,
          0.156,
          0.208,
          0.241
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.513,
          1.797,
          1.798,
          1.699,
          1.702,
          1.703
        ],
        "realInterestRate": [
          -0.6639820321749368,
          -0.7962021448764678,
          -0.18669582024641862,
          0.5034779852627347,
          0.49348643741644604,
          0.5287273820026472
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 27.549,
          "year": 2026
        },
        {
          "debtPct": 31.126,
          "year": 2027
        },
        {
          "debtPct": 34.75,
          "year": 2028
        },
        {
          "debtPct": 38.151,
          "year": 2029
        },
        {
          "debtPct": 40.782,
          "year": 2030
        },
        {
          "debtPct": 43.078,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.994,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.097,
        "realInterestRate": 0.3502956394742407
      },
      "historical": [
        {
          "debtPct": 19.112,
          "year": 2022
        },
        {
          "debtPct": 20.274,
          "year": 2023
        },
        {
          "debtPct": 23.451,
          "year": 2024
        },
        {
          "debtPct": 23.965,
          "year": 2025
        }
      ],
      "iso": "est",
      "name": "Estonia, Republic of",
      "startingDebtPct": 23.965,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.994,
          -4.187,
          -3.984,
          -3.698,
          -2.983,
          -2.713
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.097,
          2.179,
          1.885,
          1.75,
          1.655,
          1.66
        ],
        "realInterestRate": [
          0.3502956394742407,
          -0.08348466369014762,
          0.7066089442909318,
          0.8803669064748387,
          0.717080679405524,
          0.6205164042960121
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 40.651,
          "year": 2026
        },
        {
          "debtPct": 37.01,
          "year": 2027
        },
        {
          "debtPct": 34.177,
          "year": 2028
        },
        {
          "debtPct": 31.82,
          "year": 2029
        },
        {
          "debtPct": 29.673,
          "year": 2030
        },
        {
          "debtPct": 27.541,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.652,
        "realFxAppreciation": 0,
        "realGdpGrowth": 9.204,
        "realInterestRate": 0.9743821170161038
      },
      "historical": [
        {
          "debtPct": 46.945,
          "year": 2022
        },
        {
          "debtPct": 38.735,
          "year": 2023
        },
        {
          "debtPct": 33.479,
          "year": 2024
        },
        {
          "debtPct": 43.259,
          "year": 2025
        }
      ],
      "iso": "eth",
      "name": "Ethiopia, The Federal Democratic Republic of",
      "startingDebtPct": 43.259,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.652,
          0.071,
          -0.09,
          -0.25,
          -0.169,
          -0.09
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          9.204,
          7.767,
          8.227,
          8.247,
          7.993,
          7.67
        ],
        "realInterestRate": [
          0.9743821170161038,
          -1.6971752970406873,
          -0.3206228316671167,
          -0.010012874155118645,
          0.13279296040225042,
          -0.3926407845516122
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 90.618,
          "year": 2026
        },
        {
          "debtPct": 92.078,
          "year": 2027
        },
        {
          "debtPct": 94.528,
          "year": 2028
        },
        {
          "debtPct": 97.125,
          "year": 2029
        },
        {
          "debtPct": 99.132,
          "year": 2030
        },
        {
          "debtPct": 101.227,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.547,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.674,
        "realInterestRate": 0.12505207084529957
      },
      "historical": [
        {
          "debtPct": 74.094,
          "year": 2022
        },
        {
          "debtPct": 77.194,
          "year": 2023
        },
        {
          "debtPct": 82.475,
          "year": 2024
        },
        {
          "debtPct": 88.418,
          "year": 2025
        }
      ],
      "iso": "fin",
      "name": "Finland",
      "startingDebtPct": 88.418,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.547,
          -3.489,
          -3.293,
          -3.178,
          -3.027,
          -3.017
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.674,
          1.366,
          1.168,
          1.19,
          1.195,
          1.179
        ],
        "realInterestRate": [
          0.12505207084529957,
          -0.9036551899181178,
          0.24177849214794822,
          0.5680531694312707,
          0.13225714285713952,
          0.23796140499536822
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 78.884,
          "year": 2026
        },
        {
          "debtPct": 81.777,
          "year": 2027
        },
        {
          "debtPct": 84.312,
          "year": 2028
        },
        {
          "debtPct": 86.011,
          "year": 2029
        },
        {
          "debtPct": 86.986,
          "year": 2030
        },
        {
          "debtPct": 86.613,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.786,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.893,
        "realInterestRate": 1.8348826061030277
      },
      "historical": [
        {
          "debtPct": 91.494,
          "year": 2022
        },
        {
          "debtPct": 82.82,
          "year": 2023
        },
        {
          "debtPct": 78.801,
          "year": 2024
        },
        {
          "debtPct": 77.142,
          "year": 2025
        }
      ],
      "iso": "fji",
      "name": "Fiji, Republic of",
      "startingDebtPct": 77.142,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.786,
          -3.263,
          -2.512,
          -1.807,
          -1.123,
          -0.579
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.893,
          2.258,
          2.792,
          3.052,
          3.219,
          3.41
        ],
        "realInterestRate": [
          1.8348826061030277,
          1.7783658536585367,
          2.8209105249642263,
          2.9199948761742256,
          3.041390019881174,
          2.278250982916785
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 118.458,
          "year": 2026
        },
        {
          "debtPct": 120.422,
          "year": 2027
        },
        {
          "debtPct": 121.672,
          "year": 2028
        },
        {
          "debtPct": 122.571,
          "year": 2029
        },
        {
          "debtPct": 123.244,
          "year": 2030
        },
        {
          "debtPct": 123.629,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.896,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.411,
        "realInterestRate": 0.43533489708658113
      },
      "historical": [
        {
          "debtPct": 111.366,
          "year": 2022
        },
        {
          "debtPct": 109.507,
          "year": 2023
        },
        {
          "debtPct": 112.573,
          "year": 2024
        },
        {
          "debtPct": 115.534,
          "year": 2025
        }
      ],
      "iso": "fra",
      "name": "France",
      "startingDebtPct": 115.534,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.896,
          -2.475,
          -1.826,
          -1.271,
          -0.778,
          -0.2
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.411,
          0.724,
          1.218,
          1.142,
          1.109,
          1.09
        ],
        "realInterestRate": [
          0.43533489708658113,
          0.2895003123469797,
          0.7338561724601789,
          0.8327684265895252,
          1.0223853440046948,
          1.2417449125312396
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 7.661,
          "year": 2026
        },
        {
          "debtPct": 7.399,
          "year": 2027
        },
        {
          "debtPct": 7.695,
          "year": 2028
        },
        {
          "debtPct": 8.184,
          "year": 2029
        },
        {
          "debtPct": 8.834,
          "year": 2030
        },
        {
          "debtPct": 9.279,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.228,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.41,
        "realInterestRate": -8.798051755585966
      },
      "historical": [
        {
          "debtPct": 12.936,
          "year": 2022
        },
        {
          "debtPct": 12.762,
          "year": 2023
        },
        {
          "debtPct": 10.361,
          "year": 2024
        },
        {
          "debtPct": 8.772,
          "year": 2025
        }
      ],
      "iso": "fsm",
      "name": "Micronesia, Federated States of",
      "startingDebtPct": 8.772,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.228,
          -0.058,
          -0.383,
          -0.614,
          -0.786,
          -1.058
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.41,
          1.735,
          1.765,
          1.024,
          0.939,
          0.664
        ],
        "realInterestRate": [
          -8.798051755585966,
          -2.5144713483879366,
          0.5684119475604765,
          -0.6170656270305441,
          -0.73838318670576,
          -6.321174552863928
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 83.739,
          "year": 2026
        },
        {
          "debtPct": 92.404,
          "year": 2027
        },
        {
          "debtPct": 101.906,
          "year": 2028
        },
        {
          "debtPct": 109.486,
          "year": 2029
        },
        {
          "debtPct": 116.807,
          "year": 2030
        },
        {
          "debtPct": 123.776,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -5.63,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.982,
        "realInterestRate": -4.446121595134289
      },
      "historical": [
        {
          "debtPct": 65.589,
          "year": 2022
        },
        {
          "debtPct": 70.586,
          "year": 2023
        },
        {
          "debtPct": 70.879,
          "year": 2024
        },
        {
          "debtPct": 84.181,
          "year": 2025
        }
      ],
      "iso": "gab",
      "name": "Gabon",
      "startingDebtPct": 84.181,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -5.63,
          -4.617,
          -4.848,
          -4.765,
          -4.895,
          -4.772
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.982,
          2.937,
          2.78,
          2.863,
          2.906,
          2.9
        ],
        "realInterestRate": [
          -4.446121595134289,
          7.91304432821025,
          7.956595385481169,
          5.704435685828102,
          5.186199806367964,
          4.835425959060657
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 101.975,
          "year": 2026
        },
        {
          "debtPct": 102.499,
          "year": 2027
        },
        {
          "debtPct": 102.308,
          "year": 2028
        },
        {
          "debtPct": 101.616,
          "year": 2029
        },
        {
          "debtPct": 100.865,
          "year": 2030
        },
        {
          "debtPct": 100.195,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.148,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.27,
        "realInterestRate": 0.05046533275847587
      },
      "historical": [
        {
          "debtPct": 97.124,
          "year": 2022
        },
        {
          "debtPct": 98.333,
          "year": 2023
        },
        {
          "debtPct": 99.384,
          "year": 2024
        },
        {
          "debtPct": 102.056,
          "year": 2025
        }
      ],
      "iso": "gbr",
      "name": "United Kingdom",
      "startingDebtPct": 102.056,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.148,
          -0.331,
          0.355,
          1.181,
          1.476,
          1.513
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.27,
          1.222,
          1.552,
          1.453,
          1.405,
          1.426
        ],
        "realInterestRate": [
          0.05046533275847587,
          1.413574856582489,
          1.7144847852174294,
          1.9379133694334527,
          2.1284945776255615,
          2.2736886729787242
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 33.059,
          "year": 2026
        },
        {
          "debtPct": 32.39,
          "year": 2027
        },
        {
          "debtPct": 32.145,
          "year": 2028
        },
        {
          "debtPct": 31.673,
          "year": 2029
        },
        {
          "debtPct": 31.533,
          "year": 2030
        },
        {
          "debtPct": 31.533,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.024,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7.177,
        "realInterestRate": 3.4768193252787016
      },
      "historical": [
        {
          "debtPct": 39.199,
          "year": 2022
        },
        {
          "debtPct": 38.733,
          "year": 2023
        },
        {
          "debtPct": 35.497,
          "year": 2024
        },
        {
          "debtPct": 34.266,
          "year": 2025
        }
      ],
      "iso": "geo",
      "name": "Georgia",
      "startingDebtPct": 34.266,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.024,
          -0.658,
          -0.722,
          -0.703,
          -0.718,
          -0.759
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7.177,
          5.704,
          5,
          5,
          5,
          5
        ],
        "realInterestRate": [
          3.4768193252787016,
          1.4610039021144106,
          1.8652361840074239,
          1.1619225384974285,
          2.1556215072775053,
          2.472647702407005
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 51.691,
          "year": 2026
        },
        {
          "debtPct": 50.844,
          "year": 2027
        },
        {
          "debtPct": 49.682,
          "year": 2028
        },
        {
          "debtPct": 49.032,
          "year": 2029
        },
        {
          "debtPct": 48.147,
          "year": 2030
        },
        {
          "debtPct": 47.336,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.5,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.73,
        "realInterestRate": 15.219922761729144
      },
      "historical": [
        {
          "debtPct": 92.723,
          "year": 2022
        },
        {
          "debtPct": 79.092,
          "year": 2023
        },
        {
          "debtPct": 70.136,
          "year": 2024
        },
        {
          "debtPct": 48.81,
          "year": 2025
        }
      ],
      "iso": "gha",
      "name": "Ghana",
      "startingDebtPct": 48.81,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.5,
          0.5,
          0.5,
          0.5,
          0.5,
          0.5
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.73,
          5.229,
          4.965,
          5.038,
          4.966,
          4.977
        ],
        "realInterestRate": [
          15.219922761729144,
          4.522601149136207,
          3.59833274329322,
          4.720869047139797,
          4.1418053923968134,
          4.298913161775397
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 34.756,
          "year": 2026
        },
        {
          "debtPct": 31.898,
          "year": 2027
        },
        {
          "debtPct": 27.961,
          "year": 2028
        },
        {
          "debtPct": 24.368,
          "year": 2029
        },
        {
          "debtPct": 22.151,
          "year": 2030
        },
        {
          "debtPct": 20.119,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.838,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7.185,
        "realInterestRate": -5.75656786314428
      },
      "historical": [
        {
          "debtPct": 25.732,
          "year": 2022
        },
        {
          "debtPct": 25.926,
          "year": 2023
        },
        {
          "debtPct": 32.039,
          "year": 2024
        },
        {
          "debtPct": 36.301,
          "year": 2025
        }
      ],
      "iso": "gin",
      "name": "Guinea",
      "startingDebtPct": 36.301,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.838,
          -2.141,
          -1.49,
          -1.121,
          -1.213,
          -1.273
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7.185,
          7.755,
          10.072,
          10.224,
          9.801,
          8.915
        ],
        "realInterestRate": [
          -5.75656786314428,
          -7.743539676602618,
          -8.655216251802623,
          -8.358881012839303,
          -5.654409963887074,
          -7.335466118911105
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 67.434,
          "year": 2026
        },
        {
          "debtPct": 70.4,
          "year": 2027
        },
        {
          "debtPct": 64.742,
          "year": 2028
        },
        {
          "debtPct": 60.109,
          "year": 2029
        },
        {
          "debtPct": 55.69,
          "year": 2030
        },
        {
          "debtPct": 51.138,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.176,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.102,
        "realInterestRate": 0.7391570288320715
      },
      "historical": [
        {
          "debtPct": 83.93,
          "year": 2022
        },
        {
          "debtPct": 77.37,
          "year": 2023
        },
        {
          "debtPct": 75.895,
          "year": 2024
        },
        {
          "debtPct": 73.668,
          "year": 2025
        }
      ],
      "iso": "gmb",
      "name": "Gambia, The",
      "startingDebtPct": 73.668,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.176,
          2.691,
          1.802,
          1.624,
          1.533,
          1.502
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.102,
          5.137,
          5.117,
          5,
          5,
          5
        ],
        "realInterestRate": [
          0.7391570288320715,
          13.956883278464872,
          -0.6405447727272695,
          0.11993759846777863,
          -0.04134156282753487,
          -0.7505835877177125
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 73.91,
          "year": 2026
        },
        {
          "debtPct": 72.033,
          "year": 2027
        },
        {
          "debtPct": 70.082,
          "year": 2028
        },
        {
          "debtPct": 68.237,
          "year": 2029
        },
        {
          "debtPct": 66.614,
          "year": 2030
        },
        {
          "debtPct": 65.583,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.31,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.7,
        "realInterestRate": 2.6019572598362073
      },
      "historical": [
        {
          "debtPct": 80.69,
          "year": 2022
        },
        {
          "debtPct": 79.39,
          "year": 2023
        },
        {
          "debtPct": 82.427,
          "year": 2024
        },
        {
          "debtPct": 75.105,
          "year": 2025
        }
      ],
      "iso": "gnb",
      "name": "Guinea-Bissau",
      "startingDebtPct": 75.105,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.31,
          -0.112,
          0.339,
          0.058,
          -0.224,
          -0.279
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.7,
          4.9,
          4.5,
          4.5,
          4.204,
          4.21
        ],
        "realInterestRate": [
          2.6019572598362073,
          2.0770247598430602,
          2.1614329543403477,
          1.8353856910476418,
          1.3834658616293405,
          2.160654517068483
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 32.92,
          "year": 2026
        },
        {
          "debtPct": 35.959,
          "year": 2027
        },
        {
          "debtPct": 38.648,
          "year": 2028
        },
        {
          "debtPct": 40.885,
          "year": 2029
        },
        {
          "debtPct": 42.282,
          "year": 2030
        },
        {
          "debtPct": 44.136,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.229,
        "realFxAppreciation": 0,
        "realGdpGrowth": -1.671,
        "realInterestRate": -7.853220789867976
      },
      "historical": [
        {
          "debtPct": 29.759,
          "year": 2022
        },
        {
          "debtPct": 38.45,
          "year": 2023
        },
        {
          "debtPct": 34.976,
          "year": 2024
        },
        {
          "debtPct": 35.373,
          "year": 2025
        }
      ],
      "iso": "gnq",
      "name": "Equatorial Guinea, Republic of",
      "startingDebtPct": 35.373,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.229,
          -1.324,
          -1.852,
          -2.122,
          -1.611,
          -1.589
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -1.671,
          -1,
          1.599,
          2.2,
          2.5,
          2.3
        ],
        "realInterestRate": [
          -7.853220789867976,
          4.157503037667087,
          3.96387007425123,
          2.504103705236993,
          1.963495169377505,
          2.9411593585923157
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 136.038,
          "year": 2026
        },
        {
          "debtPct": 128.668,
          "year": 2027
        },
        {
          "debtPct": 124.123,
          "year": 2028
        },
        {
          "debtPct": 119.869,
          "year": 2029
        },
        {
          "debtPct": 115.35,
          "year": 2030
        },
        {
          "debtPct": 111.062,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.413,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.767,
        "realInterestRate": -3.1686220771156903
      },
      "historical": [
        {
          "debtPct": 179.17,
          "year": 2022
        },
        {
          "debtPct": 165.535,
          "year": 2023
        },
        {
          "debtPct": 155.373,
          "year": 2024
        },
        {
          "debtPct": 146.559,
          "year": 2025
        }
      ],
      "iso": "grc",
      "name": "Greece",
      "startingDebtPct": 146.559,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.413,
          2.604,
          2.375,
          2.357,
          2.406,
          2.381
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.767,
          1.788,
          1.713,
          1.637,
          1.624,
          1.621
        ],
        "realInterestRate": [
          -3.1686220771156903,
          -1.7780742439612474,
          -0.002400954394254917,
          0.08365864505368581,
          -0.16738486180746248,
          -0.05902814911139531
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 66.793,
          "year": 2026
        },
        {
          "debtPct": 67.209,
          "year": 2027
        },
        {
          "debtPct": 67.507,
          "year": 2028
        },
        {
          "debtPct": 67.586,
          "year": 2029
        },
        {
          "debtPct": 67.341,
          "year": 2030
        },
        {
          "debtPct": 64.278,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -9.395,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.899,
        "realInterestRate": -14.01472400369107
      },
      "historical": [
        {
          "debtPct": 79.274,
          "year": 2022
        },
        {
          "debtPct": 74.549,
          "year": 2023
        },
        {
          "debtPct": 72.772,
          "year": 2024
        },
        {
          "debtPct": 69.356,
          "year": 2025
        }
      ],
      "iso": "grd",
      "name": "Grenada",
      "startingDebtPct": 69.356,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -9.395,
          1.538,
          1.537,
          1.536,
          1.5,
          1.5
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.899,
          2.964,
          2.864,
          2.735,
          2.735,
          2.735
        ],
        "realInterestRate": [
          -14.01472400369107,
          5.976166783944414,
          5.672484577958303,
          5.192775119617221,
          4.642679475039202,
          0.35049717111419465
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 27.499,
          "year": 2026
        },
        {
          "debtPct": 28.437,
          "year": 2027
        },
        {
          "debtPct": 29.175,
          "year": 2028
        },
        {
          "debtPct": 29.721,
          "year": 2029
        },
        {
          "debtPct": 30.16,
          "year": 2030
        },
        {
          "debtPct": 30.573,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.951,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.952,
        "realInterestRate": 3.3524715751628964
      },
      "historical": [
        {
          "debtPct": 28.993,
          "year": 2022
        },
        {
          "debtPct": 27.226,
          "year": 2023
        },
        {
          "debtPct": 26.318,
          "year": 2024
        },
        {
          "debtPct": 26.702,
          "year": 2025
        }
      ],
      "iso": "gtm",
      "name": "Guatemala",
      "startingDebtPct": 26.702,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.951,
          -1.346,
          -1.051,
          -0.864,
          -0.798,
          -0.789
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.952,
          3.814,
          3.94,
          3.88,
          3.88,
          3.92
        ],
        "realInterestRate": [
          3.3524715751628964,
          2.273721735335843,
          2.795954566234138,
          2.747734704370175,
          2.625233336697952,
          2.6244456233421642
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 25.318,
          "year": 2026
        },
        {
          "debtPct": 26.037,
          "year": 2027
        },
        {
          "debtPct": 27.079,
          "year": 2028
        },
        {
          "debtPct": 27.944,
          "year": 2029
        },
        {
          "debtPct": 28.501,
          "year": 2030
        },
        {
          "debtPct": 28.269,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -5.558,
        "realFxAppreciation": 0,
        "realGdpGrowth": 22.325,
        "realInterestRate": -16.382121977375718
      },
      "historical": [
        {
          "debtPct": 24.832,
          "year": 2022
        },
        {
          "debtPct": 26.65,
          "year": 2023
        },
        {
          "debtPct": 24.304,
          "year": 2024
        },
        {
          "debtPct": 28.907,
          "year": 2025
        }
      ],
      "iso": "guy",
      "name": "Guyana",
      "startingDebtPct": 28.907,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -5.558,
          -2.639,
          -1.905,
          -1.757,
          -1.27,
          -0.426
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          22.325,
          16.789,
          9.241,
          4.292,
          2.401,
          1.487
        ],
        "realInterestRate": [
          -16.382121977375718,
          7.9322625009874415,
          5.620191803971286,
          0.8565531962037021,
          -0.21179390924704888,
          -0.8560211571523979
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -21.50% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 14.119,
          "year": 2026
        },
        {
          "debtPct": 15.585,
          "year": 2027
        },
        {
          "debtPct": 17.447,
          "year": 2028
        },
        {
          "debtPct": 18.448,
          "year": 2029
        },
        {
          "debtPct": 19.302,
          "year": 2030
        },
        {
          "debtPct": 20.017,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -4.991,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.79,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 4.276,
          "year": 2022
        },
        {
          "debtPct": 6.333,
          "year": 2023
        },
        {
          "debtPct": 9.212,
          "year": 2024
        },
        {
          "debtPct": 12.069,
          "year": 2025
        }
      ],
      "iso": "hkg",
      "name": "Hong Kong Special Administrative Region, People's Republic of China",
      "startingDebtPct": 12.069,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -4.991,
          -3.793,
          -1.543,
          -1.053,
          -0.946,
          -0.923
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.79,
          2.817,
          1.8,
          1.936,
          2.213,
          2.194
        ],
        "realInterestRate": [
          null,
          -14.12861647425453,
          3.8836830285530866,
          1.6321843296841942,
          1.703264744145705,
          1.0927487307014871
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 43.975,
          "year": 2026
        },
        {
          "debtPct": 42.334,
          "year": 2027
        },
        {
          "debtPct": 41.262,
          "year": 2028
        },
        {
          "debtPct": 40.219,
          "year": 2029
        },
        {
          "debtPct": 39.173,
          "year": 2030
        },
        {
          "debtPct": 38.262,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.196,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.3,
        "realInterestRate": 12.117480662435543
      },
      "historical": [
        {
          "debtPct": 46.936,
          "year": 2022
        },
        {
          "debtPct": 42.045,
          "year": 2023
        },
        {
          "debtPct": 42.175,
          "year": 2024
        },
        {
          "debtPct": 40.336,
          "year": 2025
        }
      ],
      "iso": "hnd",
      "name": "Honduras",
      "startingDebtPct": 40.336,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.196,
          -0.39,
          -0.348,
          -0.38,
          -0.375,
          -0.381
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.3,
          3.4,
          4.1,
          3.8,
          3.8,
          3.8
        ],
        "realInterestRate": [
          12.117480662435543,
          -1.3755633882887919,
          0.6081967213114714,
          0.22025592554892892,
          0.1325841020413332,
          0.37647869706174397
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 56.316,
          "year": 2026
        },
        {
          "debtPct": 56.548,
          "year": 2027
        },
        {
          "debtPct": 56.742,
          "year": 2028
        },
        {
          "debtPct": 57.284,
          "year": 2029
        },
        {
          "debtPct": 57.465,
          "year": 2030
        },
        {
          "debtPct": 57.766,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.858,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.23,
        "realInterestRate": -1.08836563915784
      },
      "historical": [
        {
          "debtPct": 68.549,
          "year": 2022
        },
        {
          "debtPct": 60.948,
          "year": 2023
        },
        {
          "debtPct": 57.37,
          "year": 2024
        },
        {
          "debtPct": 56.285,
          "year": 2025
        }
      ],
      "iso": "hrv",
      "name": "Croatia, Republic of",
      "startingDebtPct": 56.285,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.858,
          -1.72,
          -1.589,
          -1.456,
          -1.114,
          -1.268
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.23,
          2.3,
          2.4,
          2.4,
          2.4,
          2.4
        ],
        "realInterestRate": [
          -1.08836563915784,
          -0.4030044747496242,
          -0.1261370870764722,
          0.7505410454337058,
          0.7321835067383597,
          0.6768502566779633
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 10.538,
          "year": 2026
        },
        {
          "debtPct": 9.411,
          "year": 2027
        },
        {
          "debtPct": 9.256,
          "year": 2028
        },
        {
          "debtPct": 9.457,
          "year": 2029
        },
        {
          "debtPct": 9.876,
          "year": 2030
        },
        {
          "debtPct": 10.3,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.334,
        "realFxAppreciation": 0,
        "realGdpGrowth": -1.7,
        "realInterestRate": -18.781117408906876
      },
      "historical": [
        {
          "debtPct": 29.168,
          "year": 2022
        },
        {
          "debtPct": 27.891,
          "year": 2023
        },
        {
          "debtPct": 15.114,
          "year": 2024
        },
        {
          "debtPct": 12.35,
          "year": 2025
        }
      ],
      "iso": "hti",
      "name": "Haiti",
      "startingDebtPct": 12.35,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.334,
          -0.303,
          -0.849,
          -0.838,
          -0.957,
          -0.974
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -1.7,
          -0.5,
          0.7,
          0.9,
          1.2,
          1.5
        ],
        "realInterestRate": [
          -18.781117408906876,
          -14.00208768267226,
          -10.04304537243652,
          -6.043960674157301,
          -4.55717457967646,
          -4.152592142567835
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 78.734,
          "year": 2026
        },
        {
          "debtPct": 81.394,
          "year": 2027
        },
        {
          "debtPct": 83.501,
          "year": 2028
        },
        {
          "debtPct": 85.065,
          "year": 2029
        },
        {
          "debtPct": 86.487,
          "year": 2030
        },
        {
          "debtPct": 87.84,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.786,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.9,
        "realInterestRate": 2.413790698921825
      },
      "historical": [
        {
          "debtPct": 74.078,
          "year": 2022
        },
        {
          "debtPct": 73.306,
          "year": 2023
        },
        {
          "debtPct": 73.472,
          "year": 2024
        },
        {
          "debtPct": 74.572,
          "year": 2025
        }
      ],
      "iso": "hun",
      "name": "Hungary",
      "startingDebtPct": 74.572,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.786,
          -3.248,
          -2.841,
          -2.434,
          -2.23,
          -2.08
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.9,
          2.05,
          2.3,
          2.5,
          2.5,
          2.5
        ],
        "realInterestRate": [
          2.413790698921825,
          1.2878718215764362,
          1.3774725409735344,
          1.432048717979395,
          1.5263915829071717,
          1.6383965220206465
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 41.698,
          "year": 2026
        },
        {
          "debtPct": 41.555,
          "year": 2027
        },
        {
          "debtPct": 41.371,
          "year": 2028
        },
        {
          "debtPct": 41.527,
          "year": 2029
        },
        {
          "debtPct": 41.606,
          "year": 2030
        },
        {
          "debtPct": 41.632,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.641,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.142,
        "realInterestRate": 5.597238111545999
      },
      "historical": [
        {
          "debtPct": 40.141,
          "year": 2022
        },
        {
          "debtPct": 39.601,
          "year": 2023
        },
        {
          "debtPct": 40.165,
          "year": 2024
        },
        {
          "debtPct": 40.88,
          "year": 2025
        }
      ],
      "iso": "idn",
      "name": "Indonesia",
      "startingDebtPct": 40.88,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.641,
          -0.586,
          -0.53,
          -0.458,
          -0.374,
          -0.371
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.142,
          5.104,
          5.189,
          5.215,
          5.24,
          5.248
        ],
        "realInterestRate": [
          5.597238111545999,
          3.266482229363521,
          3.3816375646733343,
          4.446951608614724,
          4.492394827461643,
          4.375275873672058
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 83.079,
          "year": 2026
        },
        {
          "debtPct": 81.274,
          "year": 2027
        },
        {
          "debtPct": 79.849,
          "year": 2028
        },
        {
          "debtPct": 78.393,
          "year": 2029
        },
        {
          "debtPct": 76.982,
          "year": 2030
        },
        {
          "debtPct": 75.057,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.17,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7.012,
        "realInterestRate": 2.754938915987215
      },
      "historical": [
        {
          "debtPct": 84.406,
          "year": 2022
        },
        {
          "debtPct": 84.749,
          "year": 2023
        },
        {
          "debtPct": 84.805,
          "year": 2024
        },
        {
          "debtPct": 84.261,
          "year": 2025
        }
      ],
      "iso": "ind",
      "name": "India",
      "startingDebtPct": 84.261,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.17,
          -1.825,
          -1.724,
          -1.723,
          -1.72,
          -1.74
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7.012,
          7.015,
          6.944,
          6.86,
          6.821,
          6.814
        ],
        "realInterestRate": [
          2.754938915987215,
          2.3391559238796766,
          2.800403573098409,
          2.605620608899306,
          2.5545916344571706,
          1.7287422774155292
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 33.482,
          "year": 2026
        },
        {
          "debtPct": 30.792,
          "year": 2027
        },
        {
          "debtPct": 28.692,
          "year": 2028
        },
        {
          "debtPct": 26.943,
          "year": 2029
        },
        {
          "debtPct": 25.254,
          "year": 2030
        },
        {
          "debtPct": 24.143,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.692,
        "realFxAppreciation": 0,
        "realGdpGrowth": -1.04,
        "realInterestRate": -0.09703690947706622
      },
      "historical": [
        {
          "debtPct": 42.751,
          "year": 2022
        },
        {
          "debtPct": 42.105,
          "year": 2023
        },
        {
          "debtPct": 38.363,
          "year": 2024
        },
        {
          "debtPct": 34.842,
          "year": 2025
        }
      ],
      "iso": "irl",
      "name": "Ireland",
      "startingDebtPct": 34.842,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.692,
          1.78,
          1.583,
          1.523,
          1.719,
          1.577
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -1.04,
          3.675,
          2.914,
          2.369,
          2.276,
          2.292
        ],
        "realInterestRate": [
          -0.09703690947706622,
          0.8572397108894458,
          1.1860661860223276,
          1.5626639481388649,
          2.3898804142077568,
          4.179545418547548
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 39.141,
          "year": 2026
        },
        {
          "debtPct": 40.206,
          "year": 2027
        },
        {
          "debtPct": 40.812,
          "year": 2028
        },
        {
          "debtPct": 41.674,
          "year": 2029
        },
        {
          "debtPct": 42.72,
          "year": 2030
        },
        {
          "debtPct": 43.416,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -5.196,
        "realFxAppreciation": 0,
        "realGdpGrowth": -7.6,
        "realInterestRate": -11.84108156726067
      },
      "historical": [
        {
          "debtPct": 34.453,
          "year": 2022
        },
        {
          "debtPct": 29.643,
          "year": 2023
        },
        {
          "debtPct": 31.229,
          "year": 2024
        },
        {
          "debtPct": 35.578,
          "year": 2025
        }
      ],
      "iso": "irn",
      "name": "Iran, Islamic Republic of",
      "startingDebtPct": 35.578,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -5.196,
          -3.241,
          -2.42,
          -1.972,
          -1.888,
          -1.599
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -7.6,
          3.6,
          1.483,
          1.842,
          2.048,
          2.047
        ],
        "realInterestRate": [
          -11.84108156726067,
          -2.1595258169183063,
          -3.0956738795204997,
          -0.9278867980005767,
          -0.013823103133847603,
          -0.11003279494381513
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 71.09,
          "year": 2026
        },
        {
          "debtPct": 65.201,
          "year": 2027
        },
        {
          "debtPct": 62.847,
          "year": 2028
        },
        {
          "debtPct": 65.275,
          "year": 2029
        },
        {
          "debtPct": 68.659,
          "year": 2030
        },
        {
          "debtPct": 73.248,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -13.881,
        "realFxAppreciation": 0,
        "realGdpGrowth": -16.02,
        "realInterestRate": -8.983218656461943
      },
      "historical": [
        {
          "debtPct": 38.974,
          "year": 2022
        },
        {
          "debtPct": 42.078,
          "year": 2023
        },
        {
          "debtPct": 45.651,
          "year": 2024
        },
        {
          "debtPct": 52.786,
          "year": 2025
        }
      ],
      "iso": "irq",
      "name": "Iraq",
      "startingDebtPct": 52.786,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -13.881,
          -2.333,
          -0.273,
          -2.465,
          -3.906,
          -5.372
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -16.02,
          18.986,
          6.616,
          3.396,
          3.402,
          3.465
        ],
        "realInterestRate": [
          -8.983218656461943,
          5.22453014488673,
          2.320356804343482,
          3.335127531942672,
          2.575100819609344,
          2.285065905416639
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 54.631,
          "year": 2026
        },
        {
          "debtPct": 52.868,
          "year": 2027
        },
        {
          "debtPct": 51.589,
          "year": 2028
        },
        {
          "debtPct": 49.966,
          "year": 2029
        },
        {
          "debtPct": 48.57,
          "year": 2030
        },
        {
          "debtPct": 47.538,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.474,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.424,
        "realInterestRate": 0.3950868031051602
      },
      "historical": [
        {
          "debtPct": 66.431,
          "year": 2022
        },
        {
          "debtPct": 61.601,
          "year": 2023
        },
        {
          "debtPct": 60.471,
          "year": 2024
        },
        {
          "debtPct": 56.68,
          "year": 2025
        }
      ],
      "iso": "isl",
      "name": "Iceland",
      "startingDebtPct": 56.68,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.474,
          1.68,
          2,
          2.16,
          2.273,
          2.371
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.424,
          1.833,
          2.136,
          2.385,
          2.429,
          2.417
        ],
        "realInterestRate": [
          0.3950868031051602,
          1.6782867602643137,
          3.5289041386093567,
          3.4507455077632976,
          4.226827182484083,
          5.2404787523162355
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 68.837,
          "year": 2026
        },
        {
          "debtPct": 69.53,
          "year": 2027
        },
        {
          "debtPct": 70.449,
          "year": 2028
        },
        {
          "debtPct": 71.182,
          "year": 2029
        },
        {
          "debtPct": 71.88,
          "year": 2030
        },
        {
          "debtPct": 72.666,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.078,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.487,
        "realInterestRate": 1.23857185165539
      },
      "historical": [
        {
          "debtPct": 60.884,
          "year": 2022
        },
        {
          "debtPct": 61.92,
          "year": 2023
        },
        {
          "debtPct": 67.677,
          "year": 2024
        },
        {
          "debtPct": 67.869,
          "year": 2025
        }
      ],
      "iso": "isr",
      "name": "Israel",
      "startingDebtPct": 67.869,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.078,
          -2.529,
          -2.349,
          -2.066,
          -2.009,
          -2.083
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.487,
          4.424,
          3.618,
          3.568,
          3.552,
          3.549
        ],
        "realInterestRate": [
          1.23857185165539,
          1.6388341153739994,
          1.486923630087733,
          1.608339195730224,
          1.644823017054864,
          1.6805657623817583
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 137.866,
          "year": 2026
        },
        {
          "debtPct": 137.617,
          "year": 2027
        },
        {
          "debtPct": 136.983,
          "year": 2028
        },
        {
          "debtPct": 136.212,
          "year": 2029
        },
        {
          "debtPct": 135.791,
          "year": 2030
        },
        {
          "debtPct": 135.576,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.999,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.782,
        "realInterestRate": 2.0757261223150136
      },
      "historical": [
        {
          "debtPct": 138.357,
          "year": 2022
        },
        {
          "debtPct": 133.939,
          "year": 2023
        },
        {
          "debtPct": 134.739,
          "year": 2024
        },
        {
          "debtPct": 137.105,
          "year": 2025
        }
      ],
      "iso": "ita",
      "name": "Italy",
      "startingDebtPct": 137.105,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.999,
          1.2,
          1.693,
          1.789,
          1.953,
          1.89
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.782,
          0.623,
          0.738,
          0.648,
          0.643,
          0.635
        ],
        "realInterestRate": [
          2.0757261223150136,
          1.3170976963137848,
          1.5132061300566102,
          1.3959735733630962,
          1.7749492849381987,
          1.8763460759549488
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 64.329,
          "year": 2026
        },
        {
          "debtPct": 64.012,
          "year": 2027
        },
        {
          "debtPct": 63.202,
          "year": 2028
        },
        {
          "debtPct": 62.449,
          "year": 2029
        },
        {
          "debtPct": 61.527,
          "year": 2030
        },
        {
          "debtPct": 60.288,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.55,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.048,
        "realInterestRate": -1.6110500962515206
      },
      "historical": [
        {
          "debtPct": 70.167,
          "year": 2022
        },
        {
          "debtPct": 66.546,
          "year": 2023
        },
        {
          "debtPct": 62.463,
          "year": 2024
        },
        {
          "debtPct": 65.973,
          "year": 2025
        }
      ],
      "iso": "jam",
      "name": "Jamaica",
      "startingDebtPct": 65.973,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.55,
          1.979,
          2.694,
          2.936,
          2.855,
          2.952
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.048,
          2.373,
          1.849,
          1.6,
          1.6,
          1.6
        ],
        "realInterestRate": [
          -1.6110500962515206,
          5.017902392389129,
          4.846617884146709,
          5.109268694028657,
          4.744850998414729,
          4.428689843483347
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 82.461,
          "year": 2026
        },
        {
          "debtPct": 81.43,
          "year": 2027
        },
        {
          "debtPct": 79.934,
          "year": 2028
        },
        {
          "debtPct": 78.35,
          "year": 2029
        },
        {
          "debtPct": 76.848,
          "year": 2030
        },
        {
          "debtPct": 75.738,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.487,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.702,
        "realInterestRate": 0.7297736034171498
      },
      "historical": [
        {
          "debtPct": 80.709,
          "year": 2022
        },
        {
          "debtPct": 81.031,
          "year": 2023
        },
        {
          "debtPct": 82.122,
          "year": 2024
        },
        {
          "debtPct": 83.579,
          "year": 2025
        }
      ],
      "iso": "jor",
      "name": "Jordan",
      "startingDebtPct": 83.579,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.487,
          0.49,
          1.34,
          1.35,
          1.185,
          0.939
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.702,
          3.149,
          3.032,
          3.011,
          3.046,
          3.042
        ],
        "realInterestRate": [
          0.7297736034171498,
          2.4722727107359788,
          2.834615841827315,
          2.709444041334108,
          2.6290812763241744,
          2.8127138507182847
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 199.369,
          "year": 2026
        },
        {
          "debtPct": 196.366,
          "year": 2027
        },
        {
          "debtPct": 193.761,
          "year": 2028
        },
        {
          "debtPct": 191.542,
          "year": 2029
        },
        {
          "debtPct": 190.098,
          "year": 2030
        },
        {
          "debtPct": 188.881,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.172,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.75,
        "realInterestRate": -2.4863984861433264
      },
      "historical": [
        {
          "debtPct": 227.987,
          "year": 2022
        },
        {
          "debtPct": 220.078,
          "year": 2023
        },
        {
          "debtPct": 213.589,
          "year": 2024
        },
        {
          "debtPct": 204.775,
          "year": 2025
        }
      ],
      "iso": "jpn",
      "name": "Japan",
      "startingDebtPct": 204.775,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.172,
          -1.459,
          -1.634,
          -1.825,
          -1.94,
          -2.086
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.75,
          0.67,
          0.599,
          0.588,
          0.582,
          0.596
        ],
        "realInterestRate": [
          -2.4863984861433264,
          -1.5830560919701697,
          -1.5726547722110795,
          -1.5113795036152622,
          -1.1949966273715362,
          -1.151880503740188
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 23.816,
          "year": 2026
        },
        {
          "debtPct": 25.14,
          "year": 2027
        },
        {
          "debtPct": 26.903,
          "year": 2028
        },
        {
          "debtPct": 28.315,
          "year": 2029
        },
        {
          "debtPct": 29.015,
          "year": 2030
        },
        {
          "debtPct": 29.751,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.652,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.415,
        "realInterestRate": -0.35968278816843613
      },
      "historical": [
        {
          "debtPct": 23.524,
          "year": 2022
        },
        {
          "debtPct": 22.982,
          "year": 2023
        },
        {
          "debtPct": 24.377,
          "year": 2024
        },
        {
          "debtPct": 24.274,
          "year": 2025
        }
      ],
      "iso": "kaz",
      "name": "Kazakhstan, Republic of",
      "startingDebtPct": 24.274,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.652,
          -1.829,
          -1.86,
          -1.743,
          -1.078,
          -1.073
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.415,
          4.882,
          3.53,
          3.777,
          3.721,
          3.603
        ],
        "realInterestRate": [
          -0.35968278816843613,
          2.6580576923076915,
          3.1305405727923397,
          2.500183771326636,
          2.33634388133499,
          2.399684094433918
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 72.913,
          "year": 2026
        },
        {
          "debtPct": 73.766,
          "year": 2027
        },
        {
          "debtPct": 74.446,
          "year": 2028
        },
        {
          "debtPct": 74.429,
          "year": 2029
        },
        {
          "debtPct": 74.295,
          "year": 2030
        },
        {
          "debtPct": 74.021,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.97,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.544,
        "realInterestRate": 5.532685908319168
      },
      "historical": [
        {
          "debtPct": 67.8,
          "year": 2022
        },
        {
          "debtPct": 73.405,
          "year": 2023
        },
        {
          "debtPct": 67.306,
          "year": 2024
        },
        {
          "debtPct": 71.269,
          "year": 2025
        }
      ],
      "iso": "ken",
      "name": "Kenya",
      "startingDebtPct": 71.269,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.97,
          -0.146,
          0.236,
          0.395,
          0.508,
          0.527
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.544,
          4.655,
          4.927,
          4.952,
          4.97,
          4.988
        ],
        "realInterestRate": [
          5.532685908319168,
          5.669785909234304,
          6.229946235392991,
          5.484894393251483,
          5.497466175818566,
          5.345520209973742
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 34.008,
          "year": 2026
        },
        {
          "debtPct": 32.243,
          "year": 2027
        },
        {
          "debtPct": 31.381,
          "year": 2028
        },
        {
          "debtPct": 30.808,
          "year": 2029
        },
        {
          "debtPct": 31.109,
          "year": 2030
        },
        {
          "debtPct": 31.381,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.415,
        "realFxAppreciation": 0,
        "realGdpGrowth": 8.96,
        "realInterestRate": 3.3667126343540854
      },
      "historical": [
        {
          "debtPct": 46.822,
          "year": 2022
        },
        {
          "debtPct": 41.95,
          "year": 2023
        },
        {
          "debtPct": 36.23,
          "year": 2024
        },
        {
          "debtPct": 39.448,
          "year": 2025
        }
      ],
      "iso": "kgz",
      "name": "Kyrgyz Republic",
      "startingDebtPct": 39.448,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.415,
          -1.277,
          -1.254,
          -0.801,
          -0.575,
          -0.075
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          8.96,
          7.04,
          7.532,
          6.538,
          5.481,
          5.347
        ],
        "realInterestRate": [
          3.3667126343540854,
          -2.5346788990825653,
          0.47503532549699745,
          1.8732916733054994,
          4.542873734095054,
          6.01411752226042
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 25.11,
          "year": 2026
        },
        {
          "debtPct": 25.32,
          "year": 2027
        },
        {
          "debtPct": 24.894,
          "year": 2028
        },
        {
          "debtPct": 25.432,
          "year": 2029
        },
        {
          "debtPct": 25.706,
          "year": 2030
        },
        {
          "debtPct": 25.738,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.655,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.002,
        "realInterestRate": -9.432613752055774
      },
      "historical": [
        {
          "debtPct": 25.283,
          "year": 2022
        },
        {
          "debtPct": 26.278,
          "year": 2023
        },
        {
          "debtPct": 26.132,
          "year": 2024
        },
        {
          "debtPct": 25.538,
          "year": 2025
        }
      ],
      "iso": "khm",
      "name": "Cambodia",
      "startingDebtPct": 25.538,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.655,
          -2.528,
          -2.559,
          -2.414,
          -2.381,
          -2.283
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.002,
          3.998,
          4.723,
          5.121,
          5.283,
          5.489
        ],
        "realInterestRate": [
          -9.432613752055774,
          -5.602452568697736,
          -7.6228986966824674,
          -2.8008685627058827,
          -3.4395259908776454,
          -3.7483663347078533
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -215.01% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 7.74,
          "year": 2026
        },
        {
          "debtPct": 15.702,
          "year": 2027
        },
        {
          "debtPct": 20.905,
          "year": 2028
        },
        {
          "debtPct": 28.158,
          "year": 2029
        },
        {
          "debtPct": 32.358,
          "year": 2030
        },
        {
          "debtPct": 36.393,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -16.619,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.989,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 16.248,
          "year": 2022
        },
        {
          "debtPct": 11.306,
          "year": 2023
        },
        {
          "debtPct": 8.899,
          "year": 2024
        },
        {
          "debtPct": 7.951,
          "year": 2025
        }
      ],
      "iso": "kir",
      "name": "Kiribati",
      "startingDebtPct": 7.951,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -16.619,
          -15.054,
          -12.234,
          -14.22,
          -13.953,
          -13.875
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.989,
          2.451,
          2.158,
          2.151,
          2.102,
          2.109
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 65.055,
          "year": 2026
        },
        {
          "debtPct": 69.244,
          "year": 2027
        },
        {
          "debtPct": 71.552,
          "year": 2028
        },
        {
          "debtPct": 74.045,
          "year": 2029
        },
        {
          "debtPct": 76.649,
          "year": 2030
        },
        {
          "debtPct": 79.34,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -7.819,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.796,
        "realInterestRate": -0.7462121222445384
      },
      "historical": [
        {
          "debtPct": 64.499,
          "year": 2022
        },
        {
          "debtPct": 60.015,
          "year": 2023
        },
        {
          "debtPct": 58.125,
          "year": 2024
        },
        {
          "debtPct": 58.702,
          "year": 2025
        }
      ],
      "iso": "kna",
      "name": "St. Kitts and Nevis",
      "startingDebtPct": 58.702,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -7.819,
          -5.561,
          -3.211,
          -3.211,
          -3.211,
          -3.211
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.796,
          2.295,
          2.43,
          2.618,
          2.503,
          2.454
        ],
        "realInterestRate": [
          -0.7462121222445384,
          0.13761409576511507,
          1.0942266477961926,
          1.5882632491055482,
          1.6627093524208325,
          1.7589344414147723
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 47.291,
          "year": 2026
        },
        {
          "debtPct": 46.228,
          "year": 2027
        },
        {
          "debtPct": 46.982,
          "year": 2028
        },
        {
          "debtPct": 48.191,
          "year": 2029
        },
        {
          "debtPct": 49.214,
          "year": 2030
        },
        {
          "debtPct": 49.726,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.036,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.33,
        "realInterestRate": -8.8171938493237
      },
      "historical": [
        {
          "debtPct": 49.704,
          "year": 2022
        },
        {
          "debtPct": 50.562,
          "year": 2023
        },
        {
          "debtPct": 49.558,
          "year": 2024
        },
        {
          "debtPct": 52.417,
          "year": 2025
        }
      ],
      "iso": "kor",
      "name": "Korea, Republic of",
      "startingDebtPct": 52.417,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.036,
          1.621,
          0.914,
          0.458,
          0.254,
          0.021
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.33,
          2.83,
          2.255,
          2.139,
          1.904,
          1.887
        ],
        "realInterestRate": [
          -8.8171938493237,
          4.043320504958681,
          5.944567794410327,
          5.763062683580955,
          4.6043259529787495,
          2.99046184012679
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 18.116,
          "year": 2026
        },
        {
          "debtPct": 18.758,
          "year": 2027
        },
        {
          "debtPct": 19.668,
          "year": 2028
        },
        {
          "debtPct": 20.735,
          "year": 2029
        },
        {
          "debtPct": 21.755,
          "year": 2030
        },
        {
          "debtPct": 22.667,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.831,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.5,
        "realInterestRate": -3.60323134114956
      },
      "historical": [
        {
          "debtPct": 21.436,
          "year": 2022
        },
        {
          "debtPct": 18.628,
          "year": 2023
        },
        {
          "debtPct": 17.916,
          "year": 2024
        },
        {
          "debtPct": 17.485,
          "year": 2025
        }
      ],
      "iso": "kos",
      "name": "Kosovo, Republic of",
      "startingDebtPct": 17.485,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.831,
          -1.45,
          -1.4,
          -1.244,
          -1.222,
          -1.189
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.5,
          3.6,
          4,
          4,
          4,
          3.96
        ],
        "realInterestRate": [
          -3.60323134114956,
          -1.020710973724892,
          1.2832924618829455,
          3.0640634533251943,
          2.9868338557993646,
          2.6363079751781537
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -49.69% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 26.572,
          "year": 2026
        },
        {
          "debtPct": 28.479,
          "year": 2027
        },
        {
          "debtPct": 31.841,
          "year": 2028
        },
        {
          "debtPct": 34.724,
          "year": 2029
        },
        {
          "debtPct": 36.543,
          "year": 2030
        },
        {
          "debtPct": 37.757,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -17.721,
        "realFxAppreciation": 0,
        "realGdpGrowth": -16.74,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 2.951,
          "year": 2022
        },
        {
          "debtPct": 3.133,
          "year": 2023
        },
        {
          "debtPct": 2.911,
          "year": 2024
        },
        {
          "debtPct": 14.648,
          "year": 2025
        }
      ],
      "iso": "kwt",
      "name": "Kuwait",
      "startingDebtPct": 14.648,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -17.721,
          -5.944,
          1.5,
          1.15,
          -0.896,
          -2.118
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -16.74,
          17.125,
          11.506,
          2.328,
          2.262,
          2.235
        ],
        "realInterestRate": [
          null,
          -0.6694311681469056,
          30.542559289300897,
          15.288925347821959,
          4.980230215412984,
          -0.29408737651532846
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 79.783,
          "year": 2026
        },
        {
          "debtPct": 71.919,
          "year": 2027
        },
        {
          "debtPct": 66.534,
          "year": 2028
        },
        {
          "debtPct": 61.805,
          "year": 2029
        },
        {
          "debtPct": 57.54,
          "year": 2030
        },
        {
          "debtPct": 52.108,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 5.036,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.533,
        "realInterestRate": -0.12858448038928216
      },
      "historical": [
        {
          "debtPct": 115.72,
          "year": 2022
        },
        {
          "debtPct": 108.783,
          "year": 2023
        },
        {
          "debtPct": 99.165,
          "year": 2024
        },
        {
          "debtPct": 88.778,
          "year": 2025
        }
      ],
      "iso": "lao",
      "name": "Lao People's Democratic Republic",
      "startingDebtPct": 88.778,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          5.036,
          5.103,
          4.879,
          4.514,
          4.425,
          4.079
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.533,
          4.521,
          4.013,
          3.535,
          3.04,
          3.021
        ],
        "realInterestRate": [
          -0.12858448038928216,
          0.9039076244312438,
          3.2811964710299346,
          3.200433838338279,
          3.306748644931634,
          0.5985562565172131
        ]
      }
    },
    {
      "baselineProjection": [],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": null,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 260.317,
          "year": 2022
        },
        {
          "debtPct": 175.563,
          "year": 2023
        },
        {
          "debtPct": 152.002,
          "year": 2024
        },
        {
          "debtPct": 139.414,
          "year": 2025
        }
      ],
      "iso": "lbn",
      "name": "Lebanon",
      "startingDebtPct": 139.414,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 53.958,
          "year": 2026
        },
        {
          "debtPct": 55.065,
          "year": 2027
        },
        {
          "debtPct": 53.576,
          "year": 2028
        },
        {
          "debtPct": 52.847,
          "year": 2029
        },
        {
          "debtPct": 52.31,
          "year": 2030
        },
        {
          "debtPct": 50.715,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.142,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.549,
        "realInterestRate": 3.1006095763603803
      },
      "historical": [
        {
          "debtPct": 54.438,
          "year": 2022
        },
        {
          "debtPct": 57.16,
          "year": 2023
        },
        {
          "debtPct": 56.368,
          "year": 2024
        },
        {
          "debtPct": 55.094,
          "year": 2025
        }
      ],
      "iso": "lbr",
      "name": "Liberia",
      "startingDebtPct": 55.094,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.142,
          -1.7,
          -1.774,
          -2.515,
          -2.677,
          -1.609
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.549,
          5.065,
          5.275,
          5.359,
          5.571,
          5.399
        ],
        "realInterestRate": [
          3.1006095763603803,
          3.9103325734830774,
          -0.9633060927994097,
          -1.0204347469015995,
          -0.8495194996877786,
          -1.0567139361498779
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -31.02% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 125.189,
          "year": 2026
        },
        {
          "debtPct": 132.139,
          "year": 2027
        },
        {
          "debtPct": 149.157,
          "year": 2028
        },
        {
          "debtPct": 158.64,
          "year": 2029
        },
        {
          "debtPct": 166.516,
          "year": 2030
        },
        {
          "debtPct": 174.368,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -22.476,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.293,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 77.591,
          "year": 2022
        },
        {
          "debtPct": 91.595,
          "year": 2023
        },
        {
          "debtPct": 115.308,
          "year": 2024
        },
        {
          "debtPct": 153.796,
          "year": 2025
        }
      ],
      "iso": "lby",
      "name": "Libya",
      "startingDebtPct": 153.796,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -22.476,
          -23.596,
          -26.938,
          -27.114,
          -27.206,
          -27.685
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.293,
          2.926,
          2.694,
          2.524,
          2.303,
          2.149
        ],
        "realInterestRate": [
          null,
          -10.759756703863744,
          -5.015491368937264,
          -9.59477849514273,
          -10.162437405446267,
          -10.017525240817704
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 78.11,
          "year": 2026
        },
        {
          "debtPct": 78.24,
          "year": 2027
        },
        {
          "debtPct": 78.392,
          "year": 2028
        },
        {
          "debtPct": 78.342,
          "year": 2029
        },
        {
          "debtPct": 78.131,
          "year": 2030
        },
        {
          "debtPct": 77.693,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.154,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.203,
        "realInterestRate": 3.1093585013733938
      },
      "historical": [
        {
          "debtPct": 73.881,
          "year": 2022
        },
        {
          "debtPct": 73.974,
          "year": 2023
        },
        {
          "debtPct": 75.944,
          "year": 2024
        },
        {
          "debtPct": 76.817,
          "year": 2025
        }
      ],
      "iso": "lca",
      "name": "St. Lucia",
      "startingDebtPct": 76.817,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.154,
          0.396,
          0.469,
          0.844,
          1.147,
          1.489
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.203,
          1.794,
          1.64,
          1.583,
          1.508,
          1.5
        ],
        "realInterestRate": [
          3.1093585013733938,
          2.4794902573294086,
          2.4467285276073447,
          2.6118920042861538,
          2.720778433024429,
          2.865354340786608
        ]
      }
    },
    {
      "_caveats": [
        "r computed as 579.91% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 0.513,
          "year": 2026
        },
        {
          "debtPct": 0.504,
          "year": 2027
        },
        {
          "debtPct": 0.494,
          "year": 2028
        },
        {
          "debtPct": 0.483,
          "year": 2029
        },
        {
          "debtPct": 0.473,
          "year": 2030
        },
        {
          "debtPct": 0.463,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.001,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 0.512,
          "year": 2022
        },
        {
          "debtPct": 0.473,
          "year": 2023
        },
        {
          "debtPct": 0.487,
          "year": 2024
        },
        {
          "debtPct": 0.522,
          "year": 2025
        }
      ],
      "iso": "lie",
      "name": "Liechtenstein, Principality of",
      "startingDebtPct": 0.522,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.001,
          3.201,
          3.301,
          3.301,
          3.301,
          3.301
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1,
          1,
          1.2,
          1.5,
          1.5,
          1.5
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 95.23,
          "year": 2026
        },
        {
          "debtPct": 91.822,
          "year": 2027
        },
        {
          "debtPct": 90.102,
          "year": 2028
        },
        {
          "debtPct": 87.378,
          "year": 2029
        },
        {
          "debtPct": 84.722,
          "year": 2030
        },
        {
          "debtPct": 82.435,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 2.28,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.972,
        "realInterestRate": 4.735686525687255
      },
      "historical": [
        {
          "debtPct": 115.942,
          "year": 2022
        },
        {
          "debtPct": 109.897,
          "year": 2023
        },
        {
          "debtPct": 100.179,
          "year": 2024
        },
        {
          "debtPct": 96.799,
          "year": 2025
        }
      ],
      "iso": "lka",
      "name": "Sri Lanka",
      "startingDebtPct": 96.799,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          2.28,
          2.6,
          2.6,
          2.6,
          2.6,
          2.6
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.972,
          3.691,
          3.457,
          3.506,
          3.506,
          3.505
        ],
        "realInterestRate": [
          4.735686525687255,
          2.8112107739157732,
          4.448507046241623,
          3.3635531730705104,
          3.4396636682002324,
          3.8873925898822215
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 47.475,
          "year": 2026
        },
        {
          "debtPct": 48.002,
          "year": 2027
        },
        {
          "debtPct": 48.482,
          "year": 2028
        },
        {
          "debtPct": 49.174,
          "year": 2029
        },
        {
          "debtPct": 50.711,
          "year": 2030
        },
        {
          "debtPct": 52.208,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.323,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.098,
        "realInterestRate": 4.062252112419218
      },
      "historical": [
        {
          "debtPct": 64.565,
          "year": 2022
        },
        {
          "debtPct": 60.951,
          "year": 2023
        },
        {
          "debtPct": 52.53,
          "year": 2024
        },
        {
          "debtPct": 49.351,
          "year": 2025
        }
      ],
      "iso": "lso",
      "name": "Lesotho, Kingdom of",
      "startingDebtPct": 49.351,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.323,
          5.082,
          5.376,
          5.053,
          4.94,
          5.15
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.098,
          0.796,
          1.4,
          1.496,
          1.497,
          1.496
        ],
        "realInterestRate": [
          4.062252112419218,
          12.704683812532913,
          13.770284571476177,
          13.523031063074953,
          14.865773518526026,
          14.799699631243723
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 44.677,
          "year": 2026
        },
        {
          "debtPct": 48.307,
          "year": 2027
        },
        {
          "debtPct": 50.079,
          "year": 2028
        },
        {
          "debtPct": 53.144,
          "year": 2029
        },
        {
          "debtPct": 55.12,
          "year": 2030
        },
        {
          "debtPct": 57.015,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.719,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.698,
        "realInterestRate": 11.756527611713462
      },
      "historical": [
        {
          "debtPct": 38.32,
          "year": 2022
        },
        {
          "debtPct": 37.106,
          "year": 2023
        },
        {
          "debtPct": 37.965,
          "year": 2024
        },
        {
          "debtPct": 39.476,
          "year": 2025
        }
      ],
      "iso": "ltu",
      "name": "Lithuania, Republic of",
      "startingDebtPct": 39.476,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.719,
          -2.078,
          -2.51,
          -2.802,
          -2.948,
          -3.121
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.698,
          2.088,
          2.571,
          2.529,
          2.445,
          2.374
        ],
        "realInterestRate": [
          11.756527611713462,
          5.6343566488349595,
          1.0039931893928378,
          3.067451786177844,
          0.5712881981032814,
          0.09695856313498563
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 28.477,
          "year": 2026
        },
        {
          "debtPct": 30.006,
          "year": 2027
        },
        {
          "debtPct": 32.277,
          "year": 2028
        },
        {
          "debtPct": 34.68,
          "year": 2029
        },
        {
          "debtPct": 37.123,
          "year": 2030
        },
        {
          "debtPct": 39.685,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.227,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.096,
        "realInterestRate": 0.25954890626771476
      },
      "historical": [
        {
          "debtPct": 24.902,
          "year": 2022
        },
        {
          "debtPct": 24.682,
          "year": 2023
        },
        {
          "debtPct": 26.268,
          "year": 2024
        },
        {
          "debtPct": 26.469,
          "year": 2025
        }
      ],
      "iso": "lux",
      "name": "Luxembourg",
      "startingDebtPct": 26.469,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.227,
          -2.195,
          -3.03,
          -3.354,
          -3.537,
          -3.801
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.096,
          1.602,
          2.108,
          2.105,
          2.015,
          1.989
        ],
        "realInterestRate": [
          0.25954890626771476,
          -0.7741959476068483,
          -0.4748158368326316,
          -0.9033915791430425,
          -1.203120242214517,
          -1.4149374781132984
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 47.03,
          "year": 2026
        },
        {
          "debtPct": 48.622,
          "year": 2027
        },
        {
          "debtPct": 50.301,
          "year": 2028
        },
        {
          "debtPct": 51.823,
          "year": 2029
        },
        {
          "debtPct": 53.417,
          "year": 2030
        },
        {
          "debtPct": 54.894,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.01,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.267,
        "realInterestRate": -1.8051839529080516
      },
      "historical": [
        {
          "debtPct": 44.443,
          "year": 2022
        },
        {
          "debtPct": 44.43,
          "year": 2023
        },
        {
          "debtPct": 46.25,
          "year": 2024
        },
        {
          "debtPct": 46.887,
          "year": 2025
        }
      ],
      "iso": "lva",
      "name": "Latvia, Republic of",
      "startingDebtPct": 46.887,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.01,
          -3.089,
          -2.811,
          -2.642,
          -2.745,
          -2.77
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.267,
          1.802,
          2.135,
          2.022,
          2.002,
          2.004
        ],
        "realInterestRate": [
          -1.8051839529080516,
          -1.4384336381033425,
          -0.2428705112911822,
          -0.2496176616767265,
          -0.26348640565000414,
          -0.46508609618661767
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 66.617,
          "year": 2026
        },
        {
          "debtPct": 66.153,
          "year": 2027
        },
        {
          "debtPct": 65.252,
          "year": 2028
        },
        {
          "debtPct": 63.878,
          "year": 2029
        },
        {
          "debtPct": 62.628,
          "year": 2030
        },
        {
          "debtPct": 61.627,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.563,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.501,
        "realInterestRate": 2.136539272836524
      },
      "historical": [
        {
          "debtPct": 71.372,
          "year": 2022
        },
        {
          "debtPct": 68.433,
          "year": 2023
        },
        {
          "debtPct": 66.989,
          "year": 2024
        },
        {
          "debtPct": 66.56,
          "year": 2025
        }
      ],
      "iso": "mar",
      "name": "Morocco",
      "startingDebtPct": 66.56,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.563,
          -1.307,
          -1.236,
          -0.958,
          -0.868,
          -0.855
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.501,
          4.192,
          4.388,
          4.411,
          4.141,
          4.037
        ],
        "realInterestRate": [
          2.136539272836524,
          1.4220759265652916,
          1.0158603237947927,
          0.6795212407282758,
          0.6880015028648323,
          0.9538315769304528
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 41.751,
          "year": 2026
        },
        {
          "debtPct": 43.642,
          "year": 2027
        },
        {
          "debtPct": 46.09,
          "year": 2028
        },
        {
          "debtPct": 47.681,
          "year": 2029
        },
        {
          "debtPct": 48.599,
          "year": 2030
        },
        {
          "debtPct": 49.169,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.289,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.515,
        "realInterestRate": -0.3910931680187857
      },
      "historical": [
        {
          "debtPct": 35.042,
          "year": 2022
        },
        {
          "debtPct": 34.945,
          "year": 2023
        },
        {
          "debtPct": 38.777,
          "year": 2024
        },
        {
          "debtPct": 39.198,
          "year": 2025
        }
      ],
      "iso": "mda",
      "name": "Moldova, Republic of",
      "startingDebtPct": 39.198,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.289,
          -3.838,
          -3.919,
          -3.372,
          -2.779,
          -2.643
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.515,
          2.319,
          3.2,
          3.48,
          3.45,
          3.45
        ],
        "realInterestRate": [
          -0.3910931680187857,
          -2.45250470647409,
          -0.27846569818065214,
          -0.5186522022130879,
          -0.5876764329607265,
          -0.9626803020638341
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 49.763,
          "year": 2026
        },
        {
          "debtPct": 50.626,
          "year": 2027
        },
        {
          "debtPct": 50.913,
          "year": 2028
        },
        {
          "debtPct": 50.859,
          "year": 2029
        },
        {
          "debtPct": 49.915,
          "year": 2030
        },
        {
          "debtPct": 49.667,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.616,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.806,
        "realInterestRate": 0.32746522294593294
      },
      "historical": [
        {
          "debtPct": 49.836,
          "year": 2022
        },
        {
          "debtPct": 52.149,
          "year": 2023
        },
        {
          "debtPct": 49.805,
          "year": 2024
        },
        {
          "debtPct": 47.747,
          "year": 2025
        }
      ],
      "iso": "mdg",
      "name": "Madagascar, Republic of",
      "startingDebtPct": 47.747,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.616,
          -2.997,
          -3.02,
          -3.016,
          -3.02,
          -3.044
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.806,
          4.514,
          4.627,
          4.728,
          4.833,
          4.843
        ],
        "realInterestRate": [
          0.32746522294593294,
          0.03209826577978969,
          -1.0211964010587549,
          -1.5869875277433998,
          -3.3377861342142046,
          -2.0716179705499216
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 130.674,
          "year": 2026
        },
        {
          "debtPct": 130.306,
          "year": 2027
        },
        {
          "debtPct": 130.063,
          "year": 2028
        },
        {
          "debtPct": 130.062,
          "year": 2029
        },
        {
          "debtPct": 130.467,
          "year": 2030
        },
        {
          "debtPct": 130.644,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -9.342,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.985,
        "realInterestRate": -5.293779217165473
      },
      "historical": [
        {
          "debtPct": 111.588,
          "year": 2022
        },
        {
          "debtPct": 122.434,
          "year": 2023
        },
        {
          "debtPct": 133.364,
          "year": 2024
        },
        {
          "debtPct": 129.376,
          "year": 2025
        }
      ],
      "iso": "mdv",
      "name": "Maldives",
      "startingDebtPct": 129.376,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -9.342,
          -4.715,
          -3.843,
          -3.854,
          -3.861,
          -3.269
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.985,
          3.819,
          3.862,
          4,
          4,
          4.029
        ],
        "realInterestRate": [
          -5.293779217165473,
          -0.21938542479760237,
          0.6052034442005638,
          0.9174938299132185,
          1.2365179683535565,
          1.5635668406570158
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 62.094,
          "year": 2026
        },
        {
          "debtPct": 62.895,
          "year": 2027
        },
        {
          "debtPct": 63.382,
          "year": 2028
        },
        {
          "debtPct": 63.963,
          "year": 2029
        },
        {
          "debtPct": 64.295,
          "year": 2030
        },
        {
          "debtPct": 64.493,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.666,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.515,
        "realInterestRate": 4.955349440570789
      },
      "historical": [
        {
          "debtPct": 53.803,
          "year": 2022
        },
        {
          "debtPct": 52.745,
          "year": 2023
        },
        {
          "debtPct": 59.001,
          "year": 2024
        },
        {
          "debtPct": 61.67,
          "year": 2025
        }
      ],
      "iso": "mex",
      "name": "Mexico",
      "startingDebtPct": 61.67,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.666,
          1.776,
          1.941,
          1.895,
          1.956,
          2.177
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.515,
          1.751,
          2.154,
          2.149,
          2.092,
          2.092
        ],
        "realInterestRate": [
          4.955349440570789,
          5.973828727413277,
          6.097555322362624,
          6.139421949449364,
          5.743900254834844,
          5.863187495139588
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 13.915,
          "year": 2026
        },
        {
          "debtPct": 12.637,
          "year": 2027
        },
        {
          "debtPct": 11.991,
          "year": 2028
        },
        {
          "debtPct": 11.503,
          "year": 2029
        },
        {
          "debtPct": 11.096,
          "year": 2030
        },
        {
          "debtPct": 14.25,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -5.948,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3,
        "realInterestRate": -6.227745400525652
      },
      "historical": [
        {
          "debtPct": 19.559,
          "year": 2022
        },
        {
          "debtPct": 17.154,
          "year": 2023
        },
        {
          "debtPct": 14.295,
          "year": 2024
        },
        {
          "debtPct": 8.751,
          "year": 2025
        }
      ],
      "iso": "mhl",
      "name": "Marshall Islands, Republic of the",
      "startingDebtPct": 8.751,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -5.948,
          0.428,
          0.204,
          0.143,
          0.119,
          -3.433
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3,
          2.2,
          1.916,
          1.79,
          1.65,
          1.65
        ],
        "realInterestRate": [
          -6.227745400525652,
          -4.042903341717552,
          -1.6486808577985235,
          -1.138658994245667,
          -0.8950056506998205,
          -0.9059075342465861
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 53.79,
          "year": 2026
        },
        {
          "debtPct": 54.596,
          "year": 2027
        },
        {
          "debtPct": 54.738,
          "year": 2028
        },
        {
          "debtPct": 54.989,
          "year": 2029
        },
        {
          "debtPct": 55.428,
          "year": 2030
        },
        {
          "debtPct": 55.958,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.146,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.5,
        "realInterestRate": -0.35825491873395787
      },
      "historical": [
        {
          "debtPct": 50.928,
          "year": 2022
        },
        {
          "debtPct": 50.587,
          "year": 2023
        },
        {
          "debtPct": 54.005,
          "year": 2024
        },
        {
          "debtPct": 52.605,
          "year": 2025
        }
      ],
      "iso": "mkd",
      "name": "North Macedonia, Republic of",
      "startingDebtPct": 52.605,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.146,
          -2.385,
          -1.539,
          -0.99,
          -0.797,
          -0.7
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.5,
          3.2,
          3,
          3,
          3,
          3
        ],
        "realInterestRate": [
          -0.35825491873395787,
          0.17057445621861955,
          0.3644406183603177,
          1.6094303774343288,
          2.3294295222680894,
          2.6840946813884825
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 39.712,
          "year": 2026
        },
        {
          "debtPct": 39.027,
          "year": 2027
        },
        {
          "debtPct": 38.905,
          "year": 2028
        },
        {
          "debtPct": 39.078,
          "year": 2029
        },
        {
          "debtPct": 39.365,
          "year": 2030
        },
        {
          "debtPct": 39.759,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.3,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.5,
        "realInterestRate": 0.5400054581090163
      },
      "historical": [
        {
          "debtPct": 42.946,
          "year": 2022
        },
        {
          "debtPct": 44.242,
          "year": 2023
        },
        {
          "debtPct": 43.955,
          "year": 2024
        },
        {
          "debtPct": 40.307,
          "year": 2025
        }
      ],
      "iso": "mli",
      "name": "Mali",
      "startingDebtPct": 40.307,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.3,
          -1.178,
          -0.981,
          -1.072,
          -1.174,
          -1.221
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.5,
          5.7,
          5.5,
          5.25,
          5.25,
          5.25
        ],
        "realInterestRate": [
          0.5400054581090163,
          0.7413200040290002,
          2.518307838163314,
          2.817928286852589,
          2.8610151491887947,
          3.038854312206274
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 46.45,
          "year": 2026
        },
        {
          "debtPct": 46.367,
          "year": 2027
        },
        {
          "debtPct": 45.993,
          "year": 2028
        },
        {
          "debtPct": 45.464,
          "year": 2029
        },
        {
          "debtPct": 44.941,
          "year": 2030
        },
        {
          "debtPct": 44.38,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.533,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.2,
        "realInterestRate": 1.2865762080979781
      },
      "historical": [
        {
          "debtPct": 50.146,
          "year": 2022
        },
        {
          "debtPct": 46.943,
          "year": 2023
        },
        {
          "debtPct": 46.02,
          "year": 2024
        },
        {
          "debtPct": 46.209,
          "year": 2025
        }
      ],
      "iso": "mlt",
      "name": "Malta",
      "startingDebtPct": 46.209,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.533,
          -1.256,
          -0.963,
          -0.761,
          -0.768,
          -0.682
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.2,
          4,
          4,
          4,
          4,
          4
        ],
        "realInterestRate": [
          1.2865762080979781,
          1.002023681377806,
          1.0011430543274358,
          1.0830343747961546,
          1.0468062642970288,
          1.1235175007231701
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 53.309,
          "year": 2026
        },
        {
          "debtPct": 54.586,
          "year": 2027
        },
        {
          "debtPct": 55.285,
          "year": 2028
        },
        {
          "debtPct": 55.261,
          "year": 2029
        },
        {
          "debtPct": 55.683,
          "year": 2030
        },
        {
          "debtPct": 55.961,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.574,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.046,
        "realInterestRate": -0.3387204758513285
      },
      "historical": [
        {
          "debtPct": 55.965,
          "year": 2022
        },
        {
          "debtPct": 53.205,
          "year": 2023
        },
        {
          "debtPct": 50.667,
          "year": 2024
        },
        {
          "debtPct": 51.949,
          "year": 2025
        }
      ],
      "iso": "mmr",
      "name": "Myanmar",
      "startingDebtPct": 51.949,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.574,
          -2.509,
          -1.833,
          -1.168,
          -1.138,
          -1.028
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.046,
          2.042,
          1.562,
          1.207,
          0.851,
          0.851
        ],
        "realInterestRate": [
          -0.3387204758513285,
          -0.3162461498058322,
          -0.5479056168248397,
          -0.9751243375237251,
          -0.4556957890736735,
          -0.5073723937287777
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 66.769,
          "year": 2026
        },
        {
          "debtPct": 61.127,
          "year": 2027
        },
        {
          "debtPct": 61.775,
          "year": 2028
        },
        {
          "debtPct": 62.45,
          "year": 2029
        },
        {
          "debtPct": 63.706,
          "year": 2030
        },
        {
          "debtPct": 64.882,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.604,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3,
        "realInterestRate": 5.70070866141732
      },
      "historical": [
        {
          "debtPct": 69.01,
          "year": 2022
        },
        {
          "debtPct": 58.38,
          "year": 2023
        },
        {
          "debtPct": 59.832,
          "year": 2024
        },
        {
          "debtPct": 63.5,
          "year": 2025
        }
      ],
      "iso": "mne",
      "name": "Montenegro",
      "startingDebtPct": 63.5,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.604,
          -1.602,
          -1.506,
          -1.479,
          -1.515,
          -1.425
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3,
          2.8,
          3,
          3.005,
          2.99,
          3
        ],
        "realInterestRate": [
          5.70070866141732,
          -8.353127948598903,
          1.554255893467693,
          1.6643926345609072,
          2.5628677341873463,
          2.5974162559256664
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 44.144,
          "year": 2026
        },
        {
          "debtPct": 48.323,
          "year": 2027
        },
        {
          "debtPct": 53.581,
          "year": 2028
        },
        {
          "debtPct": 56.538,
          "year": 2029
        },
        {
          "debtPct": 59.464,
          "year": 2030
        },
        {
          "debtPct": 61.745,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.698,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6.199,
        "realInterestRate": 2.451909714666378
      },
      "historical": [
        {
          "debtPct": 64.536,
          "year": 2022
        },
        {
          "debtPct": 46.705,
          "year": 2023
        },
        {
          "debtPct": 44.091,
          "year": 2024
        },
        {
          "debtPct": 45.035,
          "year": 2025
        }
      ],
      "iso": "mng",
      "name": "Mongolia",
      "startingDebtPct": 45.035,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.698,
          -1.554,
          -2.849,
          -2.175,
          -2.189,
          -2.269
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6.199,
          5.853,
          5.602,
          5.102,
          5.01,
          5.016
        ],
        "realInterestRate": [
          2.451909714666378,
          12.147493589162739,
          10.866474846346463,
          6.635934864970783,
          6.378855813788964,
          5.037192519843936
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 91.024,
          "year": 2026
        },
        {
          "debtPct": 98.641,
          "year": 2027
        },
        {
          "debtPct": 104.82,
          "year": 2028
        },
        {
          "debtPct": 109.837,
          "year": 2029
        },
        {
          "debtPct": 108.826,
          "year": 2030
        },
        {
          "debtPct": 98.717,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.641,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.007,
        "realInterestRate": 2.5406633331118478
      },
      "historical": [
        {
          "debtPct": 97.307,
          "year": 2022
        },
        {
          "debtPct": 90.828,
          "year": 2023
        },
        {
          "debtPct": 91.192,
          "year": 2024
        },
        {
          "debtPct": 90.294,
          "year": 2025
        }
      ],
      "iso": "moz",
      "name": "Mozambique, Republic of",
      "startingDebtPct": 90.294,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.641,
          -2.003,
          -2.023,
          -1.997,
          -2.041,
          -1.953
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.007,
          1.96,
          2.557,
          3.081,
          9.812,
          13.106
        ],
        "realInterestRate": [
          2.5406633331118478,
          8.248489189664276,
          6.877991190275856,
          6.05089715703111,
          6.760694665731948,
          0.5696155698086791
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 38.317,
          "year": 2026
        },
        {
          "debtPct": 38.518,
          "year": 2027
        },
        {
          "debtPct": 38.188,
          "year": 2028
        },
        {
          "debtPct": 38.287,
          "year": 2029
        },
        {
          "debtPct": 39.124,
          "year": 2030
        },
        {
          "debtPct": 39.85,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.899,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.377,
        "realInterestRate": 1.3657024838414245
      },
      "historical": [
        {
          "debtPct": 50.124,
          "year": 2022
        },
        {
          "debtPct": 48.599,
          "year": 2023
        },
        {
          "debtPct": 45.23,
          "year": 2024
        },
        {
          "debtPct": 40.381,
          "year": 2025
        }
      ],
      "iso": "mrt",
      "name": "Mauritania, Islamic Republic of",
      "startingDebtPct": 40.381,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.899,
          1.293,
          1.47,
          1.592,
          1.574,
          1.63
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.377,
          4.433,
          5.817,
          4.937,
          3.096,
          3.039
        ],
        "realInterestRate": [
          1.3657024838414245,
          8.504897643343678,
          8.948818370631905,
          9.583707525924346,
          9.588137174497868,
          9.243884060934459
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 87.645,
          "year": 2026
        },
        {
          "debtPct": 88.339,
          "year": 2027
        },
        {
          "debtPct": 88.744,
          "year": 2028
        },
        {
          "debtPct": 88.722,
          "year": 2029
        },
        {
          "debtPct": 88.68,
          "year": 2030
        },
        {
          "debtPct": 88.882,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.452,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.704,
        "realInterestRate": 3.1713849627871493
      },
      "historical": [
        {
          "debtPct": 81.804,
          "year": 2022
        },
        {
          "debtPct": 81.451,
          "year": 2023
        },
        {
          "debtPct": 86.347,
          "year": 2024
        },
        {
          "debtPct": 86.798,
          "year": 2025
        }
      ],
      "iso": "mus",
      "name": "Mauritius",
      "startingDebtPct": 86.798,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.452,
          0.283,
          0.619,
          0.948,
          0.986,
          1.129
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.704,
          3.156,
          3.295,
          3.293,
          3.299,
          3.303
        ],
        "realInterestRate": [
          3.1713849627871493,
          4.30590486622171,
          4.492365602961312,
          4.370811660506613,
          4.3980989382566005,
          4.853476917004951
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 77.955,
          "year": 2026
        },
        {
          "debtPct": 75.008,
          "year": 2027
        },
        {
          "debtPct": 71.775,
          "year": 2028
        },
        {
          "debtPct": 69.62,
          "year": 2029
        },
        {
          "debtPct": 68.331,
          "year": 2030
        },
        {
          "debtPct": 67.509,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.242,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.614,
        "realInterestRate": -18.47987550096828
      },
      "historical": [
        {
          "debtPct": 75.698,
          "year": 2022
        },
        {
          "debtPct": 84.529,
          "year": 2023
        },
        {
          "debtPct": 86.547,
          "year": 2024
        },
        {
          "debtPct": 96.563,
          "year": 2025
        }
      ],
      "iso": "mwi",
      "name": "Malawi",
      "startingDebtPct": 96.563,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.242,
          -1.394,
          -0.489,
          -0.195,
          -0.459,
          -0.645
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.614,
          2.266,
          2.514,
          2.675,
          3,
          3
        ],
        "realInterestRate": [
          -18.47987550096828,
          -3.42878168173949,
          -2.5728855055460853,
          -0.6867032392894434,
          0.41390405056016544,
          0.7886903455240013
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 69.244,
          "year": 2026
        },
        {
          "debtPct": 68.753,
          "year": 2027
        },
        {
          "debtPct": 67.738,
          "year": 2028
        },
        {
          "debtPct": 66.741,
          "year": 2029
        },
        {
          "debtPct": 65.858,
          "year": 2030
        },
        {
          "debtPct": 65.122,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.368,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.2,
        "realInterestRate": 1.2844709219858252
      },
      "historical": [
        {
          "debtPct": 65.464,
          "year": 2022
        },
        {
          "debtPct": 69.662,
          "year": 2023
        },
        {
          "debtPct": 69.806,
          "year": 2024
        },
        {
          "debtPct": 70.5,
          "year": 2025
        }
      ],
      "iso": "mys",
      "name": "Malaysia",
      "startingDebtPct": 70.5,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.368,
          -1.093,
          -0.559,
          -0.576,
          -0.581,
          -0.583
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.2,
          4.6,
          4.3,
          4.3,
          4.3,
          4.3
        ],
        "realInterestRate": [
          1.2844709219858252,
          2.207209288891465,
          1.9122031038645515,
          1.877963624553436,
          2.0121229828740983,
          2.211085972850668
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 67.545,
          "year": 2026
        },
        {
          "debtPct": 67.785,
          "year": 2027
        },
        {
          "debtPct": 68.489,
          "year": 2028
        },
        {
          "debtPct": 69.183,
          "year": 2029
        },
        {
          "debtPct": 70.189,
          "year": 2030
        },
        {
          "debtPct": 71.187,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.558,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.033,
        "realInterestRate": 1.184097040666754
      },
      "historical": [
        {
          "debtPct": 70.053,
          "year": 2022
        },
        {
          "debtPct": 67.244,
          "year": 2023
        },
        {
          "debtPct": 68.461,
          "year": 2024
        },
        {
          "debtPct": 67.549,
          "year": 2025
        }
      ],
      "iso": "nam",
      "name": "Namibia",
      "startingDebtPct": 67.549,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.558,
          0.245,
          0.676,
          0.728,
          0.724,
          0.692
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.033,
          2.669,
          2.965,
          3.124,
          3.021,
          3.036
        ],
        "realInterestRate": [
          1.184097040666754,
          3.406204308238947,
          5.061211551228162,
          5.265107739929031,
          5.597157871153313,
          5.516885038966213
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 46.276,
          "year": 2026
        },
        {
          "debtPct": 45.39,
          "year": 2027
        },
        {
          "debtPct": 44.788,
          "year": 2028
        },
        {
          "debtPct": 44.207,
          "year": 2029
        },
        {
          "debtPct": 43.769,
          "year": 2030
        },
        {
          "debtPct": 43.411,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.699,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6.999,
        "realInterestRate": 4.750174001844787
      },
      "historical": [
        {
          "debtPct": 50.674,
          "year": 2022
        },
        {
          "debtPct": 51.352,
          "year": 2023
        },
        {
          "debtPct": 48.059,
          "year": 2024
        },
        {
          "debtPct": 45.534,
          "year": 2025
        }
      ],
      "iso": "ner",
      "name": "Niger",
      "startingDebtPct": 45.534,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.699,
          -1.241,
          -1.279,
          -1.527,
          -1.602,
          -1.7
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6.999,
          6.547,
          6.01,
          6,
          6.02,
          6
        ],
        "realInterestRate": [
          4.750174001844787,
          1.6497429120926554,
          1.6168559153998618,
          1.0109850852907165,
          1.1275440541090864,
          1.0159245127830285
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 34.647,
          "year": 2026
        },
        {
          "debtPct": 32.752,
          "year": 2027
        },
        {
          "debtPct": 32.875,
          "year": 2028
        },
        {
          "debtPct": 32.519,
          "year": 2029
        },
        {
          "debtPct": 32.24,
          "year": 2030
        },
        {
          "debtPct": 31.924,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.959,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.2,
        "realInterestRate": -2.6595973601020617
      },
      "historical": [
        {
          "debtPct": 29.838,
          "year": 2022
        },
        {
          "debtPct": 36.336,
          "year": 2023
        },
        {
          "debtPct": 39.333,
          "year": 2024
        },
        {
          "debtPct": 36.062,
          "year": 2025
        }
      ],
      "iso": "nga",
      "name": "Nigeria",
      "startingDebtPct": 36.062,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.959,
          -0.46,
          -0.322,
          -0.335,
          -0.375,
          -0.347
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.2,
          4.324,
          4.132,
          4.235,
          4.186,
          4.181
        ],
        "realInterestRate": [
          -2.6595973601020617,
          -2.767032989869256,
          3.4992976306790435,
          2.044083346007608,
          2.090682062794058,
          2.038568145161257
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 31.738,
          "year": 2026
        },
        {
          "debtPct": 28.77,
          "year": 2027
        },
        {
          "debtPct": 28.372,
          "year": 2028
        },
        {
          "debtPct": 27.906,
          "year": 2029
        },
        {
          "debtPct": 27.011,
          "year": 2030
        },
        {
          "debtPct": 26.781,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 3.462,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.84,
        "realInterestRate": 5.540034071550259
      },
      "historical": [
        {
          "debtPct": 45.919,
          "year": 2022
        },
        {
          "debtPct": 42.391,
          "year": 2023
        },
        {
          "debtPct": 37.865,
          "year": 2024
        },
        {
          "debtPct": 34.633,
          "year": 2025
        }
      ],
      "iso": "nic",
      "name": "Nicaragua",
      "startingDebtPct": 34.633,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          3.462,
          3.588,
          3.598,
          3.857,
          3.821,
          3.955
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.84,
          3.8,
          3.53,
          3.53,
          3.53,
          3.53
        ],
        "realInterestRate": [
          5.540034071550259,
          5.827727014934769,
          15.045328467153274,
          15.903827365007729,
          14.385327886476018,
          17.807488800858895
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 45.417,
          "year": 2026
        },
        {
          "debtPct": 45.653,
          "year": 2027
        },
        {
          "debtPct": 45.766,
          "year": 2028
        },
        {
          "debtPct": 46.302,
          "year": 2029
        },
        {
          "debtPct": 47.103,
          "year": 2030
        },
        {
          "debtPct": 48.017,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.028,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.531,
        "realInterestRate": -1.5018768250419257
      },
      "historical": [
        {
          "debtPct": 48.414,
          "year": 2022
        },
        {
          "debtPct": 45.85,
          "year": 2023
        },
        {
          "debtPct": 44.031,
          "year": 2024
        },
        {
          "debtPct": 44.725,
          "year": 2025
        }
      ],
      "iso": "nld",
      "name": "Netherlands, The",
      "startingDebtPct": 44.725,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.028,
          -1.562,
          -1.199,
          -1.155,
          -1.266,
          -1.301
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.531,
          1.318,
          1.38,
          1.288,
          1.205,
          1.19
        ],
        "realInterestRate": [
          -1.5018768250419257,
          -1.640092080058131,
          -1.0316417321972304,
          -0.08195306559454218,
          0.18862219774524736,
          0.358619196229526
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 40,
          "year": 2026
        },
        {
          "debtPct": 40,
          "year": 2027
        },
        {
          "debtPct": 36.5,
          "year": 2028
        },
        {
          "debtPct": 33,
          "year": 2029
        },
        {
          "debtPct": 29.5,
          "year": 2030
        },
        {
          "debtPct": 26,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 8.731,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.538,
        "realInterestRate": -8.369476333333326
      },
      "historical": [
        {
          "debtPct": 34.829,
          "year": 2022
        },
        {
          "debtPct": 42.438,
          "year": 2023
        },
        {
          "debtPct": 52.818,
          "year": 2024
        },
        {
          "debtPct": 54,
          "year": 2025
        }
      ],
      "iso": "nor",
      "name": "Norway",
      "startingDebtPct": 54,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          8.731,
          7.787,
          5.77,
          5.393,
          4.943,
          4.552
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.538,
          1.334,
          1.131,
          1.135,
          1.139,
          1.144
        ],
        "realInterestRate": [
          -8.369476333333326,
          21.061196449999976,
          6.870184249999989,
          6.380165890410949,
          5.561532636363631,
          4.750897898305073
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 49.364,
          "year": 2026
        },
        {
          "debtPct": 50.646,
          "year": 2027
        },
        {
          "debtPct": 50.97,
          "year": 2028
        },
        {
          "debtPct": 49.872,
          "year": 2029
        },
        {
          "debtPct": 48.831,
          "year": 2030
        },
        {
          "debtPct": 47.674,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.367,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.6,
        "realInterestRate": 7.025010014969735
      },
      "historical": [
        {
          "debtPct": 42.73,
          "year": 2022
        },
        {
          "debtPct": 46.962,
          "year": 2023
        },
        {
          "debtPct": 47.904,
          "year": 2024
        },
        {
          "debtPct": 47.429,
          "year": 2025
        }
      ],
      "iso": "npl",
      "name": "Nepal",
      "startingDebtPct": 47.429,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.367,
          -3.308,
          -3.36,
          -1.737,
          -1.607,
          -1.297
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.6,
          3.748,
          5.742,
          5.124,
          5.031,
          5.024
        ],
        "realInterestRate": [
          7.025010014969735,
          -0.510031115792875,
          -0.596757493188016,
          -0.7230971159505661,
          -0.5457181584856974,
          -0.253977022792895
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 2.561,
          "year": 2026
        },
        {
          "debtPct": 1.587,
          "year": 2027
        },
        {
          "debtPct": 1.155,
          "year": 2028
        },
        {
          "debtPct": 0.429,
          "year": 2029
        },
        {
          "debtPct": 0.124,
          "year": 2030
        },
        {
          "debtPct": 0.119,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.127,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 18.891,
          "year": 2022
        },
        {
          "debtPct": 19.244,
          "year": 2023
        },
        {
          "debtPct": 16.462,
          "year": 2024
        },
        {
          "debtPct": 12.157,
          "year": 2025
        }
      ],
      "iso": "nru",
      "name": "Naoero, Republic of",
      "startingDebtPct": 12.157,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.127,
          2.022,
          1.955,
          1.982,
          1.969,
          2.028
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 57.138,
          "year": 2026
        },
        {
          "debtPct": 57.979,
          "year": 2027
        },
        {
          "debtPct": 57.816,
          "year": 2028
        },
        {
          "debtPct": 57.11,
          "year": 2029
        },
        {
          "debtPct": 56.274,
          "year": 2030
        },
        {
          "debtPct": 55.4,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.155,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.031,
        "realInterestRate": 0.634719597310518
      },
      "historical": [
        {
          "debtPct": 46.906,
          "year": 2022
        },
        {
          "debtPct": 47.294,
          "year": 2023
        },
        {
          "debtPct": 51.376,
          "year": 2024
        },
        {
          "debtPct": 54.732,
          "year": 2025
        }
      ],
      "iso": "nzl",
      "name": "New Zealand",
      "startingDebtPct": 54.732,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.155,
          -2.271,
          -1.127,
          -0.305,
          0.24,
          0.513
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.031,
          2.556,
          2.697,
          2.537,
          2.353,
          2.407
        ],
        "realInterestRate": [
          0.634719597310518,
          -0.010682067975775755,
          0.4120497593956385,
          0.743985834371097,
          1.2848440203116818,
          1.7500549276753041
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 31.066,
          "year": 2026
        },
        {
          "debtPct": 29.782,
          "year": 2027
        },
        {
          "debtPct": 30.114,
          "year": 2028
        },
        {
          "debtPct": 29.825,
          "year": 2029
        },
        {
          "debtPct": 29.369,
          "year": 2030
        },
        {
          "debtPct": 29.036,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 6.117,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.123,
        "realInterestRate": 11.657308329007332
      },
      "historical": [
        {
          "debtPct": 41.673,
          "year": 2022
        },
        {
          "debtPct": 37.392,
          "year": 2023
        },
        {
          "debtPct": 35.452,
          "year": 2024
        },
        {
          "debtPct": 34.674,
          "year": 2025
        }
      ],
      "iso": "omn",
      "name": "Oman",
      "startingDebtPct": 34.674,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          6.117,
          6.588,
          6.258,
          5.518,
          4.986,
          4.645
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.123,
          2.215,
          2.494,
          2.894,
          2.98,
          2.595
        ],
        "realInterestRate": [
          11.657308329007332,
          19.666501963561434,
          25.17331838022967,
          20.760531380753132,
          18.621220452640408,
          17.65814957948857
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 69.848,
          "year": 2026
        },
        {
          "debtPct": 67.72,
          "year": 2027
        },
        {
          "debtPct": 64.508,
          "year": 2028
        },
        {
          "debtPct": 61.337,
          "year": 2029
        },
        {
          "debtPct": 59.554,
          "year": 2030
        },
        {
          "debtPct": 57.35,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 2.908,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.6,
        "realInterestRate": 3.584339054791341
      },
      "historical": [
        {
          "debtPct": 77.318,
          "year": 2022
        },
        {
          "debtPct": 78.508,
          "year": 2023
        },
        {
          "debtPct": 70.28,
          "year": 2024
        },
        {
          "debtPct": 72.767,
          "year": 2025
        }
      ],
      "iso": "pak",
      "name": "Pakistan",
      "startingDebtPct": 72.767,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          2.908,
          2.012,
          2.048,
          2.046,
          1.019,
          -0.01
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.6,
          3.5,
          4.3,
          4.5,
          4.5,
          4.5
        ],
        "realInterestRate": [
          3.584339054791341,
          3.3281124727980727,
          2.5072474896633112,
          2.677551621504315,
          3.198371293020519,
          0.6150720354636041
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 56.369,
          "year": 2026
        },
        {
          "debtPct": 55.943,
          "year": 2027
        },
        {
          "debtPct": 54.916,
          "year": 2028
        },
        {
          "debtPct": 53.458,
          "year": 2029
        },
        {
          "debtPct": 51.612,
          "year": 2030
        },
        {
          "debtPct": 49.619,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.409,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5,
        "realInterestRate": 3.8457459969601704
      },
      "historical": [
        {
          "debtPct": 56.199,
          "year": 2022
        },
        {
          "debtPct": 54.418,
          "year": 2023
        },
        {
          "debtPct": 57.814,
          "year": 2024
        },
        {
          "debtPct": 56.582,
          "year": 2025
        }
      ],
      "iso": "pan",
      "name": "Panama",
      "startingDebtPct": 56.582,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.409,
          0.013,
          0.45,
          0.851,
          1.352,
          1.29
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5,
          4.2,
          4.6,
          4.754,
          4.6,
          4.54
        ],
        "realInterestRate": [
          3.8457459969601704,
          3.4365555535844194,
          3.5211483116743825,
          3.596128377886232,
          3.6334019230049863,
          3.11607494381152
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 28.608,
          "year": 2026
        },
        {
          "debtPct": 29.04,
          "year": 2027
        },
        {
          "debtPct": 29.399,
          "year": 2028
        },
        {
          "debtPct": 29.777,
          "year": 2029
        },
        {
          "debtPct": 30.064,
          "year": 2030
        },
        {
          "debtPct": 30.165,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.05,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.997,
        "realInterestRate": -2.4253333554486556
      },
      "historical": [
        {
          "debtPct": 33.452,
          "year": 2022
        },
        {
          "debtPct": 32.408,
          "year": 2023
        },
        {
          "debtPct": 32.065,
          "year": 2024
        },
        {
          "debtPct": 30.145,
          "year": 2025
        }
      ],
      "iso": "per",
      "name": "Peru",
      "startingDebtPct": 30.145,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.05,
          -0.195,
          -0.184,
          -0.15,
          -0.094,
          -0.082
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.997,
          2.866,
          3.214,
          3,
          3,
          3
        ],
        "realInterestRate": [
          -2.4253333554486556,
          3.718182676174475,
          3.8359851928374766,
          3.798802680363278,
          3.6675957954125593,
          3.0650944651410272
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 60.541,
          "year": 2026
        },
        {
          "debtPct": 60.512,
          "year": 2027
        },
        {
          "debtPct": 60.438,
          "year": 2028
        },
        {
          "debtPct": 59.664,
          "year": 2029
        },
        {
          "debtPct": 58.235,
          "year": 2030
        },
        {
          "debtPct": 56.419,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.25,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.411,
        "realInterestRate": 3.6925689328598077
      },
      "historical": [
        {
          "debtPct": 57.389,
          "year": 2022
        },
        {
          "debtPct": 56.484,
          "year": 2023
        },
        {
          "debtPct": 56.623,
          "year": 2024
        },
        {
          "debtPct": 59.13,
          "year": 2025
        }
      ],
      "iso": "phl",
      "name": "Philippines",
      "startingDebtPct": 59.13,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.25,
          -0.813,
          -0.212,
          0.302,
          0.869,
          1.286
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.411,
          5.054,
          5.464,
          5.837,
          5.85,
          5.78
        ],
        "realInterestRate": [
          3.6925689328598077,
          3.59291630465306,
          4.965541776837656,
          5.01044941923956,
          4.856503083936703,
          4.8172902893449
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 53.79,
          "year": 2026
        },
        {
          "debtPct": 55.495,
          "year": 2027
        },
        {
          "debtPct": 53.511,
          "year": 2028
        },
        {
          "debtPct": 50.639,
          "year": 2029
        },
        {
          "debtPct": 45.766,
          "year": 2030
        },
        {
          "debtPct": 41.034,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.336,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 70.086,
          "year": 2022
        },
        {
          "debtPct": 71.199,
          "year": 2023
        },
        {
          "debtPct": 60.083,
          "year": 2024
        },
        {
          "debtPct": 52.837,
          "year": 2025
        }
      ],
      "iso": "plw",
      "name": "Palau, Republic of",
      "startingDebtPct": 52.837,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.336,
          2.666,
          2.38,
          2.224,
          2.051,
          2.101
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 46.761,
          "year": 2026
        },
        {
          "debtPct": 42.017,
          "year": 2027
        },
        {
          "debtPct": 39.065,
          "year": 2028
        },
        {
          "debtPct": 36.568,
          "year": 2029
        },
        {
          "debtPct": 34.147,
          "year": 2030
        },
        {
          "debtPct": 31.898,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.367,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.087,
        "realInterestRate": -3.8940970091430493
      },
      "historical": [
        {
          "debtPct": 49.231,
          "year": 2022
        },
        {
          "debtPct": 54.799,
          "year": 2023
        },
        {
          "debtPct": 53.335,
          "year": 2024
        },
        {
          "debtPct": 51.624,
          "year": 2025
        }
      ],
      "iso": "png",
      "name": "Papua New Guinea",
      "startingDebtPct": 51.624,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.367,
          2.191,
          1.984,
          1.794,
          1.724,
          1.564
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.087,
          4.004,
          3.442,
          3.1,
          3.1,
          3.1
        ],
        "realInterestRate": [
          -3.8940970091430493,
          -1.674283441329294,
          1.0588727895851635,
          1.2446486624855702,
          1.1348747538831638,
          1.0317802442381563
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 66.602,
          "year": 2026
        },
        {
          "debtPct": 70.732,
          "year": 2027
        },
        {
          "debtPct": 73.744,
          "year": 2028
        },
        {
          "debtPct": 76.99,
          "year": 2029
        },
        {
          "debtPct": 79.793,
          "year": 2030
        },
        {
          "debtPct": 82.017,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -4.471,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.386,
        "realInterestRate": 7.6283563888609685
      },
      "historical": [
        {
          "debtPct": 48.787,
          "year": 2022
        },
        {
          "debtPct": 49.521,
          "year": 2023
        },
        {
          "debtPct": 54.847,
          "year": 2024
        },
        {
          "debtPct": 59.682,
          "year": 2025
        }
      ],
      "iso": "pol",
      "name": "Poland, Republic of",
      "startingDebtPct": 59.682,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -4.471,
          -4.093,
          -3.869,
          -3.368,
          -2.912,
          -2.423
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.386,
          2.535,
          2.457,
          2.491,
          2.476,
          2.475
        ],
        "realInterestRate": [
          7.6283563888609685,
          2.5919621783129454,
          1.215614926765829,
          2.3214417715339497,
          2.330917729575277,
          2.219432155702883
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 18.168,
          "year": 2026
        },
        {
          "debtPct": 18.514,
          "year": 2027
        },
        {
          "debtPct": 18.601,
          "year": 2028
        },
        {
          "debtPct": 18.304,
          "year": 2029
        },
        {
          "debtPct": 17.983,
          "year": 2030
        },
        {
          "debtPct": 17.646,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.359,
        "realFxAppreciation": 0,
        "realGdpGrowth": -0.1,
        "realInterestRate": 5.35332991803279
      },
      "historical": [
        {
          "debtPct": 16.687,
          "year": 2022
        },
        {
          "debtPct": 16.582,
          "year": 2023
        },
        {
          "debtPct": 16.844,
          "year": 2024
        },
        {
          "debtPct": 17.568,
          "year": 2025
        }
      ],
      "iso": "pri",
      "name": "Puerto Rico",
      "startingDebtPct": 17.568,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.359,
          0.352,
          0.125,
          0.474,
          0.466,
          0.458
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -0.1,
          1,
          0.6,
          0.8,
          0.8,
          0.8
        ],
        "realInterestRate": [
          5.35332991803279,
          4.880339057683836,
          1.751949875769676,
          1.7591742379442055,
          1.5985139860140052,
          1.478240560529387
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 85.138,
          "year": 2026
        },
        {
          "debtPct": 81.029,
          "year": 2027
        },
        {
          "debtPct": 77.892,
          "year": 2028
        },
        {
          "debtPct": 75.342,
          "year": 2029
        },
        {
          "debtPct": 73.364,
          "year": 2030
        },
        {
          "debtPct": 71.972,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.851,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.082,
        "realInterestRate": -0.97010039032005
      },
      "historical": [
        {
          "debtPct": 111.232,
          "year": 2022
        },
        {
          "debtPct": 96.869,
          "year": 2023
        },
        {
          "debtPct": 93.484,
          "year": 2024
        },
        {
          "debtPct": 89.67,
          "year": 2025
        }
      ],
      "iso": "prt",
      "name": "Portugal",
      "startingDebtPct": 89.67,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.851,
          1.931,
          1.671,
          1.38,
          1.05,
          0.654
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.082,
          1.882,
          1.84,
          1.7,
          1.65,
          1.6
        ],
        "realInterestRate": [
          -0.97010039032005,
          -0.7243449458526285,
          -0.0025186044502634175,
          0.17238484054844516,
          0.39795996920708454,
          0.5779619431873773
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 36.561,
          "year": 2026
        },
        {
          "debtPct": 37.927,
          "year": 2027
        },
        {
          "debtPct": 37.13,
          "year": 2028
        },
        {
          "debtPct": 36.599,
          "year": 2029
        },
        {
          "debtPct": 36.246,
          "year": 2030
        },
        {
          "debtPct": 35.923,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.411,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.5,
        "realInterestRate": -3.828480913232457
      },
      "historical": [
        {
          "debtPct": 40.636,
          "year": 2022
        },
        {
          "debtPct": 41.039,
          "year": 2023
        },
        {
          "debtPct": 44.633,
          "year": 2024
        },
        {
          "debtPct": 38.194,
          "year": 2025
        }
      ],
      "iso": "pry",
      "name": "Paraguay",
      "startingDebtPct": 38.194,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.411,
          -1.387,
          0.842,
          0.629,
          0.452,
          0.367
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.5,
          4,
          3.8,
          3.8,
          3.8,
          3.8
        ],
        "realInterestRate": [
          -3.828480913232457,
          3.940264215967848,
          3.9231576449495265,
          4.073967142472368,
          4.080778163337828,
          3.926005628207263
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 46.396,
          "year": 2026
        },
        {
          "debtPct": 39.529,
          "year": 2027
        },
        {
          "debtPct": 37.606,
          "year": 2028
        },
        {
          "debtPct": 36.806,
          "year": 2029
        },
        {
          "debtPct": 35.992,
          "year": 2030
        },
        {
          "debtPct": 35.67,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.382,
        "realFxAppreciation": 0,
        "realGdpGrowth": -15.583,
        "realInterestRate": -10.515793288590602
      },
      "historical": [
        {
          "debtPct": 42.565,
          "year": 2022
        },
        {
          "debtPct": 42.806,
          "year": 2023
        },
        {
          "debtPct": 41.401,
          "year": 2024
        },
        {
          "debtPct": 42.465,
          "year": 2025
        }
      ],
      "iso": "qat",
      "name": "Qatar",
      "startingDebtPct": 42.465,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.382,
          0.536,
          3.265,
          4.949,
          5.872,
          5.964
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -15.583,
          18.755,
          11.149,
          5.472,
          5.24,
          3.318
        ],
        "realInterestRate": [
          -10.515793288590602,
          2.5501999094749594,
          14.92248169698196,
          17.108529489975012,
          19.702422431125342,
          19.513825627917324
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 62.64,
          "year": 2026
        },
        {
          "debtPct": 64.886,
          "year": 2027
        },
        {
          "debtPct": 66.107,
          "year": 2028
        },
        {
          "debtPct": 68.113,
          "year": 2029
        },
        {
          "debtPct": 69.828,
          "year": 2030
        },
        {
          "debtPct": 71.314,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.228,
        "realFxAppreciation": 0,
        "realGdpGrowth": -0.545,
        "realInterestRate": -2.2479120551888387
      },
      "historical": [
        {
          "debtPct": 51.902,
          "year": 2022
        },
        {
          "debtPct": 52.595,
          "year": 2023
        },
        {
          "debtPct": 57.468,
          "year": 2024
        },
        {
          "debtPct": 60.447,
          "year": 2025
        }
      ],
      "iso": "rou",
      "name": "Romania",
      "startingDebtPct": 60.447,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.228,
          -2.902,
          -2.568,
          -2.125,
          -1.871,
          -1.451
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -0.545,
          2.237,
          2.485,
          2.781,
          2.867,
          2.98
        ],
        "realInterestRate": [
          -2.2479120551888387,
          1.166318773946351,
          0.35746409086705455,
          2.5959826947222098,
          2.63140250759768,
          3.0316168299249657
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 19.309,
          "year": 2026
        },
        {
          "debtPct": 22.19,
          "year": 2027
        },
        {
          "debtPct": 24.806,
          "year": 2028
        },
        {
          "debtPct": 27.164,
          "year": 2029
        },
        {
          "debtPct": 29.144,
          "year": 2030
        },
        {
          "debtPct": 30.707,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.105,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.867,
        "realInterestRate": 4.619031048411415
      },
      "historical": [
        {
          "debtPct": 15.134,
          "year": 2022
        },
        {
          "debtPct": 15.19,
          "year": 2023
        },
        {
          "debtPct": 14.758,
          "year": 2024
        },
        {
          "debtPct": 16.587,
          "year": 2025
        }
      ],
      "iso": "rus",
      "name": "Russian Federation",
      "startingDebtPct": 16.587,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.105,
          -2.406,
          -2.361,
          -2.071,
          -1.997,
          -1.858
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.867,
          0.924,
          1,
          1,
          1,
          1
        ],
        "realInterestRate": [
          4.619031048411415,
          3.4067230825003847,
          2.1606579540333515,
          2.1685479319519363,
          0.9367913414813689,
          -0.022337359319235528
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 63.379,
          "year": 2026
        },
        {
          "debtPct": 63.366,
          "year": 2027
        },
        {
          "debtPct": 63.347,
          "year": 2028
        },
        {
          "debtPct": 62.04,
          "year": 2029
        },
        {
          "debtPct": 60.96,
          "year": 2030
        },
        {
          "debtPct": 59.856,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.234,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7.4,
        "realInterestRate": 3.1890818014563838
      },
      "historical": [
        {
          "debtPct": 59.033,
          "year": 2022
        },
        {
          "debtPct": 61.608,
          "year": 2023
        },
        {
          "debtPct": 63.443,
          "year": 2024
        },
        {
          "debtPct": 64.681,
          "year": 2025
        }
      ],
      "iso": "rwa",
      "name": "Rwanda",
      "startingDebtPct": 64.681,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.234,
          -0.965,
          -1.348,
          -0.606,
          -1.212,
          -1.152
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7.4,
          7.234,
          6.959,
          6.994,
          7.009,
          7.083
        ],
        "realInterestRate": [
          3.1890818014563838,
          5.579274428438441,
          4.65156457721807,
          3.7629153077493704,
          3.055669439071562,
          3.120085826771657
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 35.439,
          "year": 2026
        },
        {
          "debtPct": 37.311,
          "year": 2027
        },
        {
          "debtPct": 40.18,
          "year": 2028
        },
        {
          "debtPct": 43.062,
          "year": 2029
        },
        {
          "debtPct": 45.882,
          "year": 2030
        },
        {
          "debtPct": 48.667,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -5.942,
        "realFxAppreciation": 0,
        "realGdpGrowth": -3.309,
        "realInterestRate": -10.328415173237747
      },
      "historical": [
        {
          "debtPct": 21.308,
          "year": 2022
        },
        {
          "debtPct": 22.984,
          "year": 2023
        },
        {
          "debtPct": 25.854,
          "year": 2024
        },
        {
          "debtPct": 31.806,
          "year": 2025
        }
      ],
      "iso": "sau",
      "name": "Saudi Arabia",
      "startingDebtPct": 31.806,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -5.942,
          -3.265,
          -3.221,
          -3.388,
          -3.451,
          -3.469
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          -3.309,
          7.932,
          4.814,
          3.418,
          3.505,
          3.615
        ],
        "realInterestRate": [
          -10.328415173237747,
          3.689519230226579,
          3.8251621773739863,
          2.115622996515687,
          1.988311156007616,
          2.070327579442921
        ]
      }
    },
    {
      "_caveats": [
        "r computed as 73.22% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 334.411,
          "year": 2026
        },
        {
          "debtPct": 274.123,
          "year": 2027
        },
        {
          "debtPct": 235.549,
          "year": 2028
        },
        {
          "debtPct": 225.169,
          "year": 2029
        },
        {
          "debtPct": 212.007,
          "year": 2030
        },
        {
          "debtPct": 192.159,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.507,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 188.965,
          "year": 2022
        },
        {
          "debtPct": 286.929,
          "year": 2023
        },
        {
          "debtPct": 282.263,
          "year": 2024
        },
        {
          "debtPct": 204.399,
          "year": 2025
        }
      ],
      "iso": "sdn",
      "name": "Sudan",
      "startingDebtPct": 204.399,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.507,
          -4.932,
          -4.039,
          -3.602,
          -2.574,
          -1.981
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7,
          15,
          10,
          8,
          8,
          8
        ],
        "realInterestRate": [
          null,
          -7.428389018303838,
          -7.099732601788233,
          1.5892064920674853,
          0.45238909441354114,
          -3.120066790247489
        ]
      }
    },
    {
      "baselineProjection": [],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": null,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 106.941,
          "year": 2022
        },
        {
          "debtPct": 120.578,
          "year": 2023
        },
        {
          "debtPct": 136.142,
          "year": 2024
        },
        {
          "debtPct": 127.745,
          "year": 2025
        }
      ],
      "iso": "sen",
      "name": "Senegal",
      "startingDebtPct": 127.745,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 166.42,
          "year": 2026
        },
        {
          "debtPct": 167.139,
          "year": 2027
        },
        {
          "debtPct": 167.905,
          "year": 2028
        },
        {
          "debtPct": 168.52,
          "year": 2029
        },
        {
          "debtPct": 168.962,
          "year": 2030
        },
        {
          "debtPct": 169.229,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.963,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 153.329,
          "year": 2022
        },
        {
          "debtPct": 170.41,
          "year": 2023
        },
        {
          "debtPct": 165.796,
          "year": 2024
        },
        {
          "debtPct": 165.744,
          "year": 2025
        }
      ],
      "iso": "sgp",
      "name": "Singapore",
      "startingDebtPct": 165.744,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.963,
          3.036,
          2.516,
          2.526,
          2.52,
          2.5
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 32.1,
          "year": 2026
        },
        {
          "debtPct": 34.134,
          "year": 2027
        },
        {
          "debtPct": 34.846,
          "year": 2028
        },
        {
          "debtPct": 35.355,
          "year": 2029
        },
        {
          "debtPct": 35.746,
          "year": 2030
        },
        {
          "debtPct": 36.091,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.373,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.737,
        "realInterestRate": -0.38391335606036137
      },
      "historical": [
        {
          "debtPct": 16.559,
          "year": 2022
        },
        {
          "debtPct": 23.055,
          "year": 2023
        },
        {
          "debtPct": 26.586,
          "year": 2024
        },
        {
          "debtPct": 29.627,
          "year": 2025
        }
      ],
      "iso": "slb",
      "name": "Solomon Islands",
      "startingDebtPct": 29.627,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.373,
          -2.825,
          -2.307,
          -1.955,
          -1.918,
          -1.757
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.737,
          2.838,
          2.858,
          2.854,
          2.955,
          2.954
        ],
        "realInterestRate": [
          -0.38391335606036137,
          0.30389227414329145,
          -1.948307786957304,
          -1.4141192676347392,
          -1.4916775562155205,
          -1.1127780450959635
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 50.139,
          "year": 2026
        },
        {
          "debtPct": 45.419,
          "year": 2027
        },
        {
          "debtPct": 41.692,
          "year": 2028
        },
        {
          "debtPct": 38.797,
          "year": 2029
        },
        {
          "debtPct": 35.923,
          "year": 2030
        },
        {
          "debtPct": 33.77,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.523,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.007,
        "realInterestRate": 2.601500000000012
      },
      "historical": [
        {
          "debtPct": 53.959,
          "year": 2022
        },
        {
          "debtPct": 49.444,
          "year": 2023
        },
        {
          "debtPct": 46.961,
          "year": 2024
        },
        {
          "debtPct": 51.356,
          "year": 2025
        }
      ],
      "iso": "sle",
      "name": "Sierra Leone",
      "startingDebtPct": 51.356,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.523,
          1.933,
          1.985,
          1.428,
          1.48,
          1.18
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.007,
          4.443,
          4.628,
          4.569,
          4.594,
          4.599
        ],
        "realInterestRate": [
          2.601500000000012,
          -1.362513492490891,
          0.6150984389793113,
          0.8895717403818226,
          0.8358734438229876,
          1.7658617042006552
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 85.031,
          "year": 2026
        },
        {
          "debtPct": 89.185,
          "year": 2027
        },
        {
          "debtPct": 87.274,
          "year": 2028
        },
        {
          "debtPct": 85.044,
          "year": 2029
        },
        {
          "debtPct": 82.755,
          "year": 2030
        },
        {
          "debtPct": 80.25,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 2.856,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.5,
        "realInterestRate": 4.89984809027777
      },
      "historical": [
        {
          "debtPct": 83.657,
          "year": 2022
        },
        {
          "debtPct": 83.945,
          "year": 2023
        },
        {
          "debtPct": 87.725,
          "year": 2024
        },
        {
          "debtPct": 87.552,
          "year": 2025
        }
      ],
      "iso": "slv",
      "name": "El Salvador",
      "startingDebtPct": 87.552,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          2.856,
          3.65,
          3.74,
          3.74,
          3.74,
          3.74
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.5,
          4,
          3.3,
          3.3,
          3.3,
          3.3
        ],
        "realInterestRate": [
          4.89984809027777,
          13.544942432759832,
          5.418469473566168,
          5.087279143845791,
          5.062479422416621,
          4.841604736873895
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 56.817,
          "year": 2026
        },
        {
          "debtPct": 54.474,
          "year": 2027
        },
        {
          "debtPct": 51.916,
          "year": 2028
        },
        {
          "debtPct": 49.117,
          "year": 2029
        },
        {
          "debtPct": 46.343,
          "year": 2030
        },
        {
          "debtPct": 43.553,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.661,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.3,
        "realInterestRate": -0.9510358319260281
      },
      "historical": [
        {
          "debtPct": 71.643,
          "year": 2022
        },
        {
          "debtPct": 69.348,
          "year": 2023
        },
        {
          "debtPct": 63.819,
          "year": 2024
        },
        {
          "debtPct": 59.807,
          "year": 2025
        }
      ],
      "iso": "smr",
      "name": "San Marino, Republic of",
      "startingDebtPct": 59.807,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.661,
          1.425,
          2.128,
          2.146,
          2.164,
          2.196
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.3,
          1,
          1.15,
          1.28,
          1.28,
          1.28
        ],
        "realInterestRate": [
          -0.9510358319260281,
          -0.6318707429114667,
          0.351554870213322,
          0.006099083134292194,
          0.02217073518335777,
          -0.018153334915760322
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 42.937,
          "year": 2026
        },
        {
          "debtPct": 42.914,
          "year": 2027
        },
        {
          "debtPct": 42.766,
          "year": 2028
        },
        {
          "debtPct": 42.174,
          "year": 2029
        },
        {
          "debtPct": 41.565,
          "year": 2030
        },
        {
          "debtPct": 40.864,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.661,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.335,
        "realInterestRate": 1.0029946245470933
      },
      "historical": [
        {
          "debtPct": 50.897,
          "year": 2022
        },
        {
          "debtPct": 45.666,
          "year": 2023
        },
        {
          "debtPct": 44.064,
          "year": 2024
        },
        {
          "debtPct": 42.229,
          "year": 2025
        }
      ],
      "iso": "srb",
      "name": "Serbia, Republic of",
      "startingDebtPct": 42.229,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.661,
          -0.735,
          -0.532,
          -0.488,
          -0.009,
          -0.038
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.335,
          3.979,
          3.518,
          3.527,
          3.506,
          3.546
        ],
        "realInterestRate": [
          1.0029946245470933,
          2.143378461466816,
          1.8776905438784297,
          0.9125595566571443,
          1.98926675202733,
          1.7050161433898925
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -23.41% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 43.199,
          "year": 2026
        },
        {
          "debtPct": 42.998,
          "year": 2027
        },
        {
          "debtPct": 44.363,
          "year": 2028
        },
        {
          "debtPct": 45.444,
          "year": 2029
        },
        {
          "debtPct": 45.715,
          "year": 2030
        },
        {
          "debtPct": 46.274,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.32,
        "realFxAppreciation": 0,
        "realGdpGrowth": 10.489,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 42.147,
          "year": 2022
        },
        {
          "debtPct": 60.672,
          "year": 2023
        },
        {
          "debtPct": 53.666,
          "year": 2024
        },
        {
          "debtPct": 64.221,
          "year": 2025
        }
      ],
      "iso": "ssd",
      "name": "South Sudan, Republic of",
      "startingDebtPct": 64.221,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.32,
          1.393,
          1.302,
          1.23,
          1.47,
          1.603
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          10.489,
          3.866,
          3.486,
          3.316,
          3.622,
          2.912
        ],
        "realInterestRate": [
          null,
          6.731998564781594,
          9.90483720173032,
          8.698036291504184,
          7.591850849397042,
          7.7790183528382295
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 55.902,
          "year": 2026
        },
        {
          "debtPct": 54.209,
          "year": 2027
        },
        {
          "debtPct": 52.022,
          "year": 2028
        },
        {
          "debtPct": 49.648,
          "year": 2029
        },
        {
          "debtPct": 46.55,
          "year": 2030
        },
        {
          "debtPct": 43.624,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.476,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.4,
        "realInterestRate": -5.884445346457623
      },
      "historical": [
        {
          "debtPct": 86.762,
          "year": 2022
        },
        {
          "debtPct": 73.231,
          "year": 2023
        },
        {
          "debtPct": 69.004,
          "year": 2024
        },
        {
          "debtPct": 59.127,
          "year": 2025
        }
      ],
      "iso": "stp",
      "name": "São Tomé and Príncipe, Democratic Republic of",
      "startingDebtPct": 59.127,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.476,
          0.307,
          2.579,
          3.398,
          3.512,
          3.178
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.4,
          1.9,
          2.6,
          2.75,
          2.751,
          2.751
        ],
        "realInterestRate": [
          -5.884445346457623,
          -0.6264462809917437,
          3.3419284620634926,
          4.772528930068076,
          3.6078102239767817,
          3.3072460150375793
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 85.144,
          "year": 2026
        },
        {
          "debtPct": 72.082,
          "year": 2027
        },
        {
          "debtPct": 52.111,
          "year": 2028
        },
        {
          "debtPct": 35.392,
          "year": 2029
        },
        {
          "debtPct": 29.453,
          "year": 2030
        },
        {
          "debtPct": 27.842,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.076,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.97,
        "realInterestRate": -8.697017033137177
      },
      "historical": [
        {
          "debtPct": 111.682,
          "year": 2022
        },
        {
          "debtPct": 92.283,
          "year": 2023
        },
        {
          "debtPct": 83.953,
          "year": 2024
        },
        {
          "debtPct": 96.87,
          "year": 2025
        }
      ],
      "iso": "sur",
      "name": "Suriname",
      "startingDebtPct": 96.87,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.076,
          1.106,
          4.859,
          8.836,
          8.377,
          6.352
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.97,
          4.136,
          28.178,
          43.039,
          3.155,
          2.956
        ],
        "realInterestRate": [
          -8.697017033137177,
          -10.486874377525146,
          1.305466829444235,
          21.401026501122633,
          10.26089653028932,
          19.528654602247663
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 62.19,
          "year": 2026
        },
        {
          "debtPct": 64.585,
          "year": 2027
        },
        {
          "debtPct": 65.521,
          "year": 2028
        },
        {
          "debtPct": 67.345,
          "year": 2029
        },
        {
          "debtPct": 69.611,
          "year": 2030
        },
        {
          "debtPct": 72.128,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -3.343,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.82,
        "realInterestRate": -3.359484297628368
      },
      "historical": [
        {
          "debtPct": 57.756,
          "year": 2022
        },
        {
          "debtPct": 55.758,
          "year": 2023
        },
        {
          "debtPct": 59.701,
          "year": 2024
        },
        {
          "debtPct": 61.392,
          "year": 2025
        }
      ],
      "iso": "svk",
      "name": "Slovak Republic",
      "startingDebtPct": 61.392,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -3.343,
          -3.336,
          -3.405,
          -3.403,
          -3.447,
          -3.48
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.82,
          1.64,
          2.56,
          2.47,
          2.19,
          1.8
        ],
        "realInterestRate": [
          -3.359484297628368,
          0.10208007718282008,
          -1.3607345358829348,
          0.000560736252497307,
          0.39793837701389556,
          0.39169671459968747
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 63.499,
          "year": 2026
        },
        {
          "debtPct": 64.049,
          "year": 2027
        },
        {
          "debtPct": 64.791,
          "year": 2028
        },
        {
          "debtPct": 65.939,
          "year": 2029
        },
        {
          "debtPct": 66.99,
          "year": 2030
        },
        {
          "debtPct": 68.21,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.944,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.2,
        "realInterestRate": -2.401733038348075
      },
      "historical": [
        {
          "debtPct": 72.748,
          "year": 2022
        },
        {
          "debtPct": 68.215,
          "year": 2023
        },
        {
          "debtPct": 66.326,
          "year": 2024
        },
        {
          "debtPct": 65.088,
          "year": 2025
        }
      ],
      "iso": "svn",
      "name": "Slovenia, Republic of",
      "startingDebtPct": 65.088,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.944,
          -2.211,
          -2.305,
          -2.293,
          -2.264,
          -2.266
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.2,
          2.2,
          2.1,
          2.1,
          2.1,
          2.1
        ],
        "realInterestRate": [
          -2.401733038348075,
          -0.47333658797775735,
          -0.39156583240957943,
          0.2956676081554477,
          0.2217898360606041,
          0.5057829526794899
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 35.089,
          "year": 2026
        },
        {
          "debtPct": 35.504,
          "year": 2027
        },
        {
          "debtPct": 34.834,
          "year": 2028
        },
        {
          "debtPct": 33.561,
          "year": 2029
        },
        {
          "debtPct": 32.284,
          "year": 2030
        },
        {
          "debtPct": 30.715,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.362,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.5,
        "realInterestRate": -2.902700590482832
      },
      "historical": [
        {
          "debtPct": 34.407,
          "year": 2022
        },
        {
          "debtPct": 32.244,
          "year": 2023
        },
        {
          "debtPct": 33.862,
          "year": 2024
        },
        {
          "debtPct": 34.548,
          "year": 2025
        }
      ],
      "iso": "swe",
      "name": "Sweden",
      "startingDebtPct": 34.548,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.362,
          -1.886,
          -1.184,
          -0.312,
          -0.377,
          -0.094
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.5,
          2.2,
          2.068,
          1.867,
          1.782,
          1.795
        ],
        "realInterestRate": [
          -2.902700590482832,
          -2.084425318475891,
          -3.2619366831905916,
          -2.7681034908422886,
          -3.2341624504633404,
          -3.4486217631024774
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 52.475,
          "year": 2026
        },
        {
          "debtPct": 54.437,
          "year": 2027
        },
        {
          "debtPct": 54.301,
          "year": 2028
        },
        {
          "debtPct": 53.728,
          "year": 2029
        },
        {
          "debtPct": 51.286,
          "year": 2030
        },
        {
          "debtPct": 47.955,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.995,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.722,
        "realInterestRate": 16.778627888304065
      },
      "historical": [
        {
          "debtPct": 39.456,
          "year": 2022
        },
        {
          "debtPct": 39.448,
          "year": 2023
        },
        {
          "debtPct": 40.014,
          "year": 2024
        },
        {
          "debtPct": 44.836,
          "year": 2025
        }
      ],
      "iso": "swz",
      "name": "Eswatini, Kingdom of",
      "startingDebtPct": 44.836,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.995,
          -0.598,
          1.088,
          2.213,
          3.525,
          3.835
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.722,
          3.416,
          3.43,
          3.329,
          3.304,
          3.276
        ],
        "realInterestRate": [
          16.778627888304065,
          6.10412623153882,
          5.238794753568365,
          6.4497447376659744,
          5.386307772483612,
          4.290918379284769
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 52.747,
          "year": 2026
        },
        {
          "debtPct": 51.98,
          "year": 2027
        },
        {
          "debtPct": 51.043,
          "year": 2028
        },
        {
          "debtPct": 49.965,
          "year": 2029
        },
        {
          "debtPct": 48.81,
          "year": 2030
        },
        {
          "debtPct": 47.705,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.502,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.02,
        "realInterestRate": 5.052514012303488
      },
      "historical": [
        {
          "debtPct": 60.563,
          "year": 2022
        },
        {
          "debtPct": 55.106,
          "year": 2023
        },
        {
          "debtPct": 56.252,
          "year": 2024
        },
        {
          "debtPct": 51.205,
          "year": 2025
        }
      ],
      "iso": "syc",
      "name": "Seychelles",
      "startingDebtPct": 51.205,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.502,
          0.13,
          0.272,
          0.269,
          0.318,
          0.285
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.02,
          4.027,
          3.141,
          3.101,
          3.164,
          3.197
        ],
        "realInterestRate": [
          5.052514012303488,
          2.7707162492653703,
          1.821477779915348,
          1.4669128773779017,
          1.4358249174422077,
          1.4633073140749797
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 31.088,
          "year": 2026
        },
        {
          "debtPct": 29.631,
          "year": 2027
        },
        {
          "debtPct": 28.567,
          "year": 2028
        },
        {
          "debtPct": 27.262,
          "year": 2029
        },
        {
          "debtPct": 25.898,
          "year": 2030
        },
        {
          "debtPct": 24.796,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.005,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.468,
        "realInterestRate": 0.6240140460398225
      },
      "historical": [
        {
          "debtPct": 32.084,
          "year": 2022
        },
        {
          "debtPct": 32.221,
          "year": 2023
        },
        {
          "debtPct": 31.44,
          "year": 2024
        },
        {
          "debtPct": 33.319,
          "year": 2025
        }
      ],
      "iso": "tcd",
      "name": "Chad",
      "startingDebtPct": 33.319,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.005,
          2.294,
          0.968,
          0.583,
          0.466,
          0.252
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.468,
          5.434,
          4.625,
          5.14,
          5.404,
          5.316
        ],
        "realInterestRate": [
          0.6240140460398225,
          8.272659868759646,
          4.286030677331176,
          2.482700318549358,
          1.932031985914473,
          1.8594164800370683
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 64.659,
          "year": 2026
        },
        {
          "debtPct": 63.019,
          "year": 2027
        },
        {
          "debtPct": 61.55,
          "year": 2028
        },
        {
          "debtPct": 60.173,
          "year": 2029
        },
        {
          "debtPct": 58.875,
          "year": 2030
        },
        {
          "debtPct": 57.637,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.9,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5,
        "realInterestRate": 3.219213987264724
      },
      "historical": [
        {
          "debtPct": 62.976,
          "year": 2022
        },
        {
          "debtPct": 64.012,
          "year": 2023
        },
        {
          "debtPct": 66.169,
          "year": 2024
        },
        {
          "debtPct": 64.859,
          "year": 2025
        }
      ],
      "iso": "tgo",
      "name": "Togo",
      "startingDebtPct": 64.859,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.9,
          -0.521,
          -1.084,
          -1.1,
          -1.1,
          -1.1
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5,
          5.3,
          5.5,
          5.5,
          5.5,
          5.5
        ],
        "realInterestRate": [
          3.219213987264724,
          1.780717301535728,
          1.2260270712007415,
          1.254289195775793,
          1.2956392401907824,
          1.310462845010596
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 67.199,
          "year": 2026
        },
        {
          "debtPct": 68.524,
          "year": 2027
        },
        {
          "debtPct": 69.068,
          "year": 2028
        },
        {
          "debtPct": 69.416,
          "year": 2029
        },
        {
          "debtPct": 69.641,
          "year": 2030
        },
        {
          "debtPct": 69.749,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.018,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.1,
        "realInterestRate": 2.8828955708432913
      },
      "historical": [
        {
          "debtPct": 60.548,
          "year": 2022
        },
        {
          "debtPct": 62.236,
          "year": 2023
        },
        {
          "debtPct": 62.913,
          "year": 2024
        },
        {
          "debtPct": 64.685,
          "year": 2025
        }
      ],
      "iso": "tha",
      "name": "Thailand",
      "startingDebtPct": 64.685,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.018,
          -1.572,
          -0.766,
          -0.793,
          -0.845,
          -0.89
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.1,
          2.1,
          2.295,
          2.466,
          2.503,
          2.503
        ],
        "realInterestRate": [
          2.8828955708432913,
          1.7247161416092505,
          1.9635907127429908,
          1.8058191637226884,
          1.5874782182782265,
          1.3519920305567146
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 18.255,
          "year": 2026
        },
        {
          "debtPct": 18.661,
          "year": 2027
        },
        {
          "debtPct": 19.719,
          "year": 2028
        },
        {
          "debtPct": 20.7,
          "year": 2029
        },
        {
          "debtPct": 21.51,
          "year": 2030
        },
        {
          "debtPct": 22.182,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.877,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7.3,
        "realInterestRate": -5.528470056983126
      },
      "historical": [
        {
          "debtPct": 31.793,
          "year": 2022
        },
        {
          "debtPct": 29.947,
          "year": 2023
        },
        {
          "debtPct": 24.906,
          "year": 2024
        },
        {
          "debtPct": 18.602,
          "year": 2025
        }
      ],
      "iso": "tjk",
      "name": "Tajikistan, Republic of",
      "startingDebtPct": 18.602,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.877,
          -1.851,
          -1.771,
          -1.671,
          -1.61,
          -1.555
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7.3,
          6.8,
          6.2,
          6,
          5.5,
          5.5
        ],
        "realInterestRate": [
          -5.528470056983126,
          -1.6539030402629162,
          2.142307486201167,
          2.2908869618134764,
          1.4227053140096757,
          1.1691538819153635
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 2.936,
          "year": 2026
        },
        {
          "debtPct": 2.803,
          "year": 2027
        },
        {
          "debtPct": 2.677,
          "year": 2028
        },
        {
          "debtPct": 2.557,
          "year": 2029
        },
        {
          "debtPct": 2.493,
          "year": 2030
        },
        {
          "debtPct": 2.48,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.37,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 7.138,
          "year": 2022
        },
        {
          "debtPct": 5.459,
          "year": 2023
        },
        {
          "debtPct": 4.112,
          "year": 2024
        },
        {
          "debtPct": 3.074,
          "year": 2025
        }
      ],
      "iso": "tkm",
      "name": "Turkmenistan",
      "startingDebtPct": 3.074,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.37,
          2.494,
          2.536,
          2.574,
          2.575,
          2.645
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -426.62% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 13.903,
          "year": 2026
        },
        {
          "debtPct": 13.897,
          "year": 2027
        },
        {
          "debtPct": 13.828,
          "year": 2028
        },
        {
          "debtPct": 13.839,
          "year": 2029
        },
        {
          "debtPct": 13.91,
          "year": 2030
        },
        {
          "debtPct": 15.268,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -55.519,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 7.625,
          "year": 2022
        },
        {
          "debtPct": 12.17,
          "year": 2023
        },
        {
          "debtPct": 13.579,
          "year": 2024
        },
        {
          "debtPct": 13.251,
          "year": 2025
        }
      ],
      "iso": "tls",
      "name": "Timor-Leste, Democratic Republic of",
      "startingDebtPct": 13.251,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -55.519,
          -53.67,
          -52.177,
          -50.782,
          -51.045,
          -51.442
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4,
          3.7,
          3.65,
          3.45,
          3.3,
          3.2
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 23.982,
          "year": 2026
        },
        {
          "debtPct": 28.387,
          "year": 2027
        },
        {
          "debtPct": 35.317,
          "year": 2028
        },
        {
          "debtPct": 44.23,
          "year": 2029
        },
        {
          "debtPct": 53.967,
          "year": 2030
        },
        {
          "debtPct": 64.953,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 4.461,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.825,
        "realInterestRate": 7.549796687585886
      },
      "historical": [
        {
          "debtPct": 40.076,
          "year": 2022
        },
        {
          "debtPct": 36.886,
          "year": 2023
        },
        {
          "debtPct": 31.722,
          "year": 2024
        },
        {
          "debtPct": 26.929,
          "year": 2025
        }
      ],
      "iso": "ton",
      "name": "Tonga",
      "startingDebtPct": 26.929,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          4.461,
          -5.252,
          -7.643,
          -9.733,
          -10.707,
          -12.143
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.825,
          1.897,
          1.662,
          1.568,
          1.538,
          1.549
        ],
        "realInterestRate": [
          7.549796687585886,
          -1.7018140688849992,
          -0.8914577799696954,
          -0.7902342781096916,
          -0.6888112141080649,
          -0.628111809068499
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 84.61,
          "year": 2026
        },
        {
          "debtPct": 83.139,
          "year": 2027
        },
        {
          "debtPct": 81.631,
          "year": 2028
        },
        {
          "debtPct": 80.44,
          "year": 2029
        },
        {
          "debtPct": 80.037,
          "year": 2030
        },
        {
          "debtPct": 80.478,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.379,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.211,
        "realInterestRate": 0.529664391882223
      },
      "historical": [
        {
          "debtPct": 69.953,
          "year": 2022
        },
        {
          "debtPct": 77.947,
          "year": 2023
        },
        {
          "debtPct": 80.981,
          "year": 2024
        },
        {
          "debtPct": 83.964,
          "year": 2025
        }
      ],
      "iso": "tto",
      "name": "Trinidad and Tobago",
      "startingDebtPct": 83.964,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.379,
          1.021,
          2.362,
          1.84,
          1.757,
          1.506
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.211,
          2.231,
          3.127,
          2.771,
          1.954,
          1.863
        ],
        "realInterestRate": [
          0.529664391882223,
          1.6872823543316429,
          4.18631582049338,
          3.5880716884516772,
          3.670132720039776,
          4.340944713070183
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 86.119,
          "year": 2026
        },
        {
          "debtPct": 89.825,
          "year": 2027
        },
        {
          "debtPct": 90.863,
          "year": 2028
        },
        {
          "debtPct": 90.781,
          "year": 2029
        },
        {
          "debtPct": 89.656,
          "year": 2030
        },
        {
          "debtPct": 88.666,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -4.6,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.433,
        "realInterestRate": 2.157302230269509
      },
      "historical": [
        {
          "debtPct": 82.985,
          "year": 2022
        },
        {
          "debtPct": 83.982,
          "year": 2023
        },
        {
          "debtPct": 85.61,
          "year": 2024
        },
        {
          "debtPct": 81.739,
          "year": 2025
        }
      ],
      "iso": "tun",
      "name": "Tunisia",
      "startingDebtPct": 81.739,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -4.6,
          -2.986,
          -2.295,
          -2.129,
          -2.058,
          -2.132
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.433,
          2.038,
          1.505,
          1.494,
          1.493,
          1.486
        ],
        "realInterestRate": [
          2.157302230269509,
          2.8910911877750634,
          0.08455151683830486,
          -0.9756877056667834,
          -2.0655884601403107,
          -2.047944097439114
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 22.45,
          "year": 2026
        },
        {
          "debtPct": 22.645,
          "year": 2027
        },
        {
          "debtPct": 23.15,
          "year": 2028
        },
        {
          "debtPct": 24.138,
          "year": 2029
        },
        {
          "debtPct": 25.057,
          "year": 2030
        },
        {
          "debtPct": 25.354,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.417,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.65,
        "realInterestRate": -4.429011197971688
      },
      "historical": [
        {
          "debtPct": 29.433,
          "year": 2022
        },
        {
          "debtPct": 28.251,
          "year": 2023
        },
        {
          "debtPct": 23.56,
          "year": 2024
        },
        {
          "debtPct": 23.665,
          "year": 2025
        }
      ],
      "iso": "tur",
      "name": "Türkiye, Republic of",
      "startingDebtPct": 23.665,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.417,
          -0.844,
          -0.616,
          -0.381,
          -0.178,
          -0.186
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.65,
          3.578,
          3.983,
          4.02,
          4.025,
          4.009
        ],
        "realInterestRate": [
          -4.429011197971688,
          0.5836961247215999,
          3.473301920953853,
          6.747435853131756,
          7.218409768829215,
          4.469749451251137
        ]
      }
    },
    {
      "_caveats": [
        "r computed as -614.16% (outlier; set to null)"
      ],
      "baselineProjection": [
        {
          "debtPct": 2.513,
          "year": 2026
        },
        {
          "debtPct": 2.794,
          "year": 2027
        },
        {
          "debtPct": 2.734,
          "year": 2028
        },
        {
          "debtPct": 2.731,
          "year": 2029
        },
        {
          "debtPct": 2.776,
          "year": 2030
        },
        {
          "debtPct": 2.863,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -16.55,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.403,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 6.046,
          "year": 2022
        },
        {
          "debtPct": 5.798,
          "year": 2023
        },
        {
          "debtPct": 6.116,
          "year": 2024
        },
        {
          "debtPct": 2.823,
          "year": 2025
        }
      ],
      "iso": "tuv",
      "name": "Tuvalu",
      "startingDebtPct": 2.823,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -16.55,
          -20.39,
          -8.737,
          -9.582,
          -10.337,
          -11.002
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.403,
          2.812,
          2.337,
          2.038,
          1.833,
          1.618
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 21.06,
          "year": 2026
        },
        {
          "debtPct": 19.996,
          "year": 2027
        },
        {
          "debtPct": 19.204,
          "year": 2028
        },
        {
          "debtPct": 18.562,
          "year": 2029
        },
        {
          "debtPct": 17.899,
          "year": 2030
        },
        {
          "debtPct": 17.402,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 10.721,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 29.482,
          "year": 2022
        },
        {
          "debtPct": 29.02,
          "year": 2023
        },
        {
          "debtPct": 26.782,
          "year": 2024
        },
        {
          "debtPct": 23.568,
          "year": 2025
        }
      ],
      "iso": "twn",
      "name": "Taiwan Province of China",
      "startingDebtPct": 23.568,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          10.721,
          4.302,
          3.244,
          2.612,
          2.717,
          1.927
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 48.132,
          "year": 2026
        },
        {
          "debtPct": 46.634,
          "year": 2027
        },
        {
          "debtPct": 45.197,
          "year": 2028
        },
        {
          "debtPct": 43.938,
          "year": 2029
        },
        {
          "debtPct": 42.857,
          "year": 2030
        },
        {
          "debtPct": 41.405,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.176,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6.029,
        "realInterestRate": 2.0660549199084555
      },
      "historical": [
        {
          "debtPct": 44.854,
          "year": 2022
        },
        {
          "debtPct": 47.804,
          "year": 2023
        },
        {
          "debtPct": 49.955,
          "year": 2024
        },
        {
          "debtPct": 49.818,
          "year": 2025
        }
      ],
      "iso": "tza",
      "name": "Tanzania, United Republic of",
      "startingDebtPct": 49.818,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.176,
          -0.328,
          -0.367,
          -0.465,
          -0.518,
          -0.515
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6.029,
          5.918,
          6.011,
          5.985,
          5.866,
          5.994
        ],
        "realInterestRate": [
          2.0660549199084555,
          1.8997529294440207,
          1.9100469614444782,
          1.9422949532048595,
          2.0133045200054323,
          1.1292124973749873
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 55.077,
          "year": 2026
        },
        {
          "debtPct": 54.859,
          "year": 2027
        },
        {
          "debtPct": 55.102,
          "year": 2028
        },
        {
          "debtPct": 56.019,
          "year": 2029
        },
        {
          "debtPct": 56.795,
          "year": 2030
        },
        {
          "debtPct": 57.213,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -1.35,
        "realFxAppreciation": 0,
        "realGdpGrowth": 6.164,
        "realInterestRate": 7.19551264799847
      },
      "historical": [
        {
          "debtPct": 49.894,
          "year": 2022
        },
        {
          "debtPct": 50.356,
          "year": 2023
        },
        {
          "debtPct": 51.753,
          "year": 2024
        },
        {
          "debtPct": 53.21,
          "year": 2025
        }
      ],
      "iso": "uga",
      "name": "Uganda",
      "startingDebtPct": 53.21,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -1.35,
          -0.915,
          -0.597,
          -1.019,
          0.034,
          0.23
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          6.164,
          9.86,
          7.088,
          6.283,
          6.028,
          5.738
        ],
        "realInterestRate": [
          7.19551264799847,
          7.600047932893972,
          6.396971144206054,
          6.086258212043116,
          7.561099127081872,
          6.944412958887214
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 111.825,
          "year": 2026
        },
        {
          "debtPct": 110.294,
          "year": 2027
        },
        {
          "debtPct": 109.634,
          "year": 2028
        },
        {
          "debtPct": 107.251,
          "year": 2029
        },
        {
          "debtPct": 102.116,
          "year": 2030
        },
        {
          "debtPct": 97.174,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -6.262,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1,
        "realInterestRate": -0.46711601116514734
      },
      "historical": [
        {
          "debtPct": 77.717,
          "year": 2022
        },
        {
          "debtPct": 81.209,
          "year": 2023
        },
        {
          "debtPct": 89.677,
          "year": 2024
        },
        {
          "debtPct": 107.119,
          "year": 2025
        }
      ],
      "iso": "ukr",
      "name": "Ukraine",
      "startingDebtPct": 107.119,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -6.262,
          0.614,
          -3.51,
          0.738,
          1.675,
          1.919
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1,
          3.5,
          4.2,
          3.9,
          3.7,
          3.6
        ],
        "realInterestRate": [
          -0.46711601116514734,
          2.651267605633789,
          0.26040219776235496,
          2.3410356276337696,
          0.3545579994592041,
          0.5330682752947791
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 67.737,
          "year": 2026
        },
        {
          "debtPct": 68.7,
          "year": 2027
        },
        {
          "debtPct": 69.742,
          "year": 2028
        },
        {
          "debtPct": 69.758,
          "year": 2029
        },
        {
          "debtPct": 69.536,
          "year": 2030
        },
        {
          "debtPct": 69.182,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -2.088,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.3,
        "realInterestRate": 1.3617598195369673
      },
      "historical": [
        {
          "debtPct": 59.39,
          "year": 2022
        },
        {
          "debtPct": 63.019,
          "year": 2023
        },
        {
          "debtPct": 67.605,
          "year": 2024
        },
        {
          "debtPct": 65.609,
          "year": 2025
        }
      ],
      "iso": "ury",
      "name": "Uruguay",
      "startingDebtPct": 65.609,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -2.088,
          -1.228,
          -0.627,
          0.134,
          0.297,
          0.402
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.3,
          2.401,
          2.2,
          2.2,
          2.2,
          2.2
        ],
        "realInterestRate": [
          1.3617598195369673,
          2.0003878530197916,
          2.817365356623025,
          2.4198101574374187,
          2.3098798704091372,
          2.2705476300046046
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 126.79,
          "year": 2026
        },
        {
          "debtPct": 128.659,
          "year": 2027
        },
        {
          "debtPct": 132.302,
          "year": 2028
        },
        {
          "debtPct": 136.414,
          "year": 2029
        },
        {
          "debtPct": 140.723,
          "year": 2030
        },
        {
          "debtPct": 145.033,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -4.924,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.328,
        "realInterestRate": 0.2621388841988592
      },
      "historical": [
        {
          "debtPct": 119.175,
          "year": 2022
        },
        {
          "debtPct": 120.048,
          "year": 2023
        },
        {
          "debtPct": 122.334,
          "year": 2024
        },
        {
          "debtPct": 124.377,
          "year": 2025
        }
      ],
      "iso": "usa",
      "name": "United States",
      "startingDebtPct": 124.377,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -4.924,
          -3.958,
          -3.904,
          -3.689,
          -3.559,
          -3.376
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.328,
          2.293,
          2.056,
          1.881,
          1.753,
          1.755
        ],
        "realInterestRate": [
          0.2621388841988592,
          0.6076141099455645,
          1.8489673322503508,
          2.206737048570684,
          2.3124348820502627,
          2.430363444497319
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 27.574,
          "year": 2026
        },
        {
          "debtPct": 26.43,
          "year": 2027
        },
        {
          "debtPct": 25.601,
          "year": 2028
        },
        {
          "debtPct": 25.043,
          "year": 2029
        },
        {
          "debtPct": 25.044,
          "year": 2030
        },
        {
          "debtPct": 25.045,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.415,
        "realFxAppreciation": 0,
        "realGdpGrowth": 7.817,
        "realInterestRate": 2.4384083610285323
      },
      "historical": [
        {
          "debtPct": 29.172,
          "year": 2022
        },
        {
          "debtPct": 30.719,
          "year": 2023
        },
        {
          "debtPct": 30.936,
          "year": 2024
        },
        {
          "debtPct": 28.585,
          "year": 2025
        }
      ],
      "iso": "uzb",
      "name": "Uzbekistan, Republic of",
      "startingDebtPct": 28.585,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.415,
          -0.702,
          -1.208,
          -1.316,
          -1.339,
          -1.242
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          7.817,
          6.526,
          6.007,
          5.824,
          5.711,
          5.7
        ],
        "realInterestRate": [
          2.4384083610285323,
          -0.6056093421338837,
          -2.163119523268997,
          -1.9223449084020072,
          0.06306173381784852,
          0.4622704040887937
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 111.64,
          "year": 2026
        },
        {
          "debtPct": 117.088,
          "year": 2027
        },
        {
          "debtPct": 121.753,
          "year": 2028
        },
        {
          "debtPct": 125.528,
          "year": 2029
        },
        {
          "debtPct": 129.427,
          "year": 2030
        },
        {
          "debtPct": 133.511,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -5.656,
        "realFxAppreciation": 0,
        "realGdpGrowth": 2.3,
        "realInterestRate": 0.6317297964563151
      },
      "historical": [
        {
          "debtPct": 88.58,
          "year": 2022
        },
        {
          "debtPct": 91.262,
          "year": 2023
        },
        {
          "debtPct": 102.838,
          "year": 2024
        },
        {
          "debtPct": 107.741,
          "year": 2025
        }
      ],
      "iso": "vct",
      "name": "St. Vincent and the Grenadines",
      "startingDebtPct": 107.741,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -5.656,
          -7.103,
          -5.803,
          -4.803,
          -4.803,
          -4.803
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          2.3,
          2.4,
          2.7,
          2.7,
          2.7,
          2.7
        ],
        "realInterestRate": [
          0.6317297964563151,
          0.8819777857398847,
          1.7018396419786752,
          1.832870647951168,
          1.960397680198822,
          2.1294753026802615
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 28.277,
          "year": 2026
        },
        {
          "debtPct": 26.208,
          "year": 2027
        },
        {
          "debtPct": 25.256,
          "year": 2028
        },
        {
          "debtPct": 24.554,
          "year": 2029
        },
        {
          "debtPct": 24.347,
          "year": 2030
        },
        {
          "debtPct": 24.465,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": -0.054,
        "realFxAppreciation": 0,
        "realGdpGrowth": 8.4,
        "realInterestRate": 0.36325820949383303
      },
      "historical": [
        {
          "debtPct": 34.923,
          "year": 2022
        },
        {
          "debtPct": 34.277,
          "year": 2023
        },
        {
          "debtPct": 31.166,
          "year": 2024
        },
        {
          "debtPct": 30.483,
          "year": 2025
        }
      ],
      "iso": "vnm",
      "name": "Vietnam",
      "startingDebtPct": 30.483,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          -0.054,
          -0.187,
          -0.782,
          -0.9,
          -1.175,
          -1.376
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          8.4,
          7.5,
          5.9,
          5.9,
          5.7,
          5.7
        ],
        "realInterestRate": [
          0.36325820949383303,
          -1.076581674152155,
          -1.1066620879120803,
          -0.8172869813113826,
          -0.2492302679807712,
          0.23852219986033596
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 36.603,
          "year": 2026
        },
        {
          "debtPct": 37.544,
          "year": 2027
        },
        {
          "debtPct": 39.098,
          "year": 2028
        },
        {
          "debtPct": 40.793,
          "year": 2029
        },
        {
          "debtPct": 42.37,
          "year": 2030
        },
        {
          "debtPct": 43.895,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.93,
        "realFxAppreciation": 0,
        "realGdpGrowth": 3.526,
        "realInterestRate": 7.465811820670987
      },
      "historical": [
        {
          "debtPct": 39.156,
          "year": 2022
        },
        {
          "debtPct": 39.239,
          "year": 2023
        },
        {
          "debtPct": 39.053,
          "year": 2024
        },
        {
          "debtPct": 36.157,
          "year": 2025
        }
      ],
      "iso": "vut",
      "name": "Vanuatu",
      "startingDebtPct": 36.157,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.93,
          -1.902,
          -1.643,
          -1.545,
          -1.373,
          -1.288
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          3.526,
          3.15,
          2.793,
          2.542,
          2.525,
          2.451
        ],
        "realInterestRate": [
          7.465811820670987,
          0.44182990465260197,
          2.54932386000426,
          2.9354037546677425,
          3.03771296545976,
          3.024067901817351
        ]
      }
    },
    {
      "baselineProjection": [],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": null,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 47.121,
          "year": 2022
        },
        {
          "debtPct": 46.455,
          "year": 2023
        },
        {
          "debtPct": 56.133,
          "year": 2024
        },
        {
          "debtPct": 55.88,
          "year": 2025
        }
      ],
      "iso": "wbg",
      "name": "West Bank and Gaza",
      "startingDebtPct": 55.88,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 18.649,
          "year": 2026
        },
        {
          "debtPct": 19.278,
          "year": 2027
        },
        {
          "debtPct": 20.558,
          "year": 2028
        },
        {
          "debtPct": 22.249,
          "year": 2029
        },
        {
          "debtPct": 23.518,
          "year": 2030
        },
        {
          "debtPct": 24.235,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": null,
        "realFxAppreciation": 0,
        "realGdpGrowth": 0.415,
        "realInterestRate": null
      },
      "historical": [
        {
          "debtPct": 40.966,
          "year": 2022
        },
        {
          "debtPct": 31.808,
          "year": 2023
        },
        {
          "debtPct": 25.263,
          "year": 2024
        },
        {
          "debtPct": 21.214,
          "year": 2025
        }
      ],
      "iso": "wsm",
      "name": "Samoa",
      "startingDebtPct": 21.214,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          null,
          null,
          null,
          null,
          null,
          null
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          0.415,
          1.659,
          2.222,
          2.454,
          2.454,
          2.454
        ],
        "realInterestRate": [
          null,
          null,
          null,
          null,
          null,
          null
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 78.044,
          "year": 2026
        },
        {
          "debtPct": 78.126,
          "year": 2027
        },
        {
          "debtPct": 78.836,
          "year": 2028
        },
        {
          "debtPct": 79.496,
          "year": 2029
        },
        {
          "debtPct": 79.711,
          "year": 2030
        },
        {
          "debtPct": 79.772,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 1.048,
        "realFxAppreciation": 0,
        "realGdpGrowth": 1.04,
        "realInterestRate": 1.8850487021265572
      },
      "historical": [
        {
          "debtPct": 70.715,
          "year": 2022
        },
        {
          "debtPct": 73.22,
          "year": 2023
        },
        {
          "debtPct": 75.963,
          "year": 2024
        },
        {
          "debtPct": 78.436,
          "year": 2025
        }
      ],
      "iso": "zaf",
      "name": "South Africa",
      "startingDebtPct": 78.436,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          1.048,
          1.458,
          1.324,
          1.46,
          1.581,
          1.696
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          1.04,
          1.325,
          1.493,
          1.685,
          1.841,
          1.793
        ],
        "realInterestRate": [
          1.8850487021265572,
          3.324391368971358,
          4.135356731433837,
          4.419438581358759,
          4.141825651605124,
          4.0367342524871175
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 82.069,
          "year": 2026
        },
        {
          "debtPct": 77.042,
          "year": 2027
        },
        {
          "debtPct": 72.245,
          "year": 2028
        },
        {
          "debtPct": 67.217,
          "year": 2029
        },
        {
          "debtPct": 61.891,
          "year": 2030
        },
        {
          "debtPct": 56.658,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 0.824,
        "realFxAppreciation": 0,
        "realGdpGrowth": 5.596,
        "realInterestRate": -12.974794416495982
      },
      "historical": [
        {
          "debtPct": 99.476,
          "year": 2022
        },
        {
          "debtPct": 136.803,
          "year": 2023
        },
        {
          "debtPct": 125.506,
          "year": 2024
        },
        {
          "debtPct": 100.582,
          "year": 2025
        }
      ],
      "iso": "zmb",
      "name": "Zambia",
      "startingDebtPct": 100.582,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          0.824,
          1.825,
          2.515,
          3.028,
          3.021,
          2.958
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          5.596,
          4.931,
          5.024,
          5.27,
          5.298,
          5.278
        ],
        "realInterestRate": [
          -12.974794416495982,
          0.8370173512532109,
          1.9131673632564183,
          2.355749878884339,
          1.687129386911046,
          1.4081732077361853
        ]
      }
    },
    {
      "baselineProjection": [
        {
          "debtPct": 33.528,
          "year": 2026
        },
        {
          "debtPct": 30.606,
          "year": 2027
        },
        {
          "debtPct": 30.221,
          "year": 2028
        },
        {
          "debtPct": 28.149,
          "year": 2029
        },
        {
          "debtPct": 26.697,
          "year": 2030
        },
        {
          "debtPct": 25.683,
          "year": 2031
        }
      ],
      "baselineYear": 2026,
      "defaults": {
        "fcuShare": 0,
        "primaryBalance": 2.806,
        "realFxAppreciation": 0,
        "realGdpGrowth": 4.982,
        "realInterestRate": 0.4745545253397987
      },
      "historical": [
        {
          "debtPct": 66.79,
          "year": 2022
        },
        {
          "debtPct": 76.128,
          "year": 2023
        },
        {
          "debtPct": 70.412,
          "year": 2024
        },
        {
          "debtPct": 37.964,
          "year": 2025
        }
      ],
      "iso": "zwe",
      "name": "Zimbabwe",
      "startingDebtPct": 37.964,
      "yearlyDefaults": {
        "fcuShare": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "primaryBalance": [
          2.806,
          1.79,
          1.458,
          1.637,
          1.438,
          1.015
        ],
        "realFxAppreciation": [
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "realGdpGrowth": [
          4.982,
          3.5,
          4.968,
          4.202,
          4.2,
          4.209
        ],
        "realInterestRate": [
          0.4745545253397987,
          0.005547602004307706,
          8.648019081225877,
          2.7021201151517182,
          4.1481757788908835,
          4.21290339738547
        ]
      }
    }
  ]
}
